import React, { useEffect, useState, useRef, useMemo } from "react";
import { 
  FaRegStickyNote, FaEdit, FaRegClock, FaTrash, FaDownload, 
  FaFilter, FaSyncAlt, FaCheckCircle, FaInfoCircle, 
  FaUpload, FaPlug, FaArrowLeft, FaFlag
} from "react-icons/fa";
import { fetchJournalRows, deleteJournalRow, clearJournalRows, updateJournalRow, getSettings, updateSettings } from "../services/FirestoreService";
import PreTradeChecklistModal from "../components/PreTradeChecklistModal";
import { getTodayPreTradeChecklist } from "../services/FirestoreService";
import { doc, onSnapshot } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../firebase";
import { copyTradeToFollowers,deleteLeaderTradeFromFollowers } from "../services/CopyTradeService";
import { FOREX_PAIRS, FUTURES_PRODUCTS, futuresCodeOf } from "../constants/instruments";
import {  addDoc, collection, getDoc, getDocs, updateDoc, deleteDoc, deleteField, setDoc } from "firebase/firestore";
import { functions } from "../firebase";
import { useLocation } from "react-router-dom";
import {
   tlConnect      as tlConnectCallable,
   tlListAccounts as tlListAccountsCallable,
   tlUseAccount   as tlUseAccountCallable,
   tlSyncNow      as tlSyncNowCallable,
   wbConnect      as wbConnectCallable,
   wbListAccounts as wbListAccountsCallable,
   tvConnect      as tvConnectCallable,
   tvListAccounts as tvListAccountsCallable,
   tvUseAccount   as tvUseAccountCallable,
   tvSyncNow      as tvSyncNowCallable,
   oandaConnect   as oandaConnectCallable,
   syncTradesCallable as syncTradesCallable
 } from "../services/svc.js";
import { getFunctions, httpsCallable as fbCallable } from "firebase/functions";
import { fbCallableDebug } from "../firebase";
import tllogo from "../assets/tradelocker.png";
import tradovateLogo from "../assets/tradovateT.png";
import Papa from "papaparse";
import JournalCsvImport from "../components/JournalCsvImport";
import html2canvas from 'html2canvas';
import { httpsCallable } from "firebase/functions";
import oandaLogo from "../assets/oanda.png"; 
import ninjatraderLogo from "../assets/ninjatrader.png"; 
import robinhoodLogo from "../assets/robinhood.png"; 
import webullLogo from "../assets/webull.png"; 
import schwabLogo from "../assets/schwab.png"; 
import { FaLink } from "react-icons/fa"; // Add FaLink for the connect button
// Fields shown in the main journal table

function getProductSymbol(productStr = "") {
  if (!productStr) return "";
  const firstPart = String(productStr).split(" - ")[0];
  return firstPart.split("·")[0].trim().toUpperCase();
}

const DISPLAY_FIELDS = [
  "Trade #", "Product", "Position", "Size", "% Growth",
  "Result", "Funding",    
  "Reward", "Balance", "Date", "Entry", "Exit", "Duration",
  "Link", "Details", "Edit", "Delete", "Download"
];
 

const PRODUCT_OPTIONS = [
    ["YM - Dow - $5.00", "YM - US30 - $5.00"], ["MYM - Dow Micro - $0.50", "MYM - US30 Micro - $0.50"],
    ["ES - S&P 500 - $12.50", "ES - S&P 500 - $12.50"], ["MES - S&P 500 Micro - $1.25", "MES - S&P 500 Micro - $1.25"],
    ["NQ - NAS - $5.00", "NQ - NAS - $5.00"], ["MNQ - NAS Micro - $0.50", "MNQ - NAS Micro - $0.50"],
    ["GC - Gold - $10.00", "GC - Gold - $10.00"], ["MGC - Gold Micro - $1.00", "MGC - Gold Micro - $1.00"],
    ["NG - Natural Gas - $10.00", "NG - Natural Gas - $10.00"], ["MNG - Natural Gas Micro - $1.00", "MNG - Natural Gas Micro - $1.00"],
    ["CL - Oil - $10.00", "CL - Oil - $10.00"], ["MCL - Oil Micro - $1.00", "MCL - Oil Micro - $1.00"],
    ["RT - Russell - $5.00", "RT - Russell - $5.00"], ["M2K - Russell Micro - $0.50", "M2K - Russell Micro - $0.50"],
    ["SI - Silver - $25.00", "SI - Silver - $25.00"], ["SIL - Silver Micro - $5.00", "SIL - Silver Micro - $5.00"],
    ["HG - Copper - $25.00", "HG - Copper - $12.50"], ["MHG - Copper Micro - $5.00", "MHG - Copper Micro - $1.25"],
    ["6E - Euro FX Futures - $6.25", "6E - Euro FX Futures - $6.25"], ["M6E - Euro FX Micro - $1.25", "M6E - Euro FX Micro - $1.25"],
    ["6B - British Pound - $6.25", "6B - British Pound - $6.25"], ["M6B - Micro British Pound - $0.60", "M6B - Micro British Pound - $0.60"],
    ["6C - Canadian Dollar - $5.00", "6C - Canadian Dollar - $5.00"], ["6J - Japanese Yen - $6.25", "6J - Japanese Yen - $6.25"],
    ["6S - Swiss Franc - $6.25", "6S - Swiss Franc - $6.25"], ["HE - Lean Hog - $10.00", "HE - Lean Hog - $10.00"],
    ["GF - Feeder Cattle - $12.50", "GF - Feeder Cattle - $12.50"], ["LE - Live Cattle - $10.00", "LE - Live Cattle - $10.00"],
    ["BTC - Bitcoin - $25.00", "BTC - Bitcoin - $25.00"], ["MBT - Micro Bitcoin - $0.50", "MBT - Micro Bitcoin - $0.50"],
    ["ZS - Soybean - $12.50", "ZS - Soybean - $12.50"], ["XK - Mini Soybean - $1.25", "XK - Mini Soybean - $1.25"],
    ["ZW - Wheat - $12.50", "ZW - Wheat - $12.50"], ["MZW - Micro Wheat - $2.50", "MZW - Micro Wheat - $2.50"],
    ["ZC - Corn - $12.50", "ZC - Corn - $12.50"], ["MZC - Corn Micro - $2.50", "MZC - Corn Micro - $2.50"],
    ["ZF - 5 Year T-Note - $7.81", "ZF - 5 Year T-Note - $7.81"], ["TN - Ultra 10 Year Note - $15.63", "TN - Ultra 10 Year Note - $15.63"],
    ["MTN - Ultra 10 Year Note Micro - $1.56", "MTN - Ultra 10 Year Note Micro - $1.56"], ["ZN - 10 Year T-Note - $15.62", "ZN - 10 Year Note - $15.62"],
    ["ZT - 2 Year Note - $7.81", "ZT - 2 Year Note - $7.81"],
];

const SYMBOL_OPTIONS = [
    ["EURUSD", "EUR/USD"], ["GBPUSD", "GBP/USD"], ["USDJPY", "USD/JPY"], ["USDCHF", "USD/CHF"], ["AUDUSD", "AUD/USD"], ["USDCAD", "USD/CAD"], ["NZDUSD", "NZD/USD"],
    ["EURGBP", "EUR/GBP"], ["EURJPY", "EUR/JPY"], ["EURCHF", "EUR/CHF"], ["EURAUD", "EUR/AUD"], ["EURNZD", "EUR/NZD"], ["EURCAD", "EUR/CAD"], ["GBPJPY", "GBP/JPY"],
    ["GBPCHF", "GBP/CHF"], ["GBPAUD", "GBP/AUD"], ["GBPNZD", "GBP/NZD"], ["GBPCAD", "GBP/CAD"], ["AUDJPY", "AUD/JPY"], ["AUDNZD", "AUD/NZD"], ["AUDCAD", "AUD/CAD"],
    ["AUDCHF", "AUD/CHF"], ["NZDJPY", "NZD/JPY"], ["NZDCAD", "NZD/CAD"], ["NZDCHF", "NZD/CHF"], ["CADJPY", "CAD/JPY"], ["CADCHF", "CAD/CHF"], ["CHFJPY", "CHF/JPY"],
    ["USDSEK", "USD/SEK"], ["USDNOK", "USD/NOK"], ["USDDKK", "USD/DKK"], ["USDMXN", "USD/MXN"], ["USDZAR", "USD/ZAR"], ["USDHKD", "USD/HKD"], ["USDSGD", "USD/SGD"],
    ["USDTRY", "USD/TRY"], ["USDPLN", "USD/PLN"], ["USDCNH", "USD/CNH"], ["USDTHB", "USD/THB"], ["USDHUF", "USD/HUF"], ["USDILS", "USD/ILS"],
    ["XAUUSD", "Gold (XAU/USD)"], ["XAGUSD", "Silver (XAG/USD)"], ["XPTUSD", "Platinum (XPT/USD)"], ["XPDUSD", "Palladium (XPD/USD)"]
];

// --- Helpers for Product/Symbol handling & account type detection ---
const FOREX_VALUES = new Set(SYMBOL_OPTIONS.map(([v]) => v));
const LABEL_TO_FOREX = new Map(SYMBOL_OPTIONS.map(([v, label]) => [label, v])); // "EUR/USD" => "EURUSD"
const FUTURES_VALUES = new Set(PRODUCT_OPTIONS.map(([full]) => full.split(' - ')[0])); // "YM - ..." => "YM"
const TIMEFRAME_OPTIONS = ["15s","30s","1m","2m","3m","5m","10m","15m","30m","1h","2h","4h","D","W","M"];
const TRADOVATE_WEBHOOK_URL = "https://us-central1-trapound-app.cloudfunctions.net/tradovateWebhook"
const TRADOVATE_WEBHOOK_SECRET = "AutoTV_26level$"; 

// --- Icons (copy these SVGs exactly as shown) ----
const IconGoal = () => (
  <span className="bg-blue-100 dark:bg-blue-500 text-blue-600 dark:text-blue-300 rounded-full p-2 mr-2 shadow-sm">
    <svg width="24" height="24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2"/>
      <path d="M8 12l2 2l4-4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  </span>
);



function normalizeProductValue(raw) {
  if (!raw) return "";
  // "YM - US30 - $5.00" -> "YM"; "EUR/USD" -> "EURUSD"; "EURUSD" -> "EURUSD"
  const short = getProductShort(raw).trim().toUpperCase();
  if (LABEL_TO_FOREX.has(short)) return LABEL_TO_FOREX.get(short); // turn "EUR/USD" into "EURUSD"
  const noSlash = short.replace("/", ""); // "EUR/USD" -> "EURUSD"
  if (FOREX_VALUES.has(noSlash)) return noSlash;
  if (FUTURES_VALUES.has(short)) return short;
  return short;
}

function getSessionFromTime(time24) {
  if (!time24) return "";
  
  const [hour] = time24.split(":").map(Number);

  // New York: 8:00 AM - 5:00 PM (17:00)
  if (hour >= 8 && hour < 17) return "New York";
  
  // London: 3:00 AM - 8:00 AM
  if (hour >= 3 && hour < 8) return "London";
  
  // Asian (Tokyo): 7:00 PM (19:00) - 3:00 AM 
  // (Using || because it crosses midnight)
  if (hour >= 19 || hour < 3) return "Asian";
  
  // Sydney: 5:00 PM (17:00) - 7:00 PM (19:00)
  // (Captures the gap after NY closes and before Tokyo opens)
  if (hour >= 17 && hour < 19) return "Sydney";
  
  return "";
}

function resolveAccountType(settingsMap, rows) {
  const typeString = (
    settingsMap?.type ??
    settingsMap?.Type ??
    settingsMap?.accountType ??
    settingsMap?.["Account Type"] ??
    settingsMap?.["Trade Mode"] ??
    settingsMap?.Platform ??
    ""
  ).toString().toLowerCase();

  if (typeString.includes("mixed")) return "mixed"; 
  if (typeString.includes("forex") || typeString === "fx") return "forex";
  if (typeString.includes("future")) return "futures";
  if (typeString.includes("stock")) return "stock";
  if (typeString.includes("option")) return "options"; // [!code ++] Added Options check
  
  return null;
}


const SESSION_OPTIONS = ["New York", "London", "Asian", "Sydney", "Mixed"];
const POSITION_OPTIONS = ["Buy", "Sell", "CounterTrend - Buy","CounterTrend - Sell", "Did Not Take"];
const RULES_OPTIONS = ["Yes", "No"];
const GRADE_OPTIONS = ["A", "B", "C", "D", "E", "F"];
const MOOD_OPTIONS = ["1", "2", "3", "4", "5"];
const RESULT_OPTIONS = ["Won", "Loss"];
const BLANK = "__BLANK__";
const EDITABLE_FIELDS = [
     ["Actual Balance", "number"], ["Date", "date"], ["Win", "checkbox"], ["Loss", "checkbox"],
     ["Entry Time", "time"], ["Exit Time", "time"], ["Session", "select"], ["Position", "select"],
     ["Size", "number"], ["Entry Strategy", "text"], ["Exit Strategy", "text"],
     ["Did I follow my Rules?", "select"], ["Notes", "textarea"], ["Grade", "select"], ["Actual Reward", "number"],
     ["Mood_Mindset", "text"], ["Product", "select"], ["Links_Screenshots", "text"], ["Lesson", "textarea"],["Timeframe", "text"]
    ,["Ticks", "number"], ["Pips", "number"], ["Potential", "number"],
    ["Entry Price", "number"], ["IdealSL", "number"],
    ["Exit Price", "number"],
    ["Strike", "text"], ["Option Type", "select"], ["Expiration", "date"], 
    ["Underlying Entry Price", "number"], ["Delta", "number"],
    ["Stop Loss_Take Profit", "text"],
    ["Needs Review", "checkbox"], ["Emotional Notes", "textarea"], ["Target Reached", "checkbox"]
 ];

const Tooltip = ({ children, text }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative inline-block ml-1" onMouseEnter={() => setVisible(true)} onMouseLeave={() => setVisible(false)}>
      <FaInfoCircle className="text-gray-400 dark:text-gray-500 cursor-pointer" />
      {visible && (
        <span className="absolute z-10 -top-1 left-full ml-2 w-max max-w-xs p-2 text-xs text-white bg-gray-800 dark:bg-gray-700 rounded-md shadow-lg transition-opacity duration-300">
          {text}
        </span>
      )}
      {children}
    </div>
  );
};


// Decide forex vs futures for labeling
function isForexAccount(settings, journal) {
  const a =
    String(settings?.["Account Type"] || settings?.Platform || journal?.["Account Type"] || journal?.Platform || "")
      .toLowerCase();
  if (a.includes("forex")) return true;
  if (a.includes("futures")) return false;

  // Heuristic: many forex symbols look like "EURUSD", "GBPUSD", "USDJPY", etc.
  const sym = String(journal?.Product || "").toUpperCase();
  return /^[A-Z]{6}$/.test(sym) || /^[A-Z]{3}\/[A-Z]{3}$/.test(sym);
}

const toHHMM = (t) => {
  if (!t) return "";
  // Handles "HH:MM", "HH:MM:SS", "1:07 PM", etc. AFTER your to24HourTime conversion
  const s = String(t).trim();
  return s.length >= 5 ? s.slice(0, 5) : s;
};


function getProductShort(val) { return val ? val.split(" - ")[0] : ""; }
 function formatCurrency(val) {
   const n = Number(val);
   if (!isFinite(n)) return "";
   return n.toLocaleString("en-US", {
     style: "currency", currency: "USD", minimumFractionDigits: 2
   });
 }

 function parseSignedNumber(value) {
  if (value === "" || value === null || value === undefined) {
    return NaN;
  }

  const raw = String(value)
    .trim()
    .replace(/[\u2212\u2013\u2014]/g, "-");

  const isParenthesizedNegative = /^\(.*\)$/.test(raw);
  const cleaned = raw.replace(/[^\d.-]/g, "");
  const parsed = Number(cleaned);

  if (!Number.isFinite(parsed)) {
    return NaN;
  }

  return isParenthesizedNegative
    ? -Math.abs(parsed)
    : parsed;
}

function toYYYYMMDD(val) { if (!val) return ""; if (typeof val === "string" && /^\d{4}-\d{2}-\d{2}$/.test(val)) { return val; } let date; if (typeof val === 'string') { const [mm, dd, yyyy] = val.split('/'); if (mm && dd && yyyy) { date = new Date(yyyy, mm - 1, dd); } else { date = new Date(val); } } else if (typeof val === 'object' && val.seconds) { date = new Date(val.seconds * 1000); } else { date = new Date(val); } if (isNaN(date)) return ""; const yyyy = date.getFullYear(); const mm = String(date.getMonth() + 1).padStart(2, '0'); const dd = String(date.getDate()).padStart(2, '0'); return `${yyyy}-${mm}-${dd}`; }
function parseTimeToMinutes(t) { if (!t) return -1; const m = t.match(/^(\d{1,2}):(\d{2})(?:\s*([APMapm]{2}))?$/); if (!m) return -1; let [_, h, min, ap] = m; let hour = parseInt(h, 10); const minutes = parseInt(min, 10); if (ap) { const ampm = ap.toUpperCase(); if (ampm === "PM" && hour < 12) hour += 12; if (ampm === "AM" && hour === 12) hour = 0; } return hour * 60 + minutes; }
function toAmPm(str) {
  if (!str || !/^\d{2}:\d{2}(:\d{2})?$/.test(str)) return str;
  let [h, m, s] = str.split(":");
  h = parseInt(h, 10);
  if (isNaN(h) || isNaN(parseInt(m, 10))) return "";
  const ampm = h >= 12 ? 'PM' : 'AM';
  let hour12 = h % 12;
  if (hour12 === 0) hour12 = 12;
  return `${String(hour12).padStart(2, '0')}:${m}${s ? `:${s}` : ""} ${ampm}`;
}


function formatSlTp(val) {
  if (!val || val === "-" || val === "/") return "–";
  
  const parts = String(val).split("/");
  if (parts.length === 2) {
    const slStr = parts[0].trim();
    const tpStr = parts[1].trim();

    const formatNum = (numStr) => {
      const n = Number(numStr);
      if (isNaN(n) || numStr === "") return numStr;
      
      // Keep the exact number of decimals the user typed (up to 5) 
      // so we don't accidentally truncate Forex prices like 1.05000
      const decimals = numStr.includes('.') ? numStr.split('.')[1].length : 0;
      return n.toLocaleString('en-US', { 
        minimumFractionDigits: Math.min(decimals, 5),
        maximumFractionDigits: 5 
      });
    };

    return `${formatNum(slStr)} / ${formatNum(tpStr)}`;
  }
  return val;
}


function to24HourTime(str) {
  if (!str || /^\d{2}:\d{2}(:\d{2})?$/.test(str)) return str; // already 24h (with or w/o seconds)
  const ampm = str.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*([APap][Mm])$/);
  if (ampm) {
    let [, h, m, s, ap] = ampm;
    h = parseInt(h, 10);
    if (ap.toUpperCase() === 'PM' && h !== 12) h += 12;
    if (ap.toUpperCase() === 'AM' && h === 12) h = 0;
    return `${String(h).padStart(2, '0')}:${m}${s ? `:${s}` : ""}`;
  }
  return "";
}

const formatTimeWithAmPm = (time) => {
  if (!time) return "–";
  const s = String(time).trim();

  // Case 1: already has AM/PM, maybe with seconds (e.g. "01:31:56 PM" or "1:31 PM")
  const ampmMatch = s.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*([APap][Mm])$/);
  if (ampmMatch) {
    let [, h, m, ap] = ampmMatch;
    const hour12 = (parseInt(h, 10) % 12) || 12;
    return `${hour12}:${m} ${ap.toUpperCase()}`;
  }

  // Case 2: 24h time, maybe with seconds (e.g. "13:31:56" or "09:05")
  const hhmmMatch = s.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
  if (hhmmMatch) {
    let [, h, m] = hhmmMatch;
    const hour = parseInt(h, 10);
    if (isNaN(hour)) return s;
    const ap = hour >= 12 ? "PM" : "AM";
    const hour12 = (hour % 12) || 12;
    return `${hour12}:${m} ${ap}`;
  }

  // Fallback
  return s;
};


function isValidUrl(str) {
    if (!str || typeof str !== "string") return false;
    const trimmed = str.trim();
    return /^https?:\/\/\S+\.\S+/.test(trimmed) || /^[\w.-]+\.[a-zA-Z]{2,}(\/\S*)?$/.test(trimmed);
}

function parseCsvText(text) {
  // simple CSV: supports quoted fields and commas
  const lines = text.replace(/\r/g, "").split("\n").filter(l => l.trim() !== "");
  if (!lines.length) return [];
  const parseLine = (line) => {
    const out = [];
    let cur = "", inQ = false;
    for (let i = 0; i < line.length; i++) {
      const ch = line[i];
      if (inQ) {
        if (ch === '"' && line[i+1] === '"') { cur += '"'; i++; }
        else if (ch === '"') inQ = false;
        else cur += ch;
      } else {
        if (ch === '"') inQ = true;
        else if (ch === ",") { out.push(cur); cur = ""; }
        else cur += ch;
      }
    }
    out.push(cur);
    return out;
  };
  const headers = [...parseLine(lines[0]).map(h => h.trim()), "Download"];
  return lines.slice(1).map(l => {
    const cols = parseLine(l);
    const row = {};
    headers.forEach((h, i) => row[h] = cols[i] ?? "");
    return row;
  });
}

function autoMap(row) {
  // normalize common header variants to your journal fields
  const g = (keys) => {
    for (const k of keys) {
      const found = Object.keys(row).find(
        h => h.toLowerCase().replace(/\s+/g,"") === k.toLowerCase().replace(/\s+/g,"")
      );
      if (found) return row[found];
    }
    return "";
  };
  const num = (v) => {
    const n = Number(String(v).replace(/[^\d.-]/g,""));
    return Number.isFinite(n) ? n : "";
  };
  const dateStr = g(["Date"]);
  const entryT  = g(["Entry Time","Entry"]);
  const exitT   = g(["Exit Time","Exit"]);

  // Duration — preserve if provided, else compute H:MM:SS from your helpers
  let duration = g(["Duration"]);
  if (!duration && entryT && exitT) {
    const s = computeDurationHMS(entryT, exitT);
    if (s) duration = s;
  }
  const before    = g(["Balance Before Trade"]);
  const actualBal = g(["Actual Balance"]);
  const actualRwd = g(["Actual Reward","Reward"]);
  const product   = g(["Product","Symbol","Instrument"]);

  // NEW: entry/exit price from CSV if present
  const entryPrice = num(g(["Entry Price","EntryPrice","Entry price"]));
  const exitPrice  = num(g(["Exit Price","ExitPrice","Exit price"]));


  return {
    "Trade #": g(["Trade #","Trade","Id","ID"]) || undefined,
    "Account Type": g(["Account Type", "Type", "AcctType"]),
    "Product": product,
    "Position": g(["Position","Side"]) || "",
    "Size": g(["Size","Qty","Quantity","Lots"]) || "",
    "Date": dateStr,
    "Entry Time": entryT,
    "Exit Time": exitT,
    "Entry Price": entryPrice,
    "Exit Price": exitPrice,
    "Duration": duration || g(["Duration (h:mm)"]),
    "Links_Screenshots": g(["Links_Screenshots","Link","Screenshot"]),
    "Session": g(["Session"]),
    "Entry Strategy": g(["Entry Strategy"]),
    "Exit Strategy": g(["Exit Strategy"]),
    "Potential": num(g(["Potential", "Potential Pips", "Potential Ticks", "Potential Points"])),
    "IdealSL": num(g(["IdealSL", "Ideal SL", "Ideal Stop Loss"])),
    "Ticks": g(["Ticks"]) || "",
    "Pips": g(["Pips"]) || "",
    "Timeframe": g(["Timeframe","TF"]) || "",
    "Did I follow my Rules?": g(["Did I follow my Rules?","Followed Rules","Rules"]) || "",
    "Grade": g(["Grade"]) || "",
    "Mood_Mindset": g(["Mood_Mindset","Mood/Mindset","Mood"]) || "",
    "Actual Risk to Reward": g(["Actual Risk to Reward","R:R","RR"]) || "",
    "Stop Loss_Take Profit": g(["Stop Loss_Take Profit","SL/TP","SLTP"]) || "",
    "Total Risk": num(g(["Total Risk","Risk Amount","Risk ($)"])),
    "Percent of Balance": num(g(["Percent of Balance","Risk %","Risk(%)"])),
    "Notes": g(["Notes"]) || "",
    "Lesson": g(["Lesson"]) || "",
    "Actual Balance": num(actualBal),
    "Actual Reward": num(actualRwd),
    "Balance Before Trade": before ? num(before) : ""
  };
}





function computeDurationHMM(entryStr, exitStr) { const start = parseTimeToMinutes(entryStr); const end = parseTimeToMinutes(exitStr); if (start < 0 || end < 0) return ""; let diff = end - start; if (diff < 0) diff += 24 * 60; const h = Math.floor(diff / 60); const m = diff % 60; return `${h}:${String(m).padStart(2, "0")}`; }
// NEW: parse time to seconds (supports "H:MM", "H:MM:SS", optional AM/PM)
function parseTimeToSeconds(t) {
  if (!t) return -1;
  const m = String(t).trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?(?:\s*([APMapm]{2}))?$/);
  if (!m) return -1;
  let [, h, min, sec, ap] = m;
  let hour = parseInt(h, 10);
  const minutes = parseInt(min, 10);
  const seconds = sec ? parseInt(sec, 10) : 0;
  if (ap) {
    const ampm = ap.toUpperCase();
    if (ampm === "PM" && hour < 12) hour += 12;
    if (ampm === "AM" && hour === 12) hour = 0;
  }
  return hour * 3600 + minutes * 60 + seconds;
}

// NEW: compute duration as "H:MM:SS"
function computeDurationHMS(entryStr, exitStr) {
  const start = parseTimeToSeconds(entryStr);
  const end = parseTimeToSeconds(exitStr);
  if (start < 0 || end < 0) return "";
  let diff = end - start;
  if (diff < 0) diff += 24 * 3600; // cross‑midnight
  const h = Math.floor(diff / 3600);
  const m = Math.floor((diff % 3600) / 60);
  const s = diff % 60;
  return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

function formatDateWithWeekday(val) {
  if (!val) return "";
  let d;

  if (typeof val === "object" && val.seconds) {
    d = new Date(val.seconds * 1000);
  } else if (typeof val === "string" && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(val)) {
    const [mm, dd, yyyy] = val.split("/");
    d = new Date(`${yyyy}-${mm}-${dd}`);
  } else if (typeof val === "string" && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
    d = new Date(`${val}T00:00:00`);
  } else {
    d = new Date(val);
  }

  if (!d || isNaN(d)) return "";

  const weekday = d.toLocaleDateString("en-US", { weekday: "long" });
  const month = d.getMonth() + 1;
  const day = d.getDate();
  const year = d.getFullYear();
  return `${weekday}, ${month}/${day}/${year}`;
}


// REPLACE existing formatDuration with this version
function formatDuration(raw) {
  if (raw === null || raw === undefined || raw === "") return "";
  let totalSeconds = 0;

  if (typeof raw === "number" && isFinite(raw)) {
    // assume raw is already seconds
    totalSeconds = Math.max(0, Math.floor(raw));
  } else if (typeof raw === "string") {
    const s = raw.trim();
    // "H:MM" or "H:MM:SS"
    const m = s.match(/^(\d+):(\d{1,2})(?::(\d{1,2}))?$/);
    if (m) {
      const h   = parseInt(m[1], 10) || 0;
      const min = parseInt(m[2], 10) || 0;
      const sec = parseInt(m[3] || "0", 10) || 0;
      totalSeconds = h * 3600 + min * 60 + sec;
    } else if (/^\d+$/.test(s)) {
      // plain seconds
      totalSeconds = parseInt(s, 10);
    } else {
      // unknown format – show as‑is
      return s;
    }
  } else {
    return "";
  }

  // "<1" for 0s
  if (totalSeconds <= 0) return "<1";

  const ONE_DAY = 24 * 3600;

  // -----------------------------
  // > 24 hours → days / hours / mins (no seconds)
  // -----------------------------
  if (totalSeconds > ONE_DAY) {
    const days  = Math.floor(totalSeconds / ONE_DAY);
    const rem   = totalSeconds % ONE_DAY;
    const hours = Math.floor(rem / 3600);
    const mins  = Math.floor((rem % 3600) / 60);

    const parts = [];
    if (days)  parts.push(`${days}d`);
    if (hours) parts.push(`${hours}h`);
    if (mins || (!days && !hours)) {
      const minLabel = mins === 1 ? "min" : "mins";
      parts.push(`${mins} ${minLabel}`);
    }
    return parts.join(" ");
  }

  // -----------------------------
  // ≤ 24 hours → hours / mins / seconds (existing behavior)
  // -----------------------------
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;

  const parts = [];
  if (h) parts.push(`${h}h`);
  if (m || h) {
    const minLabel = m === 1 ? "min" : "mins";
    parts.push(`${m} ${minLabel}`);
  }
  // show seconds if non‑zero or if < 1 minute total
  if (s || (!h && !m)) parts.push(`${s}s`);

  return parts.join(" ");
}

const formatProduct = (product) => { if (!product) return "–"; return product.split('-')[0].trim(); };
/*const formatTimeWithAmPm = (time) => {
  if (!time) return "–";
  const s = String(time).trim();*/
/*
  // Case 1: already has AM/PM (e.g., "1:00 PM", "01:00 pm")
  const ampmMatch = s.match(/^(\d{1,2}):(\d{2})\s*([APap][Mm])$/);
  if (ampmMatch) {
    let [, h, m, ap] = ampmMatch;
    const hour12 = (parseInt(h, 10) % 12) || 12;
    return `${hour12}:${m} ${ap.toUpperCase()}`;
  }

  // Case 2: 24-hour time (e.g., "13:00" or "09:05")
  const hhmmMatch = s.match(/^(\d{1,2}):(\d{2})$/);
  if (hhmmMatch) {
    let [, h, m] = hhmmMatch;
   const hour = parseInt(h, 10);
    const ap = hour >= 12 ? "PM" : "AM";
    const hour12 = (hour % 12) || 12;
    return `${hour12}:${m} ${ap}`;
  }

  // Fallback: return as-is
  return s;
};*/

function checkTimeRange(rowTime, fromTime, toTime) {
  if (!rowTime && (fromTime || toTime)) return false; // Hide if row has no time but filter is active
  if (!fromTime && !toTime) return true;
  if (fromTime && !toTime) return rowTime >= fromTime;
  if (!fromTime && toTime) return rowTime <= toTime;
  
  if (fromTime > toTime) {
    // Range spans midnight (e.g., 19:00 to 03:00)
    return rowTime >= fromTime || rowTime <= toTime;
  } else {
    // Normal range (e.g., 09:00 to 17:00)
    return rowTime >= fromTime && rowTime <= toTime;
  }
}

const formatLink = (url) => { if (!url) return null; if (!url.startsWith("http://") && !url.startsWith("https://")) { return `https://${url}`; } return url; };
function isFundingRow(row) {
  const type = String(row?.["Funding Type"] || "").toLowerCase();
  return row?.isFunding === true
    || type === "deposit"
    || type === "withdrawal"
    || getProductShort(row?.["Product"]) === "Funding";
}

// --- Screenshot preview helpers (top-level, outside any component) ---
const URL_REGEX = /https?:\/\/[^\s)>\]]+/ig;

function extractFirstUrl(raw) {
  if (!raw) return "";
  const s = String(raw);
  const match = s.match(URL_REGEX);
  if (!match || !match[0]) return "";
  // Trim common trailing punctuation users accidentally paste
  let token = match[0].replace(/[)\].,;]+$/, "");
  if (!/^https?:\/\//i.test(token)) token = `https://${token}`;
  return token;
}

// Keep outside components
function buildCandidates(raw) {
  if (!raw) return [];
  const out = [];

  // Google Drive
  let m = raw.match(/drive\.google\.com\/file\/d\/([^/]+)/i);
  if (m) return [`https://drive.google.com/uc?export=view&id=${m[1]}`];
  m = raw.match(/drive\.google\.com\/open\?id=([^&]+)/i);
  if (m) return [`https://drive.google.com/uc?export=view&id=${m[1]}`];

  // Dropbox -> raw
  if (/dropbox\.com/i.test(raw)) {
    let url = raw;
    if (url.includes("dl=0")) url = url.replace("dl=0", "raw=1");
    else if (!/[?&](raw|dl)=/.test(url)) url += (url.includes("?") ? "&" : "?") + "raw=1";
    return [url];
  }

  // Direct image / data URL
  if (/\.(png|jpe?g|gif|webp|bmp|svg|avif)(\?.*)?$/i.test(raw) || /^data:image\//i.test(raw)) {
    return [raw];
  }

  // TradingView /x/<id>
  const tv = raw.match(/tradingview\.com\/x\/([A-Za-z0-9]+)(?:\/|\?|$)/);
  if (tv) {
    const id = tv[1];
    const variants = [id, id.toLowerCase(), id.toUpperCase()];
    const exts = ["png", "webp", "jpg", "jpeg"];
    for (const v of variants) {
      for (const ext of exts) {
        out.push(`https://s3.tradingview.com/x/${v}.${ext}`);
        out.push(`https://s3.tradingview.com/x/${v}_original.${ext}`);
      }
    }
    return out;
  }

  // TradingView /chart/<id>
  const tvChart = raw.match(/tradingview\.com\/chart\/([A-Za-z0-9]+)(?:\/|\?|$)/);
  if (tvChart) {
    const id = tvChart[1];
    const letter = id.charAt(0);
    const exts = ["png", "webp", "jpg", "jpeg"];
    for (const ext of exts) {
      out.push(`https://s3.tradingview.com/snapshots/${letter}/${id}.${ext}`);
    }
    return out;
  }

  return [raw];
}

// Turn a row's link field into a direct image URL (TradingView/Drive/Dropbox/etc)
function resolveScreenshotUrlForRow(row) {
  if (!row) return "";
  const rawLinksField = row["Links_Screenshots"] ?? row.link_screenshot ?? "";
  if (!rawLinksField) return "";

  const extracted = extractFirstUrl(rawLinksField);
  let firstUrl = extracted;
  if (!firstUrl && isValidUrl(rawLinksField)) {
    firstUrl = formatLink(String(rawLinksField).trim());
  }
  if (!firstUrl) return "";

  const candidates = buildCandidates(firstUrl);
  if (candidates && candidates.length) {
    return candidates[0]; // best guess
  }

  const fallback = getScreenshotFallback(firstUrl);
  return fallback || firstUrl;
}



// Keep near other helpers (e.g., formatCurrency)
function formatPercent(val) {
  if (val === "" || val == null) return "–";
  // Accept values like "24.75%", "102.00", 12, etc.
  const n = Number(String(val).toString().replace(/[^\d.-]/g, ""));
  if (!Number.isFinite(n)) return "–";
  // Drop trailing zeros; show up to 2 decimals when needed.
  return `${n.toLocaleString(undefined, { maximumFractionDigits: 2 })}%`;
}



function canIframeEmbed(url) {
  if (!url) return false;
  try {
    const u = new URL(url);
    const host = u.hostname.toLowerCase();
    // Keep conservative allow-list; expand if needed later
    return (
      host.endsWith("tradingview.com") ||
      host.endsWith("dropbox.com") ||
      host.endsWith("drive.google.com")
    );
  } catch {
    return false;
  }
}

function raceImageCandidates(urls, onWin, onAllFail, timeoutMs = 9000) {
  if (!urls || !urls.length) { onAllFail?.(); return; }

  let settled = false;
  let remaining = urls.length;
  const timers = [];

  const win = (url) => {
    if (settled) return;
    settled = true;
    timers.forEach(clearTimeout);
    onWin?.(url);
  };
  const loseOne = () => {
    remaining -= 1;
    if (remaining <= 0 && !settled) {
      settled = true;
      timers.forEach(clearTimeout);
      onAllFail?.();
    }
  };

  urls.forEach((u) => {
    const img = new Image();
    const t = setTimeout(() => {
      img.src = ""; // stop
      loseOne();
    }, timeoutMs);
    timers.push(t);
    img.onload = () => { clearTimeout(t); win(u); };
    img.onerror = () => { clearTimeout(t); loseOne(); };
    // Cache-buster in case of transient CDN errors
    const cacheBust = u.includes("?") ? `${u}&v=${Date.now()}` : `${u}?v=${Date.now()}`;
    img.referrerPolicy = "no-referrer";
    img.crossOrigin = "anonymous";
    img.src = cacheBust;
  });
}


// Returns a direct-image URL for a page screenshot via Microlink.
// It responds as an actual image when `embed=screenshot.url` is used.
function getScreenshotFallback(url) {
  try {
    if (!url) return "";
    const u = new URL(url);
    // keep a tight allowlist; expand as you wish
    const allow = ["www.tradingview.com", "tradingview.com"];
    if (!allow.includes(u.hostname)) return "";
    return `https://api.microlink.io/?url=${encodeURIComponent(
      url
    )}&screenshot=true&meta=false&embed=screenshot.url&waitFor=1000`;
  } catch {
    return "";
  }
}

// For journal export: pick an image URL that html2canvas can actually use
function resolveExportScreenshotUrl(row) {
  if (!row) return "";
  const rawLinksField = row["Links_Screenshots"] ?? row.link_screenshot ?? "";
  if (!rawLinksField) return "";

  const extracted = extractFirstUrl(rawLinksField);
  let url = extracted;
  if (!url && isValidUrl(rawLinksField)) {
    url = formatLink(String(rawLinksField).trim());
  }
  if (!url) return "";

  try {
    const u = new URL(url);
    const host = u.hostname.toLowerCase();

    // Case 1: direct S3 snapshot, e.g. https://s3.tradingview.com/x/Ns9KIxMi.png
    if (host === "s3.tradingview.com") {
      const m = u.pathname.match(/\/x\/([A-Za-z0-9]+)/);
      if (m && m[1]) {
        const id = m[1];
        const tvPage = `https://www.tradingview.com/x/${id}/`;
        const fb = getScreenshotFallback(tvPage);
        return fb || tvPage;
      }
    }

    // Case 2: TradingView share link, e.g. https://www.tradingview.com/x/Ns9KIxMi/
    if (host.endsWith("tradingview.com")) {
      const m = url.match(/tradingview\.com\/x\/([A-Za-z0-9]+)/i);
      if (m && m[1]) {
        const tvPage = `https://www.tradingview.com/x/${m[1]}/`;
        const fb = getScreenshotFallback(tvPage);
        return fb || tvPage;
      }
      const fb = getScreenshotFallback(url);
      return fb || url;
    }

    // Non‑TradingView links: use direct candidates, then fallback
    const candidates = buildCandidates(url);
    if (candidates && candidates.length) return candidates[0];

    const fb = getScreenshotFallback(url);
    return fb || url;
  } catch {
    const candidates = buildCandidates(url);
    if (candidates && candidates.length) return candidates[0];
    const fb = getScreenshotFallback(url);
    return fb || url;
  }
}




function DetailsPopup({ open, onClose, details, onViewChecklist, canViewChecklist, loadingPTC, onPrev, onNext, hasPrev, hasNext, isBacktesting, accountType, settings, isPrivacyMode }) {
  // Hooks/helpers MUST be before any early return
  const [triedOriginal, setTriedOriginal] = useState(false);
  // Top of DetailsPopup (with your other hooks)
  const [resolvedUrl, setResolvedUrl] = useState("");
  const [imgLoading, setImgLoading] = useState(false);
  const [fallbackFailed, setFallbackFailed] = useState(false);
 

  // Small inline loader
  const ImgLoader = () => (
    <div className="flex items-center justify-center w-full h-64 rounded-lg border border-gray-200 dark:border-gray-700 bg-white/50 dark:bg-gray-900/50">
      <svg className="animate-spin h-6 w-6 text-blue-500" viewBox="0 0 24 24" fill="none">
        <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
        <path className="opacity-80" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
      </svg>
      <span className="ml-2 text-sm text-gray-600 dark:text-gray-300">Loading preview…</span>
    </div>
  );


  // Source field (support both keys)
  const rawLinksField = details?.["Links_Screenshots"] ?? details?.link_screenshot ?? "";

    // First URL (prefer extractor; fall back to valid bare domain)
    const firstUrl = useMemo(() => {
      const extracted = extractFirstUrl(rawLinksField);
      if (extracted) return extracted;                 // http(s) found -> use it
      if (isValidUrl(rawLinksField)) {                 // bare domain or valid-looking
        return formatLink(String(rawLinksField).trim());  // add https:// if missing
      }
      return "";
    }, [rawLinksField]);

  // Rebuild candidates with a cache-buster stamp
  const [stamp, setStamp] = useState(0);
  const candidates = useMemo(() => {
    const base = buildCandidates(firstUrl);
    if (!base.length) return [];
    const s = stamp || Date.now();
    return base.map(u => (u.includes("?") ? `${u}&v=${s}` : `${u}?v=${s}`));
  }, [firstUrl, stamp]);

  // Walk candidates sequentially in the real <img>
  const [candidateIdx, setCandidateIdx] = useState(0);
  const [imgFailed, setImgFailed] = useState(false);


  // Debug flags + logs
  const [debug, setDebug] = useState(false);
  const [imgLog, setImgLog] = useState([]); // [{url,event,ts,extra?}]
  const fallbackUrl = useMemo(() => getScreenshotFallback(firstUrl), [firstUrl]);
  useEffect(() => {
    setCandidateIdx(0);
    setImgFailed(false);
    setImgLog([]);
    setStamp(Date.now()); // force fresh cache-buster each time URL changes
    setImgLoading(!!firstUrl);  // NEW
    setFallbackFailed(false);   // NEW
  }, [firstUrl]);

  const previewUrl = candidates[candidateIdx] || "";
  const fullScreenshotUrl = useMemo(() => {
  if (previewUrl && !imgFailed) return previewUrl;
  if (imgFailed && fallbackUrl) return fallbackUrl;
  return "";
}, [previewUrl, imgFailed, fallbackUrl]);


  useEffect(() => {
    setCandidateIdx(0);
    setImgFailed(false);
  }, [firstUrl]);




  // If the standard TradingView URL fails, retry once with `_original.png`
  useEffect(() => {
    if (!imgFailed || triedOriginal) return;
    const isTV = /tradingview\.com\/x\/[A-Za-z0-9]+/i.test(firstUrl);
    if (isTV) {
      // flip to the _original variant next render
      setTriedOriginal(true);
      setImgFailed(false);
    }
  }, [imgFailed, triedOriginal, firstUrl]);


useEffect(() => {
  if (previewUrl && !imgFailed) setImgLoading(true);
}, [previewUrl, imgFailed]);

useEffect(() => {
  if (imgFailed && fallbackUrl) setImgLoading(true);
}, [imgFailed, fallbackUrl]);


// Allow keyboard navigation when the popup is open
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (e.key === "ArrowLeft" && hasPrev) onPrev?.();
      if (e.key === "ArrowRight" && hasNext) onNext?.();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, hasPrev, hasNext, onPrev, onNext]);

  
  if (!open || !details) return null;

 // ——— Compact helpers (place above the section, e.g., near other local components) ———
const DetailRow = ({
  label,
  value,
  formatter = (v) => (v ?? "–"),
  valueClass = ""
}) => (
  <div className="grid grid-cols-2 gap-2 py-2 text-[13px] border-b border-gray-200/60 dark:border-gray-700/50 last:border-b-0">
    <span className="text-gray-500 dark:text-gray-400">{label}</span>
    <span className={`text-right font-medium text-gray-900 dark:text-gray-100 ${valueClass}`}>
      {formatter(value)}
    </span>
  </div>
);

  const InfoBlock = ({ title, children }) => (
    <div className="mt-4">
      <h5 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2">{title}</h5>
      <div className="bg-gray-100 dark:bg-gray-800/50 rounded-lg p-3 text-sm text-gray-800 dark:text-gray-200 whitespace-pre-wrap break-words min-h-[40px]">
        {children}
      </div>
    </div>
  );

const isWin = details.Win === "TRUE" || details.Win === true;
  const isLoss = details.Loss === "TRUE" || details.Loss === true;

  const resultValue = isWin ? "Won" : (isLoss ? "Loss" : "–");
  const resultClass = isWin
    ? "text-green-600 dark:text-green-400 font-semibold"
    : isLoss
    ? "text-red-600 dark:text-red-400 font-semibold"
    : "";






    // Determine account type from this row’s product
    const isFuturesAccount = (accountType === "futures");
    const isStockAccount = (accountType === "stock");
    const isMixedAccount = (accountType === "mixed");
    const rowAccountType = String(details?.["Account Type"] || "").toLowerCase();

    // Determine the specific asset class for THIS trade (vital for Mixed Accounts)
    const isOptionsTrade = (accountType === "options") || rowAccountType.includes("option");
    const isStockTrade = isStockAccount || rowAccountType.includes("stock");
    
    const productNorm = normalizeProductValue(details?.["Product"]);
    const looksLikeForex = FOREX_VALUES.has(productNorm) || /^[A-Z]{3}\/[A-Z]{3}$/.test(productNorm) || /^[A-Z]{6}$/.test(productNorm);
    const isForexTrade = (accountType === "forex") || (isMixedAccount && (rowAccountType.includes("forex") || looksLikeForex));
    const isFuturesTrade = isFuturesAccount || (isMixedAccount && !isStockTrade && !isForexTrade && !isOptionsTrade);

    // Keep this for the Options UI rendering logic below
    const isOptionsAccount = isOptionsTrade; 

    // --- FIX START ---
    // Check all potential keys just in case
    const potentialVal = details["Potential"] || details["Potential Pips"] || details["Potential Ticks"] || details["Potential Points"];
    const hasPotential = potentialVal !== undefined && potentialVal !== null && Number(potentialVal) !== 0;

    // Set the label dynamically based on the specific trade type
    let baseLabel = "Units";
    if (isStockTrade || isOptionsTrade) baseLabel = "Points";
    else if (isFuturesTrade) baseLabel = "Ticks";
    else if (isForexTrade) baseLabel = "Pips";

// --- UNIVERSAL TRUTH ENGINE FOR DETAILS ---
    // 1. Smart Symbol Extraction
    const rawProd = String(details["Product"] || "").toUpperCase();
    let rootSym = rawProd.split(/[\s-]/)[0].replace(/[^\w]/g, ""); 
    rootSym = rootSym.replace(/[FGHJKMNQUVXZ][0-9]{1,2}$/, ""); 
    const acctType = String(details["Account Type"] || "").toLowerCase();

    // ADD THIS NEW INDEX CHECK
    const isIndex = ["US30", "NAS100", "SPX500", "GER30", "UK100"].includes(rootSym);

    // ADD isIndex TO THE END OF THIS LINE
    const localIsFx = FOREX_VALUES?.has(rootSym) || acctType.includes("forex") || /^[A-Z]{6}$/.test(rawProd) || isIndex;
    const localIsFut = FUTURES_VALUES?.has(rootSym) || acctType.includes("future") || ["ES","NQ","YM","RTY","CL","GC","MES","MNQ","MYM","MGC","MCL","NG","MNG","SI","SIL"].includes(rootSym);

    // 2. Safely grab the saved value
    const getValidDetailVal = (...keys) => {
        for (const k of keys) {
            const v = details[k];
            if (v != null && v !== "") {
                const num = Number(String(v).replace(/[^\d.-]/g, ""));
                if (!isNaN(num) && num !== 0) return num;
            }
        }
        for (const k of keys) {
            const v = details[k];
            if (v != null && v !== "") {
                const num = Number(String(v).replace(/[^\d.-]/g, ""));
                if (!isNaN(num)) return num;
            }
        }
        return null;
    };
    let baseValue = getValidDetailVal("Movement", "Ticks", "Pips", "Points");
    
    const ePrice = Number(details["Entry Price"]);
    const xPrice = Number(details["Exit Price"]);
    const canCalc = ePrice > 0 && xPrice > 0;

    let finalValue = null;

    if (canCalc) {
        const diff = Math.abs(xPrice - ePrice);
        const sign = (details["Loss"] === "TRUE" || details["Loss"] === true) ? -1 : 1;
        
        if (localIsFx) {
            let pipSize = 0.0001;
            if (rootSym.includes("JPY") || rootSym.includes("XAU") || rootSym.includes("GOLD") || rootSym.includes("XAG") || rootSym.includes("SILVER")) pipSize = 0.01;
            
            const isIdx = ["US30", "NAS100", "SPX500", "GER30", "UK100"].includes(rootSym);
            if (isIdx) pipSize = 1;
            
            finalValue = (diff / pipSize) * (isIdx ? 10 : 1) * sign;
        } else if (localIsFut) {
            const TICK_SIZES = {
                YM: 1, MYM: 1, ES: 0.25, MES: 0.25, NQ: 0.25, MNQ: 0.25,
                RTY: 0.1, M2K: 0.1, GC: 0.1, MGC: 0.1, CL: 0.01, MCL: 0.01,
                NG: 0.001, MNG: 0.001, SI: 0.005, SIL: 0.005, BTC: 5, MBT: 5,
            };
            const tSize = TICK_SIZES[rootSym] || Number(details["tickSize"]) || 0.25;
            finalValue = (diff / tSize) * sign;
        } else {
            finalValue = diff * sign;
        }
    } else if (baseValue !== null) {
        finalValue = baseValue;
    }

    let displayValue = "—";
    if (finalValue !== null && !isNaN(finalValue)) {
        if (finalValue === 0 && Number(details["Actual Reward"]) !== 0) {
            displayValue = "—";
        } else if (localIsFut || localIsFx) {
            displayValue = Math.round(finalValue).toString();
        } else {
            displayValue = finalValue.toFixed(2);
        }
    }

    // 1. Define perfLabel
    const perfLabel = hasPotential 
      ? `${baseLabel} / Potential` 
      : baseLabel;

    // 2. Define perfValue once
    const perfValue = hasPotential 
      ? `${displayValue} / ${potentialVal}` 
      : displayValue;

      
    // ❌ DELETE THE IF BLOCK THAT WAS HERE
    // (The block "if (hasPotential) { ... }" caused the error)
    // --- FIX END ---
      const balanceBeforeTrade = (() => {
        const explicit = details["Balance Before Trade"];
        if (explicit !== undefined && explicit !== null && String(explicit).trim() !== "" && !isNaN(Number(explicit))) {
          return Number(explicit);
        }
        const ab = Number(details["Actual Balance"]);
        const ar = Number(details["Actual Reward"]);
        if (isFinite(ab) && isFinite(ar)) return ab - ar;
        return undefined;
      })();

    // Bypass the helper functions and pull the exact values directly
    const totalRisk = details?.["Total Risk"] !== undefined && details?.["Total Risk"] !== null
      ? Number(String(details["Total Risk"]).replace(/[^\d.-]/g, "")) 
      : null;

    const actualRiskValue = details?.["Percent of Balance"] !== undefined && details?.["Percent of Balance"] !== null
      ? Number(String(details["Percent of Balance"]).replace(/[^\d.-]/g, "")) 
      : null;
    const rrRaw = String(details["Actual Risk to Reward"] ?? "").trim();
    let rrValue = parseFloat(rrRaw.replace(/[^\d.-]/g, ""));
    if (rrRaw.includes(":")) {
      const [a, b] = rrRaw.split(":").map(v => parseFloat(v));
      if (!isNaN(a) && !isNaN(b) && b !== 0) rrValue = a / b;
    }

    let rrClass = "text-gray-600 dark:text-gray-200 font-semibold";
    if (isFinite(rrValue)) {
      if (rrValue > 0.0) rrClass = "text-gray-600 dark:text-gray-200 font-semibold";
      else if (rrValue < 1.0) rrClass = "text-red-600 dark:text-red-400 font-semibold";
    }

    // --- Compute growthClass based on reward direction ---
    const rawGrowth = String(details["Actual Percent Growth"] ?? details["% Growth"] ?? "").trim();
    const numericGrowth = parseFloat(rawGrowth.replace(/[^\d.-]/g, ""));
    const numericReward = parseFloat(String(details["Actual Reward"]).replace(/[^\d.-]/g, ""));

    let growthClass = "text-gray-600 dark:text-gray-200 font-semibold";

    // Color green if reward positive, red if negative
    if (!isNaN(numericReward)) {
      if (numericReward > 0) growthClass = "text-gray-600 dark:text-gray-200 font-semibold";
      else if (numericReward < 0) growthClass = "text-red-600 dark:text-red-400 font-semibold";
    } else if (!isNaN(numericGrowth)) {
      // fallback if no reward data
      if (numericGrowth > 0) growthClass = "text-gray-600 dark:text-gray-200 font-semibold";
      else if (numericGrowth < 0) growthClass = "text-red-600 dark:text-red-400 font-semibold";
    }

    // --- Screenshot preview helpers (top-level, outside any component) ---
// Add this just under InfoBlock in DetailsPopup
const MiniField = ({ label, value, formatter = (v) => (v ?? "–"), valueClass = "" }) => (
  <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-800/50 p-3">
    <div className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">{label}</div>
    <div className={`mt-1 text-base font-semibold text-gray-900 dark:text-gray-100 ${valueClass}`}>
      {formatter(value)}
    </div>
  </div>
);



const StatTile = ({
  label,
  value,
  valueClass = "",
  formatter = (v) => v ?? "–",
}) => {
  const display =
    value === null || value === undefined || String(value).trim() === ""
      ? "–"
      : formatter(value);

  return (
    <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-800/50 p-2">
      <div className="text-[14px] text-gray-500 dark:text-gray-400">{label}</div>
      <div
        className={`text-[15px] font-semibold text-gray-900 dark:text-gray-100 ${valueClass}`}
      >
        {display}
      </div>
    </div>
  );
};

// Put this near your other helpers in Journal.jsx
function getRiskBudgetParts(details, balanceBeforeTrade) {
  const raw = details?.["Percent of Balance"];
  const totalRisk = Number(details?.["Total Risk"] ?? details?.["Risk Amount"]);
  const bbt = Number(balanceBeforeTrade);
  let pct = null, dollars = null;

  return { pct, dollars };
}




return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4 animate-fadeIn transition-all">
        <div className="bg-white dark:bg-gray-900 rounded-3xl shadow-2xl w-full max-w-5xl max-h-[90vh] flex flex-col border border-gray-200 dark:border-gray-800 overflow-hidden">
          
          {/* Header */}
          <div className="flex items-center justify-between px-8 py-5 border-b border-gray-100 dark:border-gray-800 bg-white/80 dark:bg-gray-900/80 backdrop-blur-md z-10">
            <div className="flex items-center gap-3">
              <IconGoal />
              <div>
                <h2 className="text-xl font-bold text-gray-900 dark:text-white">Trade Details</h2>
                <p className="text-xs text-gray-500 dark:text-gray-400 font-medium">#{details["Trade #"]} • {formatDateWithWeekday(details.Date)}</p>
              </div>
            </div>

            <div className="flex items-center">
              <div className="flex items-center space-x-3">
                {canViewChecklist && (
                  <button type="button" onClick={() => onViewChecklist(details)} disabled={loadingPTC} className="px-3 py-1 rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-60" title="View the pre-trade checklist recorded on this trade's date">
                    {loadingPTC ? (
                      <span className="inline-flex items-center gap-2">
                        <svg className="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24" fill="none"><circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/><path className="opacity-80" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>Loading…
                      </span>
                    ) : "Pre-Trade Checklist"}
                  </button>
                )}
                <button onClick={onPrev} disabled={!hasPrev} className="px-3 py-1 rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 disabled:opacity-50" aria-label="Previous trade" type="button">
                  ‹ Next
                </button>
              </div>
              <div className="w-px h-5 mx-3 bg-gray-200 dark:bg-gray-700" />
              <div className="flex items-center gap-2">
                <button onClick={onNext} disabled={!hasNext} className="px-3 py-1 rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 disabled:opacity-50" aria-label="Next trade" type="button">
                  Prev ›
                </button>
                <button onClick={onClose} className="text-3xl text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition" aria-label="Close" type="button">
                  &times;
                </button>
              </div>
            </div>
          </div>

          {/* Scrollable Body - NEW GRID LAYOUT */}
          <div className="flex-1 overflow-y-auto p-8 custom-scroll bg-gray-50/30 dark:bg-black/20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              
              {/* ROW 1: General (Full Width) */}
                            <div className="lg:col-span-2 bg-white dark:bg-gray-800 p-5 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm text-[15px] md:text-[16px]">
                              <h3 className="text-sm font-bold text-blue-600 dark:text-blue-400 mb-4 uppercase tracking-wide">General</h3>
                              
                              <div className="space-y-4">

                                {/* Product, Position, and Size on the same row */}
                                <div className="grid grid-cols-3 gap-4">
                                  <StatTile label="Product" value={details.Product} formatter={formatProduct} />
                                  <StatTile label="Position" value={details.Position} />
                                  <StatTile label="Size" value={details.Size} />
                                </div>

                                {/* Options specific fields (if applicable) adjusted for full-width */}
                                {isOptionsAccount && (
                                  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-4 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-100 dark:border-blue-800">
                                    <StatTile label="Type" value={details["Option Type"]} />
                                    <StatTile label="Strike" value={details["Strike"]} />
                                    <StatTile label="Expiration" value={details["Expiration"]} />
                                    <StatTile label="Delta" value={details["Delta"]} />
                                    <div className="col-span-2 lg:col-span-4 mt-2">
                                      <StatTile label="Underlying Stock Entry" value={details["Underlying Entry Price"]} formatter={formatCurrency} />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

              {/* ROW 2 - LEFT: Execution & Strategy */}
              <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm">
                <h3 className="text-sm font-bold text-purple-600 dark:text-purple-400 mb-4 uppercase tracking-wide">Execution & Strategy</h3>
                <div className="grid grid-cols-2 gap-2 mb-2">
                  <StatTile label="Entry Time" value={details["Entry Time"]} formatter={formatTimeWithAmPm} />
                  <StatTile label="Exit Time"  value={details["Exit Time"]}  formatter={formatTimeWithAmPm} />
                </div>
                <div className="grid grid-cols-2 gap-2 mb-2">
                  <StatTile label={isOptionsTrade ? "Entry Premium" : "Entry Price"} value={isOptionsTrade && details["Entry Price"] ? Number(details["Entry Price"]).toFixed(2) : (details["Entry Price"] || "—")} />
                  <StatTile label={isOptionsTrade ? "Exit Premium" : "Exit Price"}  value={isOptionsTrade && details["Exit Price"] ? Number(details["Exit Price"]).toFixed(2) : (details["Exit Price"] || "—")} />
                </div>
                <div className="grid grid-cols-2 gap-2 my-2">
                  <StatTile label="Duration" value={formatDuration(details["Duration"] || details["Duration (h:mm)"])} />
                  <StatTile label="Timeframe" value={details["Timeframe"]} />
                </div>
                <div className="grid grid-cols-2 gap-2 mt-2">
                  <StatTile label="Entry Strategy" value={details["Entry Strategy"]} />
                  <StatTile label="Exit Strategy"  value={details["Exit Strategy"]} />
                </div>
              </div>

              {/* ROW 2 - RIGHT: Performance */}
              <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm">
                <h3 className="text-sm font-bold text-blue-600 dark:text-blue-400 mb-4 uppercase tracking-wide">Performance</h3>
                <div className="grid grid-cols-2 gap-2 my-2">
                  <StatTile label="Result" value={resultValue} valueClass={resultClass} />
                  <StatTile label={perfLabel} value={perfValue} valueClass={Number(perfValue) < 0 ? "text-red-600 dark:text-red-400" : ""} />
                </div>
                <div className="grid grid-cols-2 gap-2 my-2">
                  <StatTile label="Target Reached" value={details["Target Reached"] === "TRUE" || details["Target Reached"] === true ? "Yes" : "No"} />
                  <StatTile label="Balance Before Trade" value={isPrivacyMode ? "******" : formatCurrency(balanceBeforeTrade)} formatter={(v) => v} />
                </div>
                <div className="grid grid-cols-2 gap-2 my-2">
                  <StatTile label="Balance Before Trade" value={isPrivacyMode ? "******" : formatCurrency(balanceBeforeTrade)} formatter={(v) => v} />
                  <StatTile label="Actual Balance" value={isPrivacyMode ? "******" : formatCurrency(details["Actual Balance"])} formatter={(v) => v} />
                </div>
                <div className="grid grid-cols-2 gap-2 mt-2">
                  <StatTile label="% Growth" value={isPrivacyMode ? "******" : (details["Actual Percent Growth"] ?? details["% Growth"])} valueClass={isPrivacyMode ? "text-gray-500" : growthClass} formatter={isPrivacyMode ? (v) => v : formatPercent} />
                  <StatTile label="Actual Reward" value={isPrivacyMode ? "******" : formatCurrency(details["Actual Reward"])} valueClass={Number(details["Actual Reward"]) < 0 ? "text-red-600 dark:text-red-400" : ""} />
                </div>
              </div>

              {/* ROW 3 - LEFT: Risk */}
              <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm">
                <h3 className="text-sm font-bold text-purple-600 dark:text-purple-400 mb-4 uppercase tracking-wide">Risk</h3>
                <div className="grid grid-cols-1 gap-2 mb-2">
                  {(() => {
                    const rawSLTP = details["Stop Loss_Take Profit"] || "";
                    const idealVal = details["IdealSL"];
                    let displayVal = rawSLTP;
                    let displayLabel = "SL / TP";
                    if (idealVal && Number(idealVal) !== 0) {
                      displayLabel = "SL / Ideal SL / TP";
                      if (rawSLTP.includes("/")) {
                        const [sl, tp] = rawSLTP.split("/");
                        displayVal = `${sl} (Actual) / ${idealVal} (Ideal) / ${tp}`;
                      } else if (rawSLTP) {
                        displayVal = `${rawSLTP} (Actual) / ${idealVal} (Ideal)`;
                      } else {
                        displayVal = `${idealVal} (Ideal SL)`;
                      }
                    }
                    return <StatTile label={displayLabel} value={displayVal} />;
                  })()}
                </div>
                <div className="grid grid-cols-2 gap-2 mb-2 mt-2">
                  <StatTile label="Reward / Risk" value={details["Actual Risk to Reward"]} valueClass={rrClass} />
                  <StatTile label="Planned Risk ($)" value={isPrivacyMode ? "******" : totalRisk} formatter={isPrivacyMode ? (v) => v : formatCurrency} />
                </div>
                <div className="grid grid-cols-2 gap-2 mb-2">
                  <StatTile label="Actual Risk Budget ($)" value={isPrivacyMode ? "******" : actualRiskValue} formatter={isPrivacyMode ? (v) => v : formatCurrency} />
                </div>
              </div>

              {/* ROW 3 - RIGHT: Review */}
              <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm">
                <h3 className="text-sm font-bold text-orange-600 dark:text-orange-400 mb-4 uppercase tracking-wide">Review</h3>
                <div className="grid grid-cols-2 gap-2 mb-2">
                  <StatTile label="Followed Rules?" value={details["Did I follow my Rules?"]} />
                  <StatTile label="Grade" value={details.Grade} />
                </div>
                {!isBacktesting && (
                  <div className="grid grid-cols-1 gap-2 mt-2">
                    <StatTile label="Mood / Mindset" value={details.Mood_Mindset} />
                  </div>
                )}
                <div className="flex justify-between items-start mb-4 mt-4">

                  {(details["Needs Review"] === "TRUE" || details["Needs Review"] === true) && (
                    <span className="flex items-center gap-1 bg-red-100 text-red-700 dark:bg-red-900/50 dark:text-red-400 text-xs font-bold px-2 py-1 rounded-md">
                      🚩 Needs Review
                    </span>
                  )}
              </div>
              </div>


                
                


              {/* ROW 4: Notes & Analysis (Full Width) */}
              <div className="lg:col-span-2 bg-white dark:bg-gray-900/70 p-4 rounded-xl border border-gray-200/80 dark:border-gray-700/50">
                <details className="group">
                  <summary className="cursor-pointer list-none flex items-center justify-between">
                    <h4 className="text-[15px] font-semibold text-blue-700 dark:text-blue-400">Notes & Analysis</h4>
                    <span className="text-xs text-gray-500 group-open:hidden">expand</span>
                    <span className="text-xs text-gray-500 hidden group-open:inline">collapse</span>
                  </summary>

                  <div className="mt-3 space-y-3">
                    <div className="bg-gray-100 dark:bg-gray-800/50 rounded-lg p-2 text-[13px] text-gray-800 dark:text-gray-200 whitespace-pre-wrap">
                      {details.Notes ? details.Notes : <span className="text-gray-500">No Notes provided.</span>}
                    </div>
                    <div className="bg-gray-100 dark:bg-gray-800/50 rounded-lg p-2 text-[13px] text-gray-800 dark:text-gray-200 whitespace-pre-wrap">
                      {details.Lesson ? details.Lesson : <span className="text-gray-500">No Lesson provided.</span>}
                    </div>

                    {/* NEW: Emotional Notes */}
                    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/50 rounded-lg p-2 text-[13px] text-gray-800 dark:text-gray-200 whitespace-pre-wrap">
                      <span className="block text-[10px] font-bold uppercase text-blue-500 mb-1">Emotional Notes</span>
                      {details["Emotional Notes"] ? details["Emotional Notes"] : <span className="text-gray-500 italic">No Emotional Notes provided.</span>}
                    </div>

                    {/* Link */}
                    <div className="text-[13px]">
                      {firstUrl ? (
                        <a href={firstUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline break-all">
                          {firstUrl}
                        </a>
                      ) : (
                        <span className="text-gray-500">No link provided.</span>
                      )}
                    </div>

                    {/* Screenshot Preview */}
                    {firstUrl && (
                      <div className="w-full relative min-h-[100px]"> 
                        {imgLoading && <ImgLoader />}
                        {previewUrl && !imgFailed ? (
                          <img src={previewUrl} alt={`Screenshot for Trade #${details?.["Trade #"] ?? ""}`} className="w-full max-h-[32rem] object-contain rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 select-none" loading="eager" draggable={false} referrerPolicy="no-referrer" crossOrigin="anonymous" style={{ display: imgLoading ? "none" : "block" }} onLoad={() => setImgLoading(false)} onError={() => { const next = candidateIdx + 1; if (next < candidates.length) { setImgLoading(true); setCandidateIdx(next); } else { setImgFailed(true); } }} />
                        ) : imgFailed && fallbackUrl && !fallbackFailed ? (
                          <img src={fallbackUrl} alt="Link screenshot preview" className="w-full max-h-[32rem] object-contain rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 select-none" loading="eager" draggable={false} referrerPolicy="no-referrer" style={{ display: imgLoading ? "none" : "block" }} onLoad={() => setImgLoading(false)} onError={() => { setImgLoading(false); setFallbackFailed(true); }} />
                        ) : (
                          !imgLoading && <span className="text-gray-500 text-[13px]">No preview available.</span>
                        )}
                      </div>
                    )}
                  </div>
                  </details>
                </div>

            </div>
          </div>
        </div>
      </div>
    ); // <-- This is the end of the return statement
} // <--- ADD THIS MISSING BRACE HERE



// ========== EDIT MODAL (Redesigned + Favorites Restored) ==========
function EditJournalModal({ open, onClose, row, rowIndex, onSave, accountType, userId, onPrev, onNext, hasPrev, hasNext, isPropAcct, maxLossLimit, isPropEval, isBacktesting, settings, isPrivacyMode }) {
    const [values, setValues] = useState({});
    const entryTimeRef = useRef();
    const exitTimeRef = useRef();
    const [statusMsg, setStatusMsg] = useState("");


    
    // --- Favorites Logic Restored ---
    const [userFavorites, setUserFavorites] = useState({ futures: [], forex: [] });

    
    // Fetch favorites from Firestore
    useEffect(() => {
      if (!userId) return;
      const ref = doc(db, "users", userId, "settings", "userSettings");
      const unsub = onSnapshot(ref, snap => {
        const favs = snap.exists() ? (snap.data().favorites || { futures: [], forex: [] }) 
                                   : { futures: [], forex: [] };
        setUserFavorites(favs);
      });
      return unsub;
    }, [userId]);


    // --- INSIDE EditJournalModal ---

    // 1. Get the account type from the ROW (not 'details')
    const rowType = (row?.["Account Type"] || "").toLowerCase();

    // 2. Define account flags
    const isMixed = (accountType === "mixed");
    const isStock = accountType === "stock" || (accountType === "mixed" && rowType.includes("stock"));
    
    // [!code highlight] FIXED: Use 'rowType' and 'row', NOT 'rowAccountType' or 'details'
    const isOptions = (accountType === "options") || rowType.includes("option");

    // 3. Keep existing logic for Forex/Futures
    const productNorm = normalizeProductValue(row?.["Product"]);
    const looksLikeForex = FOREX_VALUES.has(productNorm) || 
                       /^[A-Z]{3}\/[A-Z]{3}$/.test(productNorm) || 
                       /^[A-Z]{6}$/.test(productNorm);

    const isForex = (accountType === "forex" || (accountType !== "mixed" && accountType !== "futures" && accountType !== "stock" && !isOptions)) 
                  || (accountType === "mixed" && (rowType.includes("forex") || looksLikeForex));

    const isFutures = accountType === "futures" || (accountType === "mixed" && !isStock && !isForex && !isOptions);




    // Helper to determine which field to bind to (Ticks vs Pips)
        // For Mixed accounts, we check if the product looks like Forex.
        const getQtyKey = (prod) => {
            if (isOptions || isStock || isFutures) return "Ticks"; 
            if (isForex) return "Pips";
            
            // Mixed logic: Guess based on product symbol
            const p = normalizeProductValue(prod);
            if (FOREX_VALUES.has(p)) return "Pips"; 
            return "Ticks"; // Default to Ticks for futures/stocks in a mixed account
        };

    const currentQtyKey = getQtyKey(values["Product"]);
    const qtyLabel = (isOptions || isStock) ? "Points" : isFutures ? "Ticks" : isMixed ? "Units" : "Pips";

    // --- ADD THIS NEW AUTO-CALCULATION BLOCK ---
    const entryPrice = values["Entry Price"];
    const exitPrice = values["Exit Price"];
    const isLoss = values["Loss"];
    const product = values["Product"];

    useEffect(() => {
        const e = Number(entryPrice);
        const x = Number(exitPrice);

        if (e > 0 && x > 0) {
            const diff = Math.abs(x - e);
            let finalTicks = diff;
            let finalPips = diff;

            if (isForex) {
                const p = String(product).toUpperCase();
                let pipSize = 0.0001;
                const isIdx = ["US30", "NAS100", "SPX500", "GER30", "UK100"].some(idx => p.includes(idx));
                
                if (p.includes("JPY") || p.includes("XAU") || p.includes("GOLD") || p.includes("XAG") || p.includes("SILVER")) pipSize = 0.01;
                else if (isIdx) pipSize = 1;
                
                const rawPips = diff / pipSize;
                
                if (isIdx) {
                    finalPips = rawPips * 10;   // US30: 100 Points -> 1000 Pips
                    finalTicks = rawPips * 100; // US30: 100 Points -> 10000 Ticks
                } else {
                    finalPips = rawPips;        
                    finalTicks = rawPips * 10;  
                }

            } else if (isFutures) {
                const sym = String(product).split(" - ")[0].split("·")[0].trim().toUpperCase();
                const TICK_SIZES = {
                    YM: 1, MYM: 1, ES: 0.25, MES: 0.25, NQ: 0.25, MNQ: 0.25,
                    RTY: 0.1, M2K: 0.1, GC: 0.1, MGC: 0.1, CL: 0.01, MCL: 0.01,
                    NG: 0.001, MNG: 0.001, SI: 0.005, SIL: 0.005, BTC: 5, MBT: 5,
                };
                const tickSize = TICK_SIZES[sym] || 0.25;
                finalTicks = diff / tickSize;
                finalPips = finalTicks; 
            } else {
                // Stocks / Options
                finalTicks = diff;
                finalPips = diff; 
            }

            // Formatting logic
            if (isOptions || isStock) {
                finalTicks = isLoss ? -diff : diff;
                finalPips = isLoss ? -diff : diff;
                finalTicks = Number(finalTicks.toFixed(2));
                finalPips = Number(finalPips.toFixed(2));
            } else {
                finalTicks = isLoss ? -Math.round(finalTicks) : Math.round(finalTicks);
                finalPips = isLoss ? -Math.round(finalPips * 100)/100 : Math.round(finalPips * 100)/100;
            }

            setValues(prev => {
                if (prev.Ticks === finalTicks && prev.Pips === finalPips) return prev;
                return { ...prev, Ticks: finalTicks, Pips: finalPips };
            });
        }
    }, [entryPrice, exitPrice, isLoss, product, isForex, isFutures, isOptions, isStock]);
    // --- END NEW AUTO-CALCULATION BLOCK ---



    // Helper to filter options into Favorites vs Others
    const { favOpts, nonFavOpts } = useMemo(() => {
        const allOpts = isFutures ? FUTURES_PRODUCTS : FOREX_PAIRS;
        const favList = isFutures ? (userFavorites?.futures || []) : (userFavorites?.forex || []);
        
        // Normalize favorites for comparison
        const favSet = new Set(favList.map(v => {
            // If future, match code (e.g. "YM"). If forex, match full pair (e.g. "EURUSD")
            return isFutures ? futuresCodeOf(v) : String(Array.isArray(v) ? v[0] : v).toUpperCase();
        }));

        const fav = [];
        const non = [];

        for (const [val, label] of allOpts) {
            const checkVal = isFutures ? futuresCodeOf(val) : String(val).toUpperCase();
            if (favSet.has(checkVal)) {
                fav.push([val, label]);
            } else {
                non.push([val, label]);
            }
        }
        return { favOpts: fav, nonFavOpts: non };
    }, [isFutures, userFavorites, FUTURES_PRODUCTS, FOREX_PAIRS]);

    
    useEffect(() => {
        if (row) {
            const initialValues = {};
            EDITABLE_FIELDS.forEach(([field]) => {
                initialValues[field] = row[field] ?? '';
            });
            
            // ADD THIS: Combine Ticks and Pips so they don't overwrite each other with blanks
            const sharedQty = row["Movement"] ?? row["Ticks"] ?? row["Pips"] ?? row["Points"] ?? '';
            initialValues["Pips"] = sharedQty;
            initialValues["Ticks"] = sharedQty;
            
            initialValues["Win"] = row["Win"] === "TRUE" || row["Win"] === true;
            initialValues["Loss"] = row["Loss"] === "TRUE" || row["Loss"] === true;
            initialValues["Needs Review"] = row["Needs Review"] === "TRUE" || row["Needs Review"] === true;
            initialValues["Product"] = normalizeProductValue(row["Product"]);
            initialValues["Links_Screenshots"] = row["Links_Screenshots"] ?? row.link_screenshot ?? "";
            setValues(initialValues);
        }
    }, [row, open]);

    function handleChange(label, value) {
        setValues(v => ({ ...v, [label]: value }));
    }

    async function handleSubmit(e) {
        e.preventDefault();
        if (!row) return;

        const updatedRowData = { ...row, ...values };
        
        if (typeof values["Links_Screenshots"] !== "undefined") {
          updatedRowData["Links_Screenshots"] = values["Links_Screenshots"];
          updatedRowData["link_screenshot"]   = values["Links_Screenshots"];
        }
        const num = (v) => {
            const s = String(v ?? "").replace(/[^\d.-]/g,"");
            if (s === "") return NaN;
            const n = Number(s);
            return Number.isFinite(n) ? n : NaN;
        };
        const newBalance = num(values["Actual Balance"]);
        let bbt = num(row["Balance Before Trade"]);
        if (isNaN(bbt)) {
            const originalBalance = num(row["Actual Balance"]);
            const originalReward = num(row["Actual Reward"]);
            if (!isNaN(originalBalance) && !isNaN(originalReward)) {
                bbt = originalBalance - originalReward;
            }
        }
        const totalRisk = num(values["Total Risk"] ?? row["Total Risk"] ?? row["Risk Amount"]);
        if (!isNaN(newBalance) && !isNaN(bbt) && newBalance !== num(row["Actual Balance"])) {
            const actualReward = newBalance - bbt;
            updatedRowData["Actual Reward"] = actualReward.toFixed(2);
            updatedRowData["Win"] = actualReward > 0 ? "TRUE" : "FALSE";
            updatedRowData["Loss"] = actualReward < 0 ? "TRUE" : "FALSE";
            
            const mllAbs = Math.abs(Number(maxLossLimit ?? 0));
            let baseBalance;
            if (isPropEval) baseBalance = Math.max(1, bbt - mllAbs);
            else baseBalance = (Number.isFinite(bbt) && bbt !== 0) ? bbt : 1;
            
            const percentGrowth = (actualReward / baseBalance) * 100;
            updatedRowData["Actual Percent Growth"] = `${percentGrowth.toFixed(2)}%`;

            if (!isNaN(totalRisk) && totalRisk !== 0) {
                const rr = actualReward / totalRisk;
                updatedRowData["Actual Risk to Reward"] = `${rr.toFixed(2)}:1`;
            } else {
                updatedRowData["Actual Risk to Reward"] = "";
            }
            updatedRowData["Balance Before Trade"] = bbt; 
        } else {
            updatedRowData["Win"] = values.Win ? "TRUE" : "FALSE";
            updatedRowData["Loss"] = values.Loss ? "TRUE" : "FALSE";
        }
        updatedRowData["Needs Review"] = values["Needs Review"] ? "TRUE" : "FALSE";
        const durHMS = computeDurationHMS(values["Entry Time"], values["Exit Time"]);
        if (durHMS) {
            updatedRowData["Duration"] = durHMS;
            const [dh, dm] = durHMS.split(":");
            updatedRowData["Duration (h:mm)"] = `${dh}:${dm}`;
        }
        const pos = String(updatedRowData["Position"] || "").trim().toLowerCase();
        if (pos === "did not take") {
            updatedRowData["Win"] = "FALSE";
            updatedRowData["Loss"] = "FALSE";
            updatedRowData["Actual Reward"] = "";
            const bbt = Number(row["Balance Before Trade"]);
            if (Number.isFinite(bbt)) updatedRowData["Actual Balance"] = bbt;
            else delete updatedRowData["Actual Balance"];
        }

        await onSave(rowIndex, updatedRowData);
        setStatusMsg("Saved!");
        setTimeout(() => setStatusMsg(""), 2000);
    }

    if (!open || !row) return null;

    const Label = ({ children, required }) => (
      <label className="block text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-1.5 ml-1">
        {children} {required && <span className="text-red-500">*</span>}
      </label>
    );

    const inputClass = "w-full px-4 py-2.5 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 outline-none transition-all text-sm font-medium text-gray-900 dark:text-gray-100 placeholder:text-gray-400";

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4 animate-fadeIn">
         <form
           className="bg-white dark:bg-gray-900 rounded-3xl shadow-2xl w-full max-w-7xl max-h-[90vh] flex flex-col border border-gray-200 dark:border-gray-800 overflow-hidden"
           onSubmit={handleSubmit}
         >
            {/* Header */}
            <div className="flex items-center justify-between px-8 py-5 border-b border-gray-100 dark:border-gray-800 bg-white/80 dark:bg-gray-900/80 backdrop-blur-md z-10">
              <div className="flex items-center gap-3">
                <IconGoal />
                <div>
                  <h2 className="text-xl font-bold text-gray-900 dark:text-white">Edit Trade</h2>
                  <p className="text-xs text-gray-500 dark:text-gray-400 font-medium">#{row["Trade #"]} • {formatDateWithWeekday(values["Date"])}</p>
                </div>
              </div>
              
              <div className="flex items-center gap-2">
                <button type="button" onClick={onPrev} disabled={!hasPrev} className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-30 transition">
                  <FaArrowLeft className="text-gray-600 dark:text-gray-300" />
                </button>
                <button type="button" onClick={onNext} disabled={!hasNext} className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-30 transition">
                  <FaArrowLeft className="rotate-180 text-gray-600 dark:text-gray-300" />
                </button>
                <div className="w-px h-6 bg-gray-200 dark:bg-gray-700 mx-2"></div>
                <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 text-2xl leading-none">&times;</button>
              </div>
            </div>

            {/* Scrollable Body */}
            <div className="flex-1 overflow-y-auto p-8 custom-scroll bg-gray-50/30 dark:bg-black/20">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
                    
                    {/* LEFT COLUMN: Core Outcome (4 cols) */}
                    <div className="lg:col-span-4 space-y-6">
                        <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm">
                           <h3 className="text-sm font-bold text-blue-600 dark:text-blue-400 mb-4 uppercase tracking-wide">Outcome</h3>
                           
                           {/* Balance & Reward */}
                           <div className="grid grid-cols-2 gap-4 mb-4">
                             <div>
                               <Label required>New Balance</Label>
                               <div className="relative">
                                 <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-medium">$</span>
                                 <input 
                                     type={isPrivacyMode ? "password" : "number"} 
                                     step={isPrivacyMode ? undefined : "0.01"} 
                                     className={`${inputClass} pl-8 font-bold text-lg`} 
                                     value={values["Actual Balance"] || ""} 
                                     onChange={e => handleChange("Actual Balance", e.target.value)} 
                                   />
                               </div>
                             </div>
                             <div>
                               <Label>Actual Reward</Label>
                               <div className="relative">
                                 <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-medium">$</span>
                                 <input 
                                     type={isPrivacyMode ? "password" : "number"} 
                                     step={isPrivacyMode ? undefined : "0.01"} 
                                     className={`${inputClass} pl-8 font-bold text-lg`} 
                                     value={values["Actual Reward"] || ""} 
                                     onChange={e => handleChange("Actual Reward", e.target.value)} 
                                   />
                               </div>
                             </div>
                           </div>

                           {/* Win/Loss Toggle */}
                           <div className="grid grid-cols-2 gap-3 p-1 bg-gray-100 dark:bg-gray-900 rounded-xl mb-4">
                              <button
                                type="button"
                                onClick={() => { handleChange("Win", true); handleChange("Loss", false); }}
                                className={`py-2 rounded-lg text-sm font-bold transition-all ${
                                  values["Win"] 
                                    ? "bg-green-500 text-white shadow-md" 
                                    : "text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
                                }`}
                              >
                                WIN
                              </button>
                              <button
                                type="button"
                                onClick={() => { handleChange("Win", false); handleChange("Loss", true); }}
                                className={`py-2 rounded-lg text-sm font-bold transition-all ${
                                  values["Loss"] 
                                    ? "bg-red-500 text-white shadow-md" 
                                    : "text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
                                }`}
                              >
                                LOSS
                              </button>
                           </div>

                           {/* NEW: Target Reached Toggle */}
                           <div className="mb-4 flex items-center gap-3 bg-green-50 dark:bg-green-900/20 p-3 rounded-xl border border-green-100 dark:border-green-800">
                               <input 
                                   type="checkbox" 
                                   id="editTargetReached" 
                                   checked={values["Target Reached"] || false} 
                                   onChange={e => handleChange("Target Reached", e.target.checked)} 
                                   className="w-5 h-5 text-green-600 rounded border-gray-300 focus:ring-green-500 cursor-pointer" 
                               />
                               <label htmlFor="editTargetReached" className="text-sm font-bold text-green-700 dark:text-green-400 cursor-pointer">
                                   Target Reached?
                               </label>
                           </div>

                           {/* Date & Session */}
                           <div className="grid grid-cols-2 gap-4">
                              <div>
                                <Label>Date</Label>
                                <input type="date" className={inputClass} value={toYYYYMMDD(values["Date"])} onChange={e => handleChange("Date", e.target.value)} />
                              </div>
                              {!settings?.["Hide Session"] && (
                                <div>
                                  <Label>Session</Label>
                                  <select className={inputClass} value={values["Session"] || ""} onChange={e => handleChange("Session", e.target.value)}>
                                    <option value="">Select</option>
                                    {SESSION_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                  </select>
                                </div>
                              )}
                           </div>
                        </div>

                        {/* Product Info Block */}
                        <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm">
                           <h3 className="text-sm font-bold text-blue-600 dark:text-blue-400 mb-4 uppercase tracking-wide">Setup</h3>
                           <div className="space-y-4">
                              <div>
                                <Label required>Product</Label>
                                {/* [!code highlight] UPDATED PRODUCT LOGIC */}
                                {isStock || isOptions ? (
                                  <input 
                                    type="text" 
                                    className={inputClass} 
                                    value={values["Product"] || ""} 
                                    onChange={e => handleChange("Product", e.target.value)} 
                                    placeholder={isOptions ? "e.g. SPY 500C" : "e.g. AAPL"}
                                  />
                                ) : (
                                  <select className={inputClass} value={values["Product"] || ""} onChange={e => handleChange("Product", e.target.value)}>
                                    <option value="">Select Product</option>
                                    {/* ... existing favorites logic ... */}
                                    {favOpts.length > 0 && (
                                      <optgroup label="♥ Favorites">
                                        {favOpts.map(([v, l]) => (
                                          <option key={v} value={isFutures ? futuresCodeOf(v) : v}>{l}</option>
                                        ))}
                                      </optgroup>
                                    )}
                                    <optgroup label={isFutures ? "All Futures" : "All Forex"}>
                                      {nonFavOpts.map(([v, l]) => (
                                         <option key={v} value={isFutures ? futuresCodeOf(v) : v}>{l}</option>
                                      ))}
                                    </optgroup>
                                  </select>
                                )}
                              </div>

                              {/* [!code ++] NEW OPTIONS FIELDS */}
                                                            {isOptions && (
                                                              <div className="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-100 dark:border-blue-800 space-y-3">
                                                                  <div className="grid grid-cols-2 gap-3">
                                                                      <div>
                                                                          <Label>Option Type</Label>
                                                                          <select className={inputClass} value={values["Option Type"] || "Call"} onChange={e => handleChange("Option Type", e.target.value)}>
                                                                              <option value="Call">Call</option>
                                                                              <option value="Put">Put</option>
                                                                          </select>
                                                                      </div>
                                                                      <div>
                                                                          <Label>Strike</Label>
                                                                          <input type="text" className={inputClass} value={values["Strike"] || ""} onChange={e => handleChange("Strike", e.target.value)} placeholder="e.g. 450" />
                                                                      </div>
                                                                  </div>
                                                                  <div className="grid grid-cols-2 gap-3">
                                                                      <div>
                                                                          <Label>Expiration</Label>
                                                                          <input type="date" className={inputClass} value={values["Expiration"] || ""} onChange={e => handleChange("Expiration", e.target.value)} />
                                                                      </div>
                                                                      <div>
                                                                          <Label>Delta</Label>
                                                                          <input type="number" step="0.01" className={inputClass} value={values["Delta"] || ""} onChange={e => handleChange("Delta", e.target.value)} placeholder="0.50" />
                                                                      </div>
                                                                  </div>
                                                                  <div>
                                                                      <Label>Underlying Entry Price</Label>
                                                                      <input type="number" step="0.01" className={inputClass} value={values["Underlying Entry Price"] || ""} onChange={e => handleChange("Underlying Entry Price", e.target.value)} placeholder="Stock price at entry" />
                                                                  </div>
                                                              </div>
                                                            )}

                              <div className="grid grid-cols-2 gap-4">
                                 <div>
                                   <Label>Position</Label>
                                   <select 
                                               className={inputClass} 
                                               value={values["Position"] || ""} 
                                               onChange={e => handleChange("Position", e.target.value)}
                                           >
                                               {/* ADD THIS LINE BELOW */}
                                               <option value="">Select</option> 
                                               {POSITION_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                           </select>
                                 </div>
                                 <div>
                                   <Label>{isForex ? "Lot Size" : "Contracts"}</Label>
                                   <input type="number" className={inputClass} value={values["Size"] || ""} onChange={e => handleChange("Size", e.target.value)} />
                                 </div>
                              </div>
                              <div>
                                <Label>Timeframe</Label>
                                <input type="text" list="tf-options" className={inputClass} value={values["Timeframe"] || ""} onChange={e => handleChange("Timeframe", e.target.value)} />
                                <datalist id="tf-options">{TIMEFRAME_OPTIONS.map(t => <option key={t} value={t} />)}</datalist>
                              </div>
                           </div>
                        </div>
                    </div>

                    {/* MIDDLE COLUMN: Execution (4 cols) */}
                    <div className="lg:col-span-4 space-y-6">
                        <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm h-full">
                           <h3 className="text-sm font-bold text-purple-600 dark:text-purple-400 mb-4 uppercase tracking-wide">Execution Details</h3>
                           
                           {/* Entry Group */}
                           <div className="p-4 bg-gray-50 dark:bg-gray-700/30 rounded-xl mb-4 border border-gray-100 dark:border-gray-700">
                              <div className="text-xs font-bold text-gray-400 uppercase mb-3">Entry</div>
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                <div className="relative">
                                  <Label>Entry Time</Label>

                                 <input
                                   ref={entryTimeRef}
                                   type="time"
                                   step="60"
                                   className={`${inputClass} pr-10`}
                                   value={toHHMM(to24HourTime(values["Entry Time"]))}
                                   onChange={(e) => {
                                     const rawTime24 = e.target.value;
                                     const hhmm = toHHMM(rawTime24);
                                     
                                     // Use setValues directly so we can check the previous state
                                     setValues(prev => {
                                       const nextState = { ...prev, "Entry Time": toAmPm(hhmm) };
                                       
                                       // Auto-populate Session only if it is currently empty
                                       if (!prev["Session"] || prev["Session"] === "") {
                                         const calculatedSession = getSessionFromTime(rawTime24);
                                         if (calculatedSession) {
                                           nextState["Session"] = calculatedSession;
                                         }
                                       }
                                       
                                       return nextState;
                                     });
                                   }}
                                 />

                                  <FaRegClock
                                    className="absolute right-3 top-9 text-lg text-gray-400 cursor-pointer hover:text-blue-500"
                                    onClick={() => {
                                      if (entryTimeRef.current?.showPicker) {
                                        entryTimeRef.current.showPicker();
                                      } else {
                                        entryTimeRef.current?.focus();
                                      }
                                    }}
                                  />
                                </div>

                                {!settings?.["Hide Entry Price"] && (
                                <div>
                                  <label className="block text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-1.5 ml-1 flex items-center gap-1">
                                    {isOptions ? "Entry Premium" : "Entry Price"}
                                    {isOptions && (
                                      <Tooltip text="Enter the option contract premium here, not the underlying stock price." />
                                    )}
                                  </label>
                                  <input 
                                    type="number" 
                                    step="0.01"
                                    placeholder={isOptions ? "e.g. 2.50" : ""} 
                                    value={values["Entry Price"] || ""} 
                                    onChange={e => handleChange("Entry Price", e.target.value)} 
                                    className={inputClass}
                                  />
                                </div>
                                )}
                              </div>
                              {!settings?.["Hide Entry Strategy"] && (
                                <div>
                                   <Label>Strategy</Label>
                                   <input type="text" className={inputClass} value={values["Entry Strategy"] || ""} onChange={e => handleChange("Entry Strategy", e.target.value)} />
                                </div>
                              )}
                           </div>

                           {/* Exit Group */}
                           <div className="p-4 bg-gray-50 dark:bg-gray-700/30 rounded-xl border border-gray-100 dark:border-gray-700">
                              <div className="text-xs font-bold text-gray-400 uppercase mb-3">Exit</div>
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                <div className="relative">
                                  <Label>Exit Time</Label>

                                  <input
                                    ref={exitTimeRef}
                                    type="time"
                                    step="60"
                                    className={`${inputClass} pr-10`}
                                    value={toHHMM(to24HourTime(values["Exit Time"]))}
                                    onChange={(e) => {
                                      const hhmm = toHHMM(e.target.value);      // <-- important
                                      handleChange("Exit Time", toAmPm(hhmm));
                                    }}
                                  />

                                  <FaRegClock
                                    className="absolute right-3 top-9 text-lg text-gray-400 cursor-pointer hover:text-blue-500"
                                    onClick={() => {
                                      if (exitTimeRef.current?.showPicker) {
                                        exitTimeRef.current.showPicker();
                                      } else {
                                        exitTimeRef.current?.focus();
                                      }
                                    }}
                                  />
                                </div>

                                 {!settings?.["Hide Exit Price"] && (
                                <div>
                                  <label className="block text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-1.5 ml-1 flex items-center gap-1">
                                    {isOptions ? "Exit Premium" : "Exit Price"}
                                    {isOptions && (
                                      <Tooltip text="Enter the option contract premium here, not the underlying stock price." />
                                    )}
                                  </label>
                                  <input 
                                    type="number" 
                                    step="0.01"
                                    placeholder={isOptions ? "e.g. 3.10" : ""} 
                                    value={values["Exit Price"] || ""} 
                                    onChange={e => handleChange("Exit Price", e.target.value)} 
                                    className={inputClass}
                                  />
                                </div>
                                )}
                              </div>
                              {!settings?.["Hide Exit Strategy"] && (
                                <div>
                                   <Label>Strategy</Label>
                                   <input type="text" className={inputClass} value={values["Exit Strategy"] || ""} onChange={e => handleChange("Exit Strategy", e.target.value)} />
                                </div>
                              )}
                           </div>

                           {/* Metrics */}
                           <div className="mt-6 grid grid-cols-2 gap-4">
                            <div>
                                      {/* [!code highlight] Use dynamic label and key */}
                                      <Label>{qtyLabel}</Label>
                                      <input 
                                        type="number" 
                                        className={inputClass} 
                                        value={values[currentQtyKey] || ""} 
                                        onChange={e => {
                                            handleChange("Ticks", e.target.value);
                                            handleChange("Pips", e.target.value);
                                        }} 
                                      />
                                   </div>
                              {String(settings?.["Hide Potential"]) !== "true" && (
                                <div>
                                  <Label>
                                    {(isOptions || isStock) ? "Potential Points" : isForex ? "Potential Pips" : "Potential Ticks"}
                                  </Label>
                                  <input
                                    type="number"
                                    className={inputClass}
                                    value={values["Potential"] || ""}
                                    onChange={e => handleChange("Potential", e.target.value)}
                                  />
                                </div>
                              )}
                           </div>
                        </div>
                    </div>

                    {/* RIGHT COLUMN: Review & Notes (4 cols) */}
                    <div className="lg:col-span-4 space-y-6">
                      <div className="bg-white dark:bg-gray-800 p-5 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm h-full flex flex-col">
                         <h3 className="text-sm font-bold text-orange-600 dark:text-orange-400 mb-4 uppercase tracking-wide">Review</h3>
                         
                         <div className="mb-4">
                            <Label>Followed Rules?</Label>
                            <select className={inputClass} value={values["Did I follow my Rules?"] || ""} onChange={e => handleChange("Did I follow my Rules?", e.target.value)}>
                               <option value="">-</option>
                               {RULES_OPTIONS.map(v => <option key={v} value={v}>{v}</option>)}
                            </select>
                         </div>

                         <div className="grid grid-cols-2 gap-4 mb-4">
                              {!settings?.["Hide Mood"] && (
                                <div>
                                  <Label>Mood</Label>
                                  <select className={inputClass} value={values["Mood_Mindset"] || ""} onChange={e => handleChange("Mood_Mindset", e.target.value)}>
                                     <option value="">-</option>
                                     {MOOD_OPTIONS.map(v => <option key={v} value={v}>{v}</option>)}
                                  </select>
                                </div>
                              )}
                              {!settings?.["Hide Grade"] && (
                                <div>
                                  <Label>Grade</Label>
                                  <select className={inputClass} value={values["Grade"] || ""} onChange={e => handleChange("Grade", e.target.value)}>
                                     <option value="">-</option>
                                     {GRADE_OPTIONS.map(v => <option key={v} value={v}>{v}</option>)}
                                  </select>
                                </div>
                              )}
                           </div>

                           <div className="grid grid-cols-2 gap-4 mb-4">
                             {!settings?.["Hide Ideal Stop Loss"] &&  (
                               <div>
                                  <Label>Ideal SL</Label>
                                  <input type="number" className={inputClass} value={values["IdealSL"] || ""} onChange={e => handleChange("IdealSL", e.target.value)} placeholder="Ticks/Pips" />
                               </div>
                             )}
                             <div>
                                <Label>Actual SL / TP</Label>
                                <input type="text" className={inputClass} value={values["Stop Loss_Take Profit"] || ""} onChange={e => handleChange("Stop Loss_Take Profit", e.target.value)} placeholder="e.g. 1.05 / 1.06" />
                             </div>
                           </div>

                           {/* ADD THIS CHECKBOX BLOCK */}
                           <div className="mb-4 flex items-center gap-3 bg-red-50 dark:bg-red-900/20 p-3 rounded-xl border border-red-100 dark:border-red-800">
                               <input 
                                   type="checkbox" 
                                   id="needsReview" 
                                   checked={values["Needs Review"] || false} 
                                   onChange={e => handleChange("Needs Review", e.target.checked)} 
                                   className="w-5 h-5 text-red-600 rounded border-gray-300 focus:ring-red-500 cursor-pointer" 
                               />
                               <label htmlFor="needsReview" className="text-sm font-bold text-red-700 dark:text-red-400 cursor-pointer">
                                   Flag for Review
                               </label>
                           </div>

                           <div className="mb-4">
                              <Label>Link / Screenshot</Label>
                              <div className="relative">
                                <FaUpload className="absolute left-4 top-3 text-gray-400" />
                                <input type="text" className={`${inputClass} pl-10`} value={values["Links_Screenshots"] || ""} onChange={e => handleChange("Links_Screenshots", e.target.value)} placeholder="Paste URL..." />
                              </div>
                           </div>

                           <div className="space-y-4 flex-1">
                              <div>
                                <Label>Notes</Label>
                                <textarea rows={3} className={`${inputClass} resize-none`} value={values["Notes"] || ""} onChange={e => handleChange("Notes", e.target.value)} />
                              </div>

                              <div>
                                <Label>Emotional Notes</Label>
                                <textarea rows={2} className={`${inputClass} resize-none`} value={values["Emotional Notes"] || ""} onChange={e => handleChange("Emotional Notes", e.target.value)} placeholder="How were you feeling during this execution?" />
                              </div>

                              {!settings?.["Hide Lesson"] && (
                                <div>
                                  <Label>Lesson</Label>
                                  <textarea rows={3} className={`${inputClass} resize-none border-l-4 border-l-orange-300 dark:border-l-orange-500`} value={values["Lesson"] || ""} onChange={e => handleChange("Lesson", e.target.value)} placeholder="What did you learn?" />
                                </div>
                              )}
                           </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* Footer Actions */}
            <div className="px-8 py-5 border-t border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900 flex justify-end gap-3 items-center">
                {statusMsg && (
                  <span className="mr-4 text-sm font-semibold text-green-600 dark:text-green-400 animate-fadeIn">
                    <FaCheckCircle className="inline mr-1"/> {statusMsg}
                  </span>
                )}
                <button type="button" className="px-6 py-2.5 rounded-xl font-bold text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition" onClick={onClose}>
                  Close
                </button>
                <button type="submit" className="px-8 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-bold shadow-lg shadow-blue-500/20 transition transform active:scale-95">
                  Save Changes
                </button>
            </div>
         </form>
      </div>
    );
}




// --- Import helpers moved from Settings ---
const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

// Pick futures code like "YM" from "YM - US30 - $5.00"
function getProduct(val) {
  if (!val) return "";
  if (val[0] === "M") return val.slice(0, 3);
  return val.slice(0, 2);
}


function splitDateTime(iso) {
  if (!iso) return { date: "", time: "" };
  const d = new Date(iso);
  if (isNaN(d)) return { date: "", time: "" };
  const date = d.toISOString().slice(0,10);
  const time = d.toISOString().slice(11,16);
  return { date, time };
}
function calculateDuration(startIso, endIso) {
  try {
    const s = new Date(startIso).getTime();
    const e = new Date(endIso).getTime();
    if (!Number.isFinite(s) || !Number.isFinite(e) || e < s) return "";
    const secs = Math.floor((e - s) / 1000);
    const h = Math.floor(secs/3600), m = Math.floor((secs%3600)/60), ss = secs%60;
    return `${h}:${String(m).padStart(2,"0")}:${String(ss).padStart(2,"0")}`;
  } catch { return ""; }
}

function formatMMDDYYYY(val) {
  if (!val) return "";
  let date;
  if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
    // Handle YYYY-MM-DD string, respecting local timezone for display
    const [y, m, d] = val.split('-').map(Number);
    date = new Date(y, m - 1, d);
  } else if (typeof val === 'object' && val.seconds) {
    // Handle Firebase timestamp
    date = new Date(val.seconds * 1000);
  } else {
    // Handle other date strings or Date objects
    date = new Date(val);
  }

  if (isNaN(date)) return "";

  // getMonth() is 0-indexed
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  // getDate() is 1-indexed
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();
  
  return `${mm}/${dd}/${yyyy}`;
}

function formatMMDDYYYY2(val) {
  if (!val) return "";
  let date;
  if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
    const [y, m, d] = val.split('-').map(Number);
    date = new Date(y, m - 1, d);
  } else if (typeof val === 'object' && val.seconds) {
    date = new Date(val.seconds * 1000);
  } else {
    date = new Date(val);
  }

  if (isNaN(date)) return "";

  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();

  // <-- change this line
  return `${mm}/${dd}/${yyyy}`;
}

function formatDate(val) {
  if (!val) return "";
  if (typeof val === "string" && /^\d{4}-\d{2}-\d{2}/.test(val)) return val.slice(0,10);
  const d = new Date(val);
  return isNaN(d) ? "" : d.toISOString().slice(0,10);
}

// Put next to other helpers (top of file)
function requireColumns(row, columns, platformName) {
  const missing = columns.filter(c => !(c in row));
  if (missing.length) {
    throw new Error(
      `${platformName} CSV looks wrong — missing: ${missing.join(", ")}`
    );
  }
}

function buildFingerprintTopstep(r) {
  // Stable across exports for same trade
  return `topstep|${r.Id}|${r.ContractName}|${r.EnteredAt}|${r.ExitedAt}|${r.Size}|${r.PnL}`.toLowerCase();
}

function buildFingerprintTradovate(r) {
  return `tradovate|${r.buyFillId}|${r.sellFillId}|${r.symbol}|${r.qty}|${r.pnl}`.toLowerCase();
}


// Firestore helpers
async function getAccountSettings(userId, accountId) {
  const ref = doc(db, "users", userId, "accounts", accountId);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
}
async function updateAccountSettings(userId, accountId, dataToUpdate) {
  const ref = doc(db, "users", userId, "accounts", accountId);
  await updateDoc(ref, dataToUpdate);
}
async function appendTrade(userId, accountId, tradeData) {
  const ref = collection(db, "users", userId, "accounts", accountId, "journal");
  await addDoc(ref, tradeData);
}
async function fetchAllJournalRows(userId, accountId) {
  const ref = collection(db, "users", userId, "accounts", accountId, "journal");
  const snap = await getDocs(ref);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

const PLATFORMS = [
  { value: "topstep",          label: "TopStepX" },
  { value: "tradovate",        label: "Tradovate" },
  { value: "trapound",         label: "Trapound" },
  { value: "ninjatrader",      label: "NinjaTrader" },  
  { value: "tradingview",      label: "TradingView" },   
  { value: "mt4",              label: "MetaTrader 4 (.csv/.xlsx)" },
  { value: "mt5",              label: "MetaTrader 5 (.csv/.xlsx)" },
  { value: "mannysgooglesheet",label: "Manny’s Google Sheet" },
  { value: "rithmic",          label: "Rithmic" }, 
  { value: "quantower",        label: "Quantower" }, 
  { value: "oanda",            label: "OANDA" },
];


const PLATFORMS_FOREX   = PLATFORMS.filter(p =>
  ["mannysgooglesheet", "trapound", "mt4","mt5", "ninjatrader","tradingview", "rithmic", "quantower", "oanda"].includes(p.value)
);
const PLATFORMS_FUTURES = PLATFORMS.filter(p =>
  ["topstep", "tradovate", "trapound", "ninjatrader","tradingview","rithmic","quantower"].includes(p.value)
);

// Paste this code AFTER EditJournalModal, but BEFORE export default function Journal

// Paste this REPLACE the existing ImportConnectModal function in Journal.jsx

// ... (imports remain the same)

function ImportConnectModal({
  open,
  onClose,
  userId,
  accountId,
  type,
  settings,
  // TradeLocker Props
  tlEnv, setTlEnv,
  tlServer, setTlServer,
  tlEmail, setTlEmail,
  tlPass, setTlPass,
  tlEnabled, setTlEnabled,
  tlBusy, setTlBusy,
  tlMsg, setTlMsg,
  
  // --- TRADOVATE PROPS ---
  tvEnv, setTvEnv,
  tvUsername, setTvUsername,
  tvPassword, setTvPassword,
  tvDeviceId, setTvDeviceId,
  tvCid, setTvCid,
  tvSecret, setTvSecret,
  tvEnabled, setTvEnabled,
  tvBusy, setTvBusy,
  tvMsg, setTvMsg,

  setRows,
  isAdmin,  
}) {

  // 1. Toast Notification Component
     const [toast, setToast] = useState({ show: false, msg: "", type: "info" });
     
     const showToast = (msg, type = "info") => {
         setToast({ show: true, msg, type });
         setTimeout(() => setToast({ ...toast, show: false }), 3000); 
     };

     // 2. Confirmation Modal State
     const [confirmAction, setConfirmAction] = useState(null); 
   const acctResolved = React.useMemo(() => String(type || "").toLowerCase(), [type]);
   const [localAcctType, setLocalAcctType] = React.useState(type ?? null);
   const acctType = String(localAcctType || "").toLowerCase();

   const allowedPlatforms = acctType === "mixed"
  ? [
      // Combined list for Mixed accounts
      { value: "topstep",           label: "TopStepX" },
      { value: "tradovate",         label: "Tradovate" },
      { value: "trapound",          label: "Trapound" },
      { value: "mt4",               label: "MetaTrader 4 (.csv/.xlsx)" },
      { value: "mt5",               label: "MetaTrader 5 (.csv/.xlsx)" },
      { value: "mannysgooglesheet", label: "Manny’s Google Sheet" },
      { value: "ninjatrader",       label: "NinjaTrader" },
      { value: "rithmic",           label: "Rithmic" },   
      { value: "tradingview",       label: "TradingView" }, 
      { value: "tradingview_strategy", label: "TradingView Strategy"},
      { value: "quantower",         label: "Quantower" },
      { value: "oanda",             label: "OANDA" }, 
    ]
  : acctType === "forex"
  ? [
      { value: "trapound",          label: "Trapound" },
      { value: "mt4",               label: "MetaTrader 4 (.csv/.xlsx)" },
      { value: "mt5",               label: "MetaTrader 5 (.csv/.xlsx)" },
      { value: "mannysgooglesheet", label: "Manny’s Google Sheet" },
      { value: "ninjatrader",       label: "NinjaTrader" },  
      { value: "rithmic",           label: "Rithmic" },     
      { value: "tradingview",       label: "TradingView" },   
      { value: "tradingview_strategy", label: "TradingView Strategy"},
      { value: "quantower",         label: "Quantower" },  
      { value: "oanda",             label: "OANDA" },    
    ]
  : [
      { value: "topstep",     label: "TopStepX" },
      { value: "tradovate",   label: "Tradovate" },
      { value: "trapound",    label: "Trapound" },
      { value: "ninjatrader", label: "NinjaTrader" },
      { value: "rithmic",     label: "Rithmic" },   
      { value: "tradingview", label: "TradingView" }, 
      { value: "tradingview_strategy", label: "TradingView Strategy"},
      { value: "quantower",   label: "Quantower" },               
    ];

   React.useEffect(() => {
     setLocalAcctType(type ?? null);
   }, [type]);
  
   React.useEffect(() => {
     let alive = true;
     (async () => {
       const raw = String(localAcctType || "").toLowerCase();
       if (raw === "forex" || raw === "fx" || raw === "futures") return; 
       if (!userId || !accountId) return;
       try {
        const acctDoc = await getAccountSettings(userId, accountId);
        const journalData = await fetchAllJournalRows(userId, accountId);
        const inferred = resolveAccountType((acctDoc || {}), journalData);
         if (!alive) return;
         if (inferred) setLocalAcctType(inferred);
       } catch (e) {
         console.warn("[ImportConnectModal] fallback accountType resolve failed", e);
       }
     })();
     return () => { alive = false; };
   }, [userId, accountId, localAcctType]);

  // --- INTERNAL MODAL STATE ---
  const [importTab, setImportTab] = useState("csv");
  const [connectPlatform, setConnectPlatform] = useState(() => {
      if (settings?.tradovateConnected) return "tradovate";
      return null;
  });

  const [selectedSubPlatform, setSelectedSubPlatform] = useState(null);
  const [isCheckingOanda, setIsCheckingOanda] = useState(!settings?.tradovateConnected);
  // --- SNAPTRADE STATE ---
  const [snapBusy, setSnapBusy] = useState(false);
  const [snapMsg, setSnapMsg] = useState("");
  const [snapAccounts, setSnapAccounts] = useState([]);
  const [snapPickAccId, setSnapPickAccId] = useState("");
    
  // Define Callables 
  // (These use the 'functions' imported from ../firebase at top of file)
  const snapConnectCallable = httpsCallable(functions, 'snaptradeConnect');
  const snapListAccountsCallable = httpsCallable(functions, 'snaptradeListAccounts');
  const snapSyncNowCallable = httpsCallable(functions, 'snaptradeSyncNow');
  const [activeSnapBroker, setActiveSnapBroker] = useState(null); // stores "ROBINHOOD", "WEBULL", etc.

  useEffect(() => {
      if (settings?.tradovateConnected && tvAccounts.length === 0 && !tvBusy) {
        listTvAccounts();
      }
    }, [settings?.tradovateConnected]);

  // ✅ FIX: Silent disconnect when token expires (bypasses the popup)
useEffect(() => {
  if (tvMsg.toLowerCase().includes("expired") || tvMsg.includes("401")) {
    console.log("Auto-disconnecting due to expiration...");
    
    const silentDisconnect = async () => {
      try {
        // ✅ PRESERVE the document, just disable it and clear the bad token
        await setDoc(doc(db, `users/${userId}/accounts/${accountId}/connections/tradovate`), {
            enabled: false,
            error: "Session expired. Please re-authenticate."
            // We intentionally leave selectedAccountId alone!
        }, { merge: true });
        
        await updateDoc(doc(db, `users/${userId}/accounts/${accountId}`), {
          tradovateConnected: false,
          tradovateAccessToken: deleteField(), 
          tradovateRefreshToken: deleteField(), 
          lastUpdated: new Date()
        });

          setTvAccounts([]);
          setTvPickAccId("");
          
          setConnectPlatform("tradovate");
          
        } catch (e) {
          console.error("Silent disconnect error:", e);
        }
      };

      silentDisconnect();
    }
  }, [tvMsg]);


  // ✅ AUTO-ROUTE: If Tradovate is connected, go straight to the details view
useEffect(() => {
    if (settings?.tradovateConnected) {
        setIsCheckingOanda(false);
        return;
    }
    
    // We removed the "if snapAccounts..." check here.
    
    if (userId && accountId) {
       checkOandaConnection().finally(() => {
           setIsCheckingOanda(false); 
       });
    } else {
        setIsCheckingOanda(false);
    }
}, [userId, accountId, settings?.tradovateConnected]);

  // inside ImportConnectModal in Journal.jsx



  // CSV state
  const [csvFileName, setCsvFileName] = useState("");
  const [csvRows, setCsvRows] = useState([]);
  const [csvPreview, setCsvPreview] = useState([]);
  const [csvImporting, setCsvImporting] = useState(false);
  const [csvError, setCsvError] = useState("");

  // TradeLocker & Tradovate List states
  const [tlAccounts, setTlAccounts] = useState([]);
  const [tlPickAccNum, setTlPickAccNum] = useState("");
  const [tlPickId, setTlPickId] = useState("");
  const [tvAccounts, setTvAccounts] = useState([]);
  const [tvPickAccId, setTvPickAccId] = useState("");
  const [tvAppId, setTvAppId] = useState("SampleApp");
  
  // --- FIX START: Removed the local declaration of 'functions' ---
  // const functions = getFunctions(); <--- DELETED THIS LINE
  // All callables below now use the imported 'functions' instance correctly
  const listTvAccountsCallable = httpsCallable(functions, 'tradovateListAccounts');
  const selectTvAccountCallable = httpsCallable(functions, 'tradovateUseAccount');
  const tvSyncNowCallable = httpsCallable(functions, 'tradovateSyncNow'); 
  const tvRefreshTokenCallable = httpsCallable(functions, 'tradovateRefreshToken');
  // --- FIX END ---

  const [oandaToken, setOandaToken] = useState("");
  const [oandaAccountId, setOandaAccountId] = useState("");
  const [oandaEnv, setOandaEnv] = useState("practice");
  const [oandaBusy, setOandaBusy] = useState(false);
  const [oandaMsg, setOandaMsg] = useState("");
  const [isOandaSyncing, setIsOandaSyncing] = useState(false);
  const [oandaConnected, setOandaConnected] = useState(false);


  // ✅ AUTO-DEFAULT TAB: If connected to a broker, default to the 'connect' tab when opened
  useEffect(() => {
    if (open) {
      const isConnected = 
        settings?.tradovateConnected || 
        settings?.snapTradeConnected || 
        settings?.snapBroker || 
        oandaConnected;

      if (isConnected) {
        setImportTab("connect");
      } else {
        setImportTab("csv");
      }
    }
  }, [open, settings?.tradovateConnected, settings?.snapTradeConnected, settings?.snapBroker, oandaConnected]);

  // ... (Rest of the component remains exactly the same)
  // Just ensure you copy the reset logic, checkOandaConnection, handlers, and the full return JSX from your original code.
  // The critical fix was removing that one line above.

  // Reset selection when tab changes or modal closes
  useEffect(() => {
        if (importTab === "connect") {
           if (settings?.tradovateConnected) {
               setConnectPlatform("tradovate");
           } 
           else if (oandaConnected) {
               setConnectPlatform("oanda");
           }
        }
    }, [importTab, settings?.tradovateConnected, oandaConnected]);

  // --- CHECK OANDA CONNECTION ON LOAD ---
  useEffect(() => {
    if (userId && accountId) {
       checkOandaConnection();
    }
  }, [userId, accountId]);


  async function checkOandaConnection() {
      try {
          const docRef = doc(db, `users/${userId}/accounts/${accountId}/connections/oanda`);
          const snap = await getDoc(docRef);
          if (snap.exists()) {
              const data = snap.data();
              if (data.token) {
                  setOandaConnected(true);
                  setOandaAccountId(data.accountId || ""); 
                  setOandaEnv(data.env || "practice");
                  
                  setConnectPlatform("oanda");
                  setImportTab("connect"); // <-- ADD THIS LINE
              }
          }
      } catch (e) {
          console.error("Error checking Oanda status", e);
      }
  }

  // --- TradeLocker Handlers ---
  async function onTlConnect() {
    setTlMsg("Connecting…"); setTlBusy(true);
    try {
         const { ok, message } = await tlConnectCallable({
           env: tlEnv, server: tlServer, email: tlEmail, password: tlPass, userId, accountId
         });
      setTlMsg(message || (ok ? "Connected." : "Failed."));
    } catch (e) {
      setTlMsg(e?.message || "Connect failed.");
    } finally {
      setTlBusy(false); setTlPass("");
    }
  }
  async function onTlSyncNow({ full = false } = {}) {
    try {
      setTlBusy(true);
      setTlMsg(full ? "Full resync…" : "Syncing…");
      const resp = await tlSyncNowCallable({ userId, accountId, full, env: tlEnv, server: tlServer });
      setTlMsg(resp?.message || (resp?.ok ? "Sync complete." : "Sync failed."));
      if (resp?.ok) {
        const updated = await fetchJournalRows(userId, accountId);
        setRows(updated || []);
        onClose();
      }
    } catch (e) {
      setTlMsg(e?.message || "Sync failed.");
    } finally {
      setTlBusy(false);
    }
  }
  async function listTLAccounts() {
    try {
      setTlMsg("Listing accounts…"); setTlBusy(true);
      const { ok, accounts, message } = await tlListAccountsCallable({ userId, accountId, env: tlEnv, server: tlServer });
      if (!ok) { setTlMsg(message || "Failed to list accounts."); return; }
      setTlAccounts(accounts || []);
      setTlMsg(`Found ${accounts?.length || 0} account(s).`);
    } catch (e) {
      setTlMsg(e?.message || "List accounts failed.");
    } finally {
      setTlBusy(false);
    }
  }
  async function selectTLAccount() {
    try {
      if (!tlPickAccNum || !tlPickId) { setTlMsg("Pick an account first."); return; }
      setTlMsg("Selecting account…"); setTlBusy(true);
      const { ok, message } = await tlUseAccountCallable({ userId, accountId, accNum: tlPickAccNum, tlAccountId: tlPickId });
      setTlMsg(message || (ok ? "Account set." : "Failed to set account."));
    } catch (e) {
      setTlMsg(e?.message || "Set account failed.");
    } finally {
      setTlBusy(false);
    }
  }
  async function probeTL() {
      try {
        setTlMsg("Probing…"); setTlBusy(true);
        const probe = fbCallableDebug("tradelockerDebugProbe");
        const res = await probe({ userId, accountId });
        const { ok, info, message } = (res && res.data) || {};
        if (!ok) { setTlMsg(message || "Probe failed."); return; }
        setTlMsg(`Probe: env=${info.env}, total=${info.total}, accNum=${info.accNum}, id=${info.tlAccountId}`);
      } catch (e) {
        setTlMsg(e?.message || "Probe failed.");
      } finally {
        setTlBusy(false);
      }
  }

// Update this function to accept 'brokerSlug'
async function onSnapConnect(brokerSlug = null) {
    setSnapBusy(true);
    setSnapMsg(brokerSlug ? `Connecting to ${brokerSlug}...` : "Generating connection link...");
    
    try {
        // Pass the broker slug to the backend
        const { data } = await snapConnectCallable({ userId, broker: brokerSlug });
        
        if (data.ok) {
            const width = 500;
            const height = 800;
            const left = (window.screen.width / 2) - (width / 2);
            const top = (window.screen.height / 2) - (height / 2);

            window.open(
                data.redirectURI, 
                "SnapTradeConnect", 
                `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`
            );
            setSnapMsg("Connection portal opened...");
        } else {
            setSnapMsg(data.message || "Failed to generate link.");
        }
    } catch (e) {
        console.error(e);
        setSnapMsg("Error generating link.");
    } finally {
        setSnapBusy(false);
    }
}

async function handleSnapDisconnect() {
    setConfirmAction({
        title: `Disconnect ${activeSnapBroker}?`,
        msg: `This will remove your ${activeSnapBroker} connection. You will need to link it again to sync future trades.`,
        onConfirm: async () => {
            setSnapBusy(true);
            setConfirmAction(null);
            try {
                // You will eventually call a backend function here. 
                // For now, we clear the local state for immediate feedback.
                setSnapAccounts(prev => prev.filter(acc => 
                    !acc.institution_name.toUpperCase().includes(activeSnapBroker)
                ));
                setSnapMsg(`Successfully disconnected ${activeSnapBroker}.`);
            } catch (e) {
                setSnapMsg("❌ Failed to disconnect.");
            } finally {
                setSnapBusy(false);
            }
        }
    });
}

    async function listSnapAccounts() {
      setSnapBusy(true);
      setSnapMsg("Fetching accounts...");
      try {
        const { data } = await snapListAccountsCallable({ userId, accountId });
        if (data.ok) {
          setSnapAccounts(data.accounts || []);
          if (data.accounts?.length === 0) {
              setSnapMsg("No connected accounts found. Please link a brokerage first.");
          } else {
              setSnapMsg(`Found ${data.accounts.length} account(s).`);
          }
        } else {
          setSnapMsg(data.message || "Failed to list accounts.");
        }
      } catch (e) {
        console.error(e);
        setSnapMsg("Error listing accounts.");
      } finally {
        setSnapBusy(false);
      }
    }

async function onSnapSync() {
      if (!snapPickAccId) {
          setSnapMsg("Please select an account first.");
          return;
      }
      setSnapBusy(true);
      setSnapMsg("Syncing trades...");
      try {
          const { data } = await snapSyncNowCallable({ userId, accountId, snapAccountId: snapPickAccId });
          if (data.ok) {
              setSnapMsg(`✅ Synced ${data.imported} trades!`);


              // 🟢 FIX: Infer the broker name if 'activeSnapBroker' is null
              let brokerToSave = activeSnapBroker;
              
              // If we don't know the broker yet, check the selected account's name
              if (!brokerToSave && snapAccounts.length > 0) {
                  const selectedAcc = snapAccounts.find(a => a.id === snapPickAccId);
                  if (selectedAcc) {
                     const name = selectedAcc.institution_name.toUpperCase();
                     if (name.includes("ROBINHOOD")) brokerToSave = "ROBINHOOD";
                     else if (name.includes("WEBULL")) brokerToSave = "WEBULL";
                     else if (name.includes("SCHWAB") || name.includes("CHARLES")) brokerToSave = "CHARLES_SCHWAB";
                     else brokerToSave = name; // Fallback to the raw name
                  }
              }

              try {
                const acctRef = doc(db, `users/${userId}/accounts/${accountId}`);
                await updateDoc(acctRef, {
                    snapTradeConnected: true,
                    snapBroker: brokerToSave,   // ✅ Saves "CHARLES_SCHWAB" even if you were in generic view
                    snapAccountId: snapPickAccId,
                    lastUpdated: new Date()
                });
                console.log("Connection details saved:", brokerToSave);
                
                // 🟢 Update local state immediately so the UI turns Green/Linked
                if (brokerToSave) setActiveSnapBroker(brokerToSave);

              } catch(err) {
                console.error("Failed to save connection settings:", err);
              }

          } else {
              setSnapMsg(`❌ Sync failed: ${data.message}`);
          }
      } catch (e) {
          console.error(e);
          setSnapMsg("Error syncing trades.");
      } finally {
          setSnapBusy(false);
      }
    }



const filteredSnapAccounts = useMemo(() => {
    // 🔴 CHANGE THIS LINE: 
    // Old: if (!activeSnapBroker) return [];
    // New: If no broker selected, show ALL accounts (so you can find your new connection)
    if (!activeSnapBroker) return snapAccounts;

    return snapAccounts.filter(acc => {
        const name = acc.institution_name?.toUpperCase() || "";
        
        // Strict Broker Matching
        if (activeSnapBroker === "ROBINHOOD") return name.includes("ROBINHOOD");
        if (activeSnapBroker === "WEBULL") return name.includes("WEBULL");
        if (activeSnapBroker === "CHARLES_SCHWAB") return name.includes("SCHWAB") || name.includes("CHARLES");
        
        if (name.includes(activeSnapBroker)) return true;
        return false; 
    });
}, [snapAccounts, activeSnapBroker]);


  // inside ImportConnectModal in Journal.jsx

useEffect(() => {
    // Listen for the "Success" signal from the popup
    const handleMessage = (event) => {
        if (event.data === "SNAPTRADE_SUCCESS") {
            console.log("SnapTrade connection successful! Refreshing list...");
            listSnapAccounts(); // Automatically fetch the new accounts
        }
    };

    window.addEventListener("message", handleMessage);
    
    // Also: Auto-load accounts if we are on the snaptrade platform tab
    if (importTab === "connect" && connectPlatform === "snaptrade") {
        listSnapAccounts();
    }

    return () => window.removeEventListener("message", handleMessage);
}, [connectPlatform, importTab]);


// ✅ AUTO-SELECT ACCOUNT: Fixes the "Phantom Selection" bug
// This ensures that as soon as accounts load, the first one is actually selected.
useEffect(() => {
    const shouldAutoSelect = activeSnapBroker || filteredSnapAccounts.length === 1;

    if (shouldAutoSelect && filteredSnapAccounts.length > 0 && !snapPickAccId) {
        console.log("Auto-selecting account:", filteredSnapAccounts[0].id);
        setSnapPickAccId(filteredSnapAccounts[0].id);
    }
}, [filteredSnapAccounts, snapPickAccId, activeSnapBroker]);


useEffect(() => {
    if (open && importTab === "connect") {
        listSnapAccounts(); 
    }
}, [open, importTab]);

// ✅ RESTORE STATE (Fixed)
// Only restore if we are NOT already looking at a platform.
// This prevents the screen from wiping itself when you click "Sync".
useEffect(() => {
    // 1. Check if we should run the restore logic
    // We only run this if the modal is open AND we haven't selected a platform yet.
    if (open && settings?.snapTradeConnected && !connectPlatform) {
        
        // 2. NOW it is safe to reset and restore
        setActiveSnapBroker(null);
        setSnapPickAccId("");

        setConnectPlatform("snaptrade");
        
        if (settings.snapBroker) {
            setActiveSnapBroker(settings.snapBroker);
        }
        if (settings.snapAccountId) {
            setSnapPickAccId(settings.snapAccountId);
        }
        
        listSnapAccounts();
    }
    // 🔴 REMOVED the "Reset everything" code that was outside the if-block
}, [open, settings]);


  // --- TRADOVATE HANDLERS ---
  async function callWithTvRetry(apiCallFn, payload) {
      let resp;
      try {
          resp = await apiCallFn(payload);
      } catch(e) {
          return { data: { ok: false, message: e.message || "Network error" } };
      }

      let data = resp.data;

      if (!data.ok && (data.message?.toLowerCase().includes("expired") || data.message?.includes("401"))) {
          setTvMsg("Token expired. Refreshing...");
          try {
              const refreshRes = await tvRefreshTokenCallable({ userId, accountId });
              if (refreshRes.data.ok) {
                  setTvMsg("Token refreshed. Retrying...");
                  resp = await apiCallFn(payload);
                  data = resp.data;
              } else {
                  setTvMsg("Session expired. Please log in again.");
                  return { data }; 
              }
          } catch (e) {
              console.error("Auto-refresh failed:", e);
              setTvMsg("Could not refresh token.");
              return { data };
          }
      }
      return { data };
  }

  async function onTvConnect() {
    setTvMsg("Connecting…"); 
    setTvBusy(true);
    const payload = {
      env: tvEnv,
      username: tvUsername,
      password: tvPassword,
      userId, 
      accountId
    };
    try {
      const { ok, message } = await tvConnectCallable(payload);
      setTvMsg(message || (ok ? "Connected." : "Failed."));
    } catch (e) {
      console.error("[onTvConnect] Error:", e);
      setTvMsg(e?.message || "Connect failed.");
    } finally {
      setTvBusy(false); 
    }
  }

async function onTvSyncNow({ full = false } = {}) {
      try {
        setTvBusy(true);
        setTvMsg(full ? "Full resync..." : "Syncing...");
        
        const responseObj = await callWithTvRetry(tvSyncNowCallable, { userId, accountId, full });
        const result = responseObj?.data || { ok: false, message: "Unknown error" };
        
        if (result?.ok) {
            const updated = await fetchJournalRows(userId, accountId);
            setRows(updated || []);
            const count = result.count !== undefined ? result.count : (result.trades || []).length;
            if (count > 0) {
                setTvMsg(`✅ Synced ${count} trades!`);
            } else {
                setTvMsg("🟡 Sync complete.");
            }
        } else {
            const msg = result?.message || "Sync failed.";
            setTvMsg(`❌ Sync failed: ${msg}`);

            if (msg.toLowerCase().includes("expired") || msg.includes("401")) {
                console.log("Token expired. Disconnecting...");
                setTvMsg("Session expired. Please log in again.");
                try {
                    // ✅ 1. DISABLE INSTEAD OF DELETE (Preserves selectedAccountId)
                    await setDoc(doc(db, `users/${userId}/accounts/${accountId}/connections/tradovate`), {
                        enabled: false,
                        error: "Session expired."
                    }, { merge: true });
                    
                    // ✅ 2. Tell the parent account it's disconnected so the UI updates to show the Login button
                    await updateDoc(doc(db, `users/${userId}/accounts/${accountId}`), {
                        tradovateConnected: false,
                        tradovateAccessToken: deleteField(), 
                        tradovateRefreshToken: deleteField(), 
                        lastUpdated: new Date()
                    });

                    setTvAccounts([]);
                    setTvPickAccId("");
                } catch(e) {
                    console.error("Disconnect error:", e);
                }
                setConnectPlatform("tradovate");
            }
        }
      } catch (e) {
        console.error(e);
        setTvMsg(`❌ Error: ${e.message}`);
      } finally {
        setTvBusy(false);
      }
    }


  async function onOandaConnect() {
    setOandaBusy(true);
    setOandaMsg("Connecting...");
    try {
    const result = await oandaConnectCallable({
      userId, 
      accountId, 
      token: oandaToken.trim(), 
      oandaAccountId: oandaAccountId.trim(), 
      env: oandaEnv
    });
      const { ok, message } = result.data; 
      
      if (ok) {
          setOandaConnected(true);
          showToast("Connected to OANDA!", "success");
          setOandaMsg("");
      } else {
          setOandaMsg(message || "Failed.");
      }
    } catch (e) {
      console.error(e);
      setOandaMsg(e?.message || "Connect failed.");
    } finally {
      setOandaBusy(false);
    }
  }

  const handleOandaSync = async () => {
      setIsOandaSyncing(true);
      setOandaMsg("Syncing..."); 
      try {
          const { data } = await syncTradesCallable({
              userId, accountId, oandaAccountId: oandaAccountId, env: oandaEnv
          });
          
          if (data.ok) {
              const count = data.count || 0;
              if (count > 0) {
                  setOandaMsg(`✅ Synced ${count} new trades!`);
                  const updatedRows = await fetchJournalRows(userId, accountId);
                  setRows(updatedRows || []); 
              } else {
                  setOandaMsg("ℹ️ No new trades found.");
              }
          } else {
              setOandaMsg("⚠️ Sync warning: " + data.message);
          }
      } catch (error) {
          console.error("Oanda Sync failed", error);
          setOandaMsg("❌ Sync failed: " + error.message);
      } finally {
          setIsOandaSyncing(false);
      }
  };


  const handleOandaDisconnect = async () => {
      setConfirmAction({
          title: "Disconnect OANDA?",
          msg: "Are you sure? You will need to re-enter your token next time.",
          onConfirm: async () => {
              setOandaBusy(true);
              setConfirmAction(null); 
              try {
                  await deleteDoc(doc(db, `users/${userId}/accounts/${accountId}/connections/oanda`));
                  setOandaConnected(false);
                  setOandaToken("");
                  setOandaAccountId("");
                  setOandaMsg("Disconnected."); 
              } catch(e) {
                  setOandaMsg("Disconnect failed.");
              } finally {
                  setOandaBusy(false);
              }
          }
      });
  }

async function handleDisconnect() {
    setConfirmAction({
        title: "Disconnect Tradovate?",
        msg: "Are you sure you want to disconnect? This will stop auto-syncing.",
        onConfirm: async () => {
            setTvBusy(true);
            setConfirmAction(null); 
            try {
              // ✅ FIX: Use updateDoc with deleteField() instead of deleteDoc!
              // This preserves selectedAccountId, autoTrade, and other preferences.
              const connRef = doc(db, `users/${userId}/accounts/${accountId}/connections/tradovate`);
              await updateDoc(connRef, {
                  enabled: false,
                  accessToken: deleteField(),
                  refreshToken: deleteField(),
                  accessExp: deleteField(),
                  tokenExpiry: deleteField(),
                  error: "Disconnected by user",
                  lastUpdated: new Date()
              });

              await updateDoc(doc(db, `users/${userId}/accounts/${accountId}`), {
                tradovateConnected: false,
                tradovateAccessToken: deleteField(), 
                tradovateRefreshToken: deleteField(), 
                lastUpdated: new Date()
              });

              setTvAccounts([]);
              // We do NOT clear tvPickAccId here so the dropdown remembers the choice next time
              setTvMsg("Disconnected."); 
              
            } catch (e) {
              console.error(e);
              setTvMsg("Error disconnecting.");
            } finally {
              setTvBusy(false);
            }
        }
    });
  }

  async function listTvAccounts() {
    setTvBusy(true);
    try {
      const { data } = await callWithTvRetry(listTvAccountsCallable, { userId, accountId });
      
      if (data.ok) {
        const accts = data.accounts || [];
        setTvAccounts(accts);

        if (accts.length === 1) {
          const singleId = accts[0].id;
          setTvPickAccId(singleId); 
          await selectTvAccountCallable({ userId, accountId, tvAccountId: singleId });
          setTvMsg(`Account ${singleId} auto-selected.`);
        } else {
            setTvMsg(""); 
        }
      } else {
        setTvMsg(data.message || "Failed to list accounts.");
      }
    } catch (e) {
      console.error(e);
      setTvMsg("Error listing accounts.");
    } finally {
      setTvBusy(false);
    }
  }

  async function selectTvAccount() {
    try {
      if (!tvPickAccId) { setTvMsg("Pick an account first."); return; }
      setTvMsg("Selecting account…"); setTvBusy(true);
      const { ok, message } = await tvUseAccountCallable({ userId, accountId, tvAccountId: tvPickAccId });
      setTvMsg(message || (ok ? "Account set." : "Failed to set account."));
    } catch (e) {
      setTvMsg(e?.message || "Set account failed.");
    } finally {
      setTvBusy(false);
    }
  }

  if (!open) return null;

  // The rest of your JSX rendering remains exactly the same as provided
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-3">
      <div className="w-full max-w-4xl bg-white dark:bg-gray-900 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700">

        {/* --- TOAST NOTIFICATION COMPONENT --- */}
        {toast.show && (
            <div className={`absolute top-4 left-1/2 transform -translate-x-1/2 z-[110] px-6 py-3 rounded-full shadow-lg font-semibold text-sm transition-all duration-300 animate-fadeIn ${
                toast.type === "success" ? "bg-green-100 text-green-800 border border-green-200" :
                toast.type === "error" ? "bg-red-100 text-red-800 border border-red-200" :
                "bg-blue-100 text-blue-800 border border-blue-200"
            }`}>
                {toast.msg}
            </div>
        )}

        {/* --- CONFIRMATION MODAL COMPONENT --- */}
        {confirmAction && (
            <div className="absolute inset-0 z-[120] bg-black/40 backdrop-blur-sm flex items-center justify-center">
                <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-2xl max-w-sm w-full mx-4 border border-gray-200 dark:border-gray-700 text-center animate-fadeIn">
                    <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">{confirmAction.title}</h3>
                    <p className="text-sm text-gray-600 dark:text-gray-300 mb-6">{confirmAction.msg}</p>
                    <div className="flex gap-3 justify-center">
                        <button 
                            onClick={() => setConfirmAction(null)}
                            className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-lg font-semibold hover:bg-gray-300 dark:hover:bg-gray-600 transition"
                        >
                            Cancel
                        </button>
                        <button 
                            onClick={confirmAction.onConfirm}
                            className="px-4 py-2 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition shadow-md"
                        >
                            Disconnect
                        </button>
                    </div>
                </div>
            </div>
        )}

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <h3 className="text-xl font-bold text-blue-800 dark:text-blue-300">Import / Connect</h3>
          <button
            onClick={onClose}
            className="text-2xl text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
            type="button"
            aria-label="Close import/connect modal"
          >
            &times;
          </button>
        </div>

        {/* Tabs */}
        <div className="px-6 pt-4">
          <div className="inline-flex rounded-lg overflow-hidden border border-gray-200 dark:border-gray-700">
            <button
              className={`px-4 py-2 text-sm font-semibold ${
                importTab === "csv"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200"
              }`}
              onClick={() => setImportTab("csv")}
              type="button"
            >
              <span className="inline-flex items-center gap-2">
                <FaUpload />
                CSV Import
              </span>
            </button>

            <button
              className={`px-4 py-2 text-sm font-semibold ${
                importTab === "connect"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200"
              }`}
              onClick={() => setImportTab("connect")}
              type="button"
            >
              <span className="inline-flex items-center gap-2">
                <FaPlug />
                Connected Platforms
              </span>
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="p-6 max-h-[70vh] overflow-y-auto">
          {importTab === "csv" ? (
            <JournalCsvImport
              userId={userId}
              accountId={accountId}
              onDone={async () => {
                const updated = await fetchAllJournalRows(userId, accountId);
                setRows(updated || []);
                onClose();
              }}
              allowedPlatforms={allowedPlatforms}
            />
  
          ) : (
            <div>
              {/* --- CONNECTED PLATFORMS TAB --- */}
              
              {/* 1. SELECTION GRID */}
              {!connectPlatform && !isCheckingOanda && (
                <div className="animate-fadeIn">
                  <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
                    Select a platform to connect your account for auto-syncing.
                  </p>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                    
                    {/* TRADOVATE BUTTON */}
                    <button
                      onClick={() => {
                        setConnectPlatform("tradovate");
                        setSelectedSubPlatform("tradovate");
                      }}
                      disabled={oandaConnected}
                      className={`group relative flex flex-col items-center justify-center h-32 p-4 rounded-xl border border-gray-200 dark:border-gray-700 transition-all duration-200 
                        ${oandaConnected 
                            ? "bg-gray-100 dark:bg-gray-800 opacity-40 cursor-not-allowed" 
                            : "bg-gray-50 dark:bg-gray-800 hover:bg-white dark:hover:bg-gray-700 hover:shadow-lg"
                        }`}
                    >
                      <img src={tradovateLogo} alt="Tradovate" className="max-h-12 max-w-full object-contain mb-2" />
                      <span className="text-sm font-medium text-gray-700 dark:text-gray-300 group-hover:text-blue-600 dark:group-hover:text-blue-400">
                        {settings?.tradovateConnected ? "✅ Connected" : "Tradovate"}
                      </span>
                      {oandaConnected && <span className="text-[10px] text-red-500 font-bold mt-1">Disconnect OANDA first</span>}
                    </button>

                    {/* TRADELOCKER BUTTON - ADMIN ONLY */}
                    {isAdmin && (
                      <button
                        onClick={() => setConnectPlatform("tradelocker")}
                        disabled={oandaConnected || settings?.tradovateConnected}
                        className={`group relative flex flex-col items-center justify-center h-32 p-4 rounded-xl border border-gray-200 dark:border-gray-700 transition-all duration-200
                          ${(oandaConnected || settings?.tradovateConnected)
                              ? "bg-gray-100 dark:bg-gray-800 opacity-40 cursor-not-allowed" 
                              : "bg-gray-50 dark:bg-gray-800 hover:bg-white dark:hover:bg-gray-700 hover:shadow-lg"
                          }`}
                      >
                        <img src={tllogo} alt="TradeLocker" className="h-8 w-8 rounded-full mb-2" />
                        <span className="text-sm font-medium text-gray-700 dark:text-gray-300 group-hover:text-blue-600 dark:group-hover:text-blue-400">
                          TradeLocker
                        </span>
                      </button>
                    )}

                    {/* NINJATRADER BUTTON */}
                    <button
                      onClick={() => {
                        setConnectPlatform("tradovate");
                        setSelectedSubPlatform("ninjatrader");
                      }}
                      disabled={oandaConnected}
                      className={`group relative flex flex-col items-center justify-center h-32 p-4 rounded-xl border border-gray-200 dark:border-gray-700 transition-all duration-200 
                        ${oandaConnected 
                            ? "bg-gray-100 dark:bg-gray-800 opacity-40 cursor-not-allowed" 
                            : "bg-gray-50 dark:bg-gray-800 hover:bg-white dark:hover:bg-gray-700 hover:shadow-lg"
                        }`}
                    >
                     <img src={ninjatraderLogo} alt="NinjaTrader" className="max-h-12 max-w-full object-contain mb-2" />
                      <span className="text-sm font-medium text-gray-700 dark:text-gray-300 group-hover:text-blue-600 dark:group-hover:text-blue-400">
                        {settings?.tradovateConnected ? "✅ NinjaTrader" : "NinjaTrader"}
                      </span>
                      <span className="text-[9px] text-gray-400 mt-1 text-center leading-tight">
                        Tradovate-based <br/> accounts only
                      </span>
                    </button>

                    {/* OANDA BUTTON */}
                    <button
                      onClick={() => setConnectPlatform("oanda")}
                      disabled={settings?.tradovateConnected}
                      className={`group relative flex flex-col items-center justify-center h-32 p-4 rounded-xl border border-gray-200 dark:border-gray-700 transition-all duration-200
                        ${settings?.tradovateConnected 
                            ? "bg-gray-100 dark:bg-gray-800 opacity-40 cursor-not-allowed" 
                            : "bg-gray-50 dark:bg-gray-800 hover:bg-white dark:hover:bg-gray-700 hover:shadow-lg"
                        }`}
                    >
                       <img src={oandaLogo} alt="Oanda" className="max-h-12 max-w-full object-contain mb-2" />
                      <span className="text-sm font-medium text-gray-700 dark:text-gray-300 group-hover:text-blue-600 dark:group-hover:text-blue-400">
                        {oandaConnected ? "✅ Connected" : "OANDA"}
                      </span>
                      {settings?.tradovateConnected && <span className="text-[10px] text-red-500 font-bold mt-1">Disconnect Tradovate first</span>}
                    </button>

                  {/* SNAPTRADE BUTTONS (ADMIN ONLY) */}
                  {isAdmin && (
                    <>
                        {/* ROBINHOOD */}
                        <button 
                            onClick={() => {
                                // 1. Check if THIS journal is already linked to Robinhood
                                const isLinkedHere = settings?.snapBroker === "ROBINHOOD";
                                
                                setActiveSnapBroker("ROBINHOOD");
                                setConnectPlatform("snaptrade");

                                // 2. Only launch connection if not linked locally
                                if (!isLinkedHere) {
                                    onSnapConnect("ROBINHOOD"); 
                                } else {
                                    listSnapAccounts(); 
                                }
                            }}
                          className="group flex flex-col items-center justify-center p-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 hover:bg-white dark:hover:bg-gray-700 hover:shadow-lg transition-all"
                        >
                            <img src={robinhoodLogo} alt="Robinhood" className="max-h-12 mb-2 object-contain" />
                            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                {/* ✅ ONLY show Green if saved in THIS journal's settings */}
                                {settings?.snapBroker === "ROBINHOOD" ? "✅ Linked" : "Robinhood"}
                            </span>
                            <span className="text-[10px] text-gray-400 mt-1">via SnapTrade</span>
                        </button>

                        {/* Webull Card */}
                        <button 
                            onClick={() => {
                                const isLinkedHere = settings?.snapBroker === "WEBULL";
                                
                                setActiveSnapBroker("WEBULL");
                                setConnectPlatform("snaptrade");

                                if (!isLinkedHere) {
                                    onSnapConnect("WEBULL"); 
                                } else {
                                    listSnapAccounts(); 
                                }
                            }}
                            className="group flex flex-col items-center justify-center p-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 hover:bg-white dark:hover:bg-gray-700 hover:shadow-lg transition-all"
                        >
                            <img src={webullLogo} alt="Webull" className="max-h-12 mb-2 object-contain" />
                            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                {settings?.snapBroker === "WEBULL" ? "✅ Linked" : "Webull"}
                            </span>
                            <span className="text-[10px] text-gray-400 mt-1">via SnapTrade</span>
                        </button>

                        {/* SCHWAB BUTTON (Standardized) */}
                        <button 
                            onClick={() => {
                                setActiveSnapBroker("CHARLES_SCHWAB"); 
                                setConnectPlatform("snaptrade");

                                // 1. Check Settings
                                const isLinkedHere = settings?.snapBroker === "CHARLES_SCHWAB";
                                // 2. Check Availability
                                const isAvailable = snapAccounts.some(acc => 
                                    acc.institution_name?.toUpperCase().includes("SCHWAB")
                                );

                                // Standardized Logic: Only connect if neither linked nor available
                                if (!isLinkedHere && !isAvailable) {
                                    onSnapConnect(null); // Open Search
                                } else {
                                    listSnapAccounts(); // Show List
                                }
                            }}
                            className="group flex flex-col items-center justify-center p-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 hover:bg-white dark:hover:bg-gray-700 hover:shadow-lg transition-all"
                        >
                            <img src={schwabLogo} alt="Schwab" className="max-h-12 mb-2 object-contain" />
                            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                {settings?.snapBroker === "CHARLES_SCHWAB" 
                                    ? "✅ Linked" 
                                    : snapAccounts.some(acc => acc.institution_name?.toUpperCase().includes("SCHWAB"))
                                        ? "⚡ Available" 
                                        : "Schwab"
                                }
                            </span>
                            <span className="text-[10px] text-gray-400 mt-1">via SnapTrade</span>
                        </button>
                     </>
                  )}

                  </div>
                </div>
              )}

              {/* 2. PLATFORM FORMS */}
              {connectPlatform && (
                <div className="animate-fadeIn">
                  {/* Back Button */}
                  <div className="flex items-center gap-3 mb-4 pb-2 border-b border-gray-100 dark:border-gray-700">
                    <button
                      onClick={() => {
                        setConnectPlatform(null);
                        setSelectedSubPlatform(null);
                      }}
                      className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 dark:text-gray-400 transition"
                      title="Back to platforms"
                    >
                      <FaArrowLeft />
                    </button>
                    <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 capitalize">
                      Connect {connectPlatform}
                    </h3>
                  </div>

                  {/* TRADELOCKER FORM */}
                  {connectPlatform === "tradelocker" && (
                    <div className="space-y-4">
                      <div className="flex items-center justify-between mb-2">
                        <div className="text-sm text-gray-500">Connect using your credentials.</div>
                        <div className="flex items-center gap-2">
                          <span className="text-sm dark:text-gray-200">Auto-sync</span>
                          <button
                            type="button"
                            role="switch"
                            aria-checked={tlEnabled}
                            onClick={() => setTlEnabled((v) => !v)}
                            className={`relative inline-flex h-6 w-11 rounded-full ${
                              tlEnabled ? "bg-green-600" : "bg-gray-300 dark:bg-gray-600"
                            }`}
                          >
                            <span className={`absolute top-0.5 left-0.5 h-5 w-5 bg-white rounded-full transform transition ${tlEnabled ? "translate-x-5" : ""}`} />
                          </button>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <div>
                          <label className="text-sm font-medium dark:text-gray-200">Environment</label>
                          <select value={tlEnv} onChange={(e) => setTlEnv(e.target.value)} className="w-full px-3 py-2 rounded border dark:bg-gray-800 dark:text-white dark:border-gray-700">
                            <option value="demo">demo.tradelocker.com</option>
                            <option value="live">live.tradelocker.com</option>
                          </select>
                        </div>
                        <div>
                          <label className="text-sm font-medium dark:text-gray-200">Server</label>
                          <input value={tlServer} onChange={(e) => setTlServer(e.target.value)} placeholder="Your-Broker-Live" className="w-full px-3 py-2 rounded border dark:bg-gray-800 dark:text-white dark:border-gray-700" />
                        </div>
                        <div>
                          <label className="text-sm font-medium dark:text-gray-200">Email</label>
                          <input type="email" value={tlEmail} onChange={(e) => setTlEmail(e.target.value)} className="w-full px-3 py-2 rounded border dark:bg-gray-800 dark:text-white dark:border-gray-700" />
                        </div>
                        <div>
                          <label className="text-sm font-medium dark:text-gray-200">Password</label>
                          <input type="password" value={tlPass} onChange={(e) => setTlPass(e.target.value)} className="w-full px-3 py-2 rounded border dark:bg-gray-800 dark:text-white dark:border-gray-700" />
                        </div>
                      </div>

                      <div className="flex items-center flex-wrap gap-3 mt-4">
                        <button onClick={onTlConnect} disabled={tlBusy} className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white font-semibold disabled:opacity-50">
                          {tlBusy ? "Working…" : "Connect"}
                        </button>
                        <button onClick={() => onTlSyncNow()} disabled={tlBusy} className="px-4 py-2 rounded bg-indigo-600 hover:bg-indigo-700 text-white font-semibold disabled:opacity-50">
                          Sync now
                        </button>
                        <button onClick={listTLAccounts} disabled={tlBusy} className="px-3 py-2 rounded bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-100">
                          List accounts
                        </button>
                      </div>

                      {!!tlMsg && <div className="text-sm text-gray-700 dark:text-gray-200 mt-2">{tlMsg}</div>}

                      {tlAccounts.length > 0 && (
                        <div className="mt-3 grid grid-cols-1 md:grid-cols-3 gap-2">
                          <div className="md:col-span-2">
                            <label className="text-sm dark:text-gray-200">Pick account</label>
                            <select className="w-full px-3 py-2 rounded border dark:bg-gray-800 dark:text-white dark:border-gray-700" onChange={(e) => {
                              const idx = Number(e.target.value);
                              if (idx < 0) { setTlPickAccNum(""); setTlPickId(""); return; }
                              const a = tlAccounts[idx];
                              setTlPickAccNum(a?.accNum || "");
                              setTlPickId(a?.accountId || "");
                            }}>
                              <option value={-1}>Select…</option>
                              {tlAccounts.map((a, i) => <option key={`${a.accNum}|${a.accountId}`} value={i}>{a.label}</option>)}
                            </select>
                          </div>
                          <div className="flex items-end">
                            <button onClick={selectTLAccount} disabled={!tlPickAccNum || !tlPickId || tlBusy} className="px-3 py-2 w-full rounded bg-blue-600 hover:bg-blue-700 text-white font-semibold disabled:opacity-50">
                              Use this account
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* OANDA FORM */}
                  {connectPlatform === "oanda" && (
                    <div className="space-y-4 animate-fadeIn">
                      {oandaConnected ? (
                         <div className="bg-green-50 dark:bg-green-900/20 p-6 rounded-xl border border-green-100 dark:border-green-800 text-center animate-fadeIn">
                            <div className="flex items-center gap-3 mb-4 justify-center">
                              <div className="h-10 w-10 bg-green-100 dark:bg-green-800 rounded-full flex items-center justify-center text-xl shadow-sm">✅</div>
                              <h4 className="text-lg font-bold text-green-800 dark:text-green-300">Connected to OANDA</h4>
                            </div>
                            <p className="text-sm text-gray-600 dark:text-gray-300 mb-6">Account ID: <strong>{oandaAccountId || "(Saved)"}</strong> <br/>Environment: <strong>{oandaEnv}</strong></p>
                            
                            <div className="flex gap-3 justify-center">
                              <button onClick={handleOandaSync} disabled={isOandaSyncing} className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl shadow transition flex items-center gap-2">
                                  {isOandaSyncing ? <span className="animate-spin">↻</span> : <FaSyncAlt />} 
                                  {isOandaSyncing ? "Syncing..." : "Sync Trades"}
                              </button>
                              <button onClick={handleOandaDisconnect} disabled={oandaBusy} className="px-6 py-2.5 bg-red-100 hover:bg-red-200 text-red-700 font-bold rounded-xl shadow transition">Disconnect</button>
                            </div>

                            {!!oandaMsg && (
                              <div className="mt-4 text-center text-sm font-medium text-gray-600 dark:text-gray-300 animate-fadeIn">
                                  {oandaMsg}
                              </div>
                            )}
                         </div>
                       ) : (
                        <>
                          <div className="p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-100 dark:border-blue-800">
                            <h4 className="font-bold text-blue-900 dark:text-blue-200 mb-2">How to connect:</h4>
                            <ol className="list-decimal list-inside text-sm text-gray-700 dark:text-gray-300 space-y-1">
                              <li>Log in to your OANDA web portal.</li>
                              <li>Go to <strong>My Services</strong> &gt; <strong>Manage API Access</strong>.</li>
                              <li>Generate a <strong>Personal Access Token</strong> and paste it below.</li>
                            </ol>
                          </div>

                          <div>
                            <label className="block text-sm font-medium dark:text-gray-200 mb-1">Environment</label>
                            <select 
                              value={oandaEnv} 
                              onChange={(e) => setOandaEnv(e.target.value)}
                              className="w-full px-3 py-2 rounded border dark:bg-gray-800 dark:text-white dark:border-gray-700"
                            >
                              <option value="practice">Demo / Practice</option>
                              <option value="live">Live</option>
                            </select>
                          </div>

                          <div>
                            <label className="block text-sm font-medium dark:text-gray-200 mb-1">Account ID</label>
                            <input
                              type="text"
                              placeholder="e.g. 101-001-1234567-001"
                              value={oandaAccountId}
                              onChange={(e) => setOandaAccountId(e.target.value)}
                              className="w-full px-3 py-2 rounded border dark:bg-gray-800 dark:text-white dark:border-gray-700"
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-medium dark:text-gray-200 mb-1">Personal Access Token</label>
                            <input
                              type="password"
                              placeholder="Paste your OANDA token here..."
                              value={oandaToken}
                              onChange={(e) => setOandaToken(e.target.value)}
                              className="w-full px-3 py-2 rounded border dark:bg-gray-800 dark:text-white dark:border-gray-700"
                            />
                          </div>

                          {!!oandaMsg && (
                            <div className={`text-sm mt-2 ${oandaMsg.includes("Failed") ? "text-red-500" : "text-green-500"}`}>
                              {oandaMsg}
                            </div>
                          )}

                          <div className="flex gap-3 mt-4">
                            <button 
                              onClick={onOandaConnect} 
                              disabled={oandaBusy || !oandaToken || !oandaAccountId}
                              className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-bold shadow disabled:opacity-50 disabled:cursor-not-allowed transition"
                            >
                              {oandaBusy ? "Connecting..." : "Connect OANDA"}
                            </button>
                          </div>
                        </>
                       )}
                    </div>
                  )}

                  {/* SNAPTRADE FORM */}
                  {connectPlatform === "snaptrade" && (
                    <div className="space-y-6 animate-fadeIn">
                        <div className="bg-indigo-50 dark:bg-indigo-900/20 p-6 rounded-xl border border-indigo-100 dark:border-indigo-800">
                            
                            <div className="text-center mb-6">
                                <h4 className="text-lg font-bold text-indigo-800 dark:text-indigo-300 mb-2">Connect Brokerage</h4>
                                <p className="text-sm text-gray-600 dark:text-gray-300">
                                    Link your Robinhood, Webull, Schwab, or other brokerage accounts to import trades.
                                </p>
                            </div>

                            {/* Action Area */}
                            <div className="flex flex-col gap-4">
                                
                                {/* CASE 1: Specific Broker Selected AND Connected -> Show Disconnect */}
                                {activeSnapBroker && filteredSnapAccounts.length > 0 ? (
                                    <div className="p-4 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-xl text-center animate-fadeIn">
                                        <div className="flex items-center justify-center gap-2 mb-3">
                                            <span className="h-2 w-2 bg-green-500 rounded-full animate-pulse"></span>
                                            <p className="text-sm font-semibold text-green-700 dark:text-green-300">
                                                {activeSnapBroker} Connected
                                            </p>
                                        </div>
                                        <button 
                                            onClick={handleSnapDisconnect} 
                                            disabled={snapBusy}
                                            className="w-full py-2.5 bg-red-100 hover:bg-red-200 dark:bg-red-900/40 dark:hover:bg-red-900/60 text-red-700 dark:text-red-300 font-bold rounded-xl transition flex items-center justify-center gap-2"
                                        >
                                            {snapBusy ? "Processing..." : `Disconnect ${activeSnapBroker}`}
                                        </button>
                                    </div>

                                ) : (
                                    /* CASE 2: No Specific Broker Selected OR Not Connected -> Show Link Button */
                                    <button 
                                        onClick={() => onSnapConnect(activeSnapBroker)}
                                        disabled={snapBusy}
                                        className="w-full py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-xl shadow transition flex items-center justify-center gap-2"
                                    >
                                        {snapBusy ? "Generating Link..." : `➕ Link ${activeSnapBroker || 'New Account'}`}
                                    </button>
                                )}
                                {/* 2. Account List & Sync */}
                                <div className="mt-4 p-4 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                    <div className="flex justify-between items-center mb-2">
                                        <label className="text-sm font-semibold text-gray-700 dark:text-gray-200">Your Connected Accounts</label>
                                        <button onClick={listSnapAccounts} className="text-xs text-blue-600 hover:underline">Refresh List</button>
                                    </div>

                                    {snapAccounts.length > 0 ? (
                                        <div className="space-y-3">
                                           <select 
                                               className="w-full px-3 py-2.5 text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-lg outline-none focus:ring-2 focus:ring-indigo-500 appearance-none shadow-sm transition-colors"
                                               value={snapPickAccId}
                                               onChange={(e) => setSnapPickAccId(e.target.value)}
                                           >
                                               <option value="" className="text-gray-500 bg-white dark:bg-gray-800">
                                                   -- Select Account to Sync --
                                               </option>
                                               {filteredSnapAccounts.map(acc => (
                                                   <option 
                                                       key={acc.id} 
                                                       value={acc.id} 
                                                       className="text-gray-900 dark:text-white bg-white dark:bg-gray-800"
                                                   >
                                                       {acc.institution_name} - {acc.name}
                                                   </option>
                                               ))}
                                           </select>

                                            <button 
                                                onClick={onSnapSync}
                                                disabled={!snapPickAccId || snapBusy}
                                                className="w-full py-2 bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg shadow disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                {snapBusy ? "Syncing..." : "Sync Trades Now"}
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="text-sm text-gray-500 text-center py-4 italic">
                                            No accounts found. Click "Link New Account" above.
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Status Message */}
                            {!!snapMsg && (
                                <div className={`mt-4 text-center text-sm font-medium animate-fadeIn ${snapMsg.includes("❌") ? "text-red-500" : "text-green-600 dark:text-green-400"}`}>
                                    {snapMsg}
                                </div>
                            )}
                        </div>
                    </div>
                  )}

                      {/* TRADOVATE SECTION */}
                      {connectPlatform === "tradovate" && (
                        <div className="space-y-6 text-center">
                          
                          {/* CHECK: Do we have a token? */}
                          {settings?.tradovateConnected ? (
                            
                            <div className="bg-green-50 dark:bg-green-900/20 p-6 rounded-xl border border-green-100 dark:border-green-800 animate-fadeIn text-left">
                              <div className="flex items-center gap-3 mb-4 justify-center">
                                <div className="h-10 w-10 bg-green-100 dark:bg-green-800 rounded-full flex items-center justify-center text-xl shadow-sm">
                                  ✅
                                </div>
                                <h4 className="text-lg font-bold text-green-800 dark:text-green-300">
                                  Connected to Tradovate
                                </h4>
                              </div>
      
                              {/* --- ACCOUNT SELECTION AREA --- */}
                             <div className="mb-6 p-4 bg-white/50 dark:bg-gray-800 rounded-lg border border-green-100 dark:border-green-700">
                          <label className="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-2">
                            Select Account
                          </label>
                          
                          <div className="flex gap-2">
                            <button 
                              onClick={listTvAccounts} 
                              disabled={tvBusy}
                              className="px-3 py-2 text-sm font-medium bg-white dark:bg-gray-700 text-gray-700 dark:text-white border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 transition shadow-sm"
                            >
                              Load Accounts
                            </button>

                            {tvAccounts.length > 0 && (
                              <select 
                                className="flex-1 px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-lg outline-none focus:ring-2 focus:ring-green-500 shadow-sm"
                                onChange={(e) => setTvPickAccId(e.target.value)}
                                value={tvPickAccId}
                              >
                                <option value="" className="text-gray-500">-- Choose Account --</option>
                                {tvAccounts.map(acc => (
                                  <option key={acc.id} value={acc.id} className="text-gray-900 dark:text-white">
                                    {acc.name} ({acc.id}) - {acc.accountType}
                                  </option>
                                ))}
                              </select>
                            )}

                            {tvAccounts.length > 0 && (
                              <button 
                                onClick={selectTvAccount}
                                disabled={!tvPickAccId || tvBusy}
                                className="px-4 py-2 text-sm bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg transition disabled:opacity-50 shadow-sm"
                              >
                                Save
                              </button>
                            )}
                          </div>
                          {tvAccounts.length === 0 && (
                            <div className="text-xs text-gray-500 dark:text-gray-400 mt-2">
                              Click "Load Accounts" to pick which account to sync.
                            </div>
                          )}
                        </div>
      
                              {/* --- ACTION BUTTONS --- */}
                              <div className="flex flex-wrap gap-3 justify-center pt-2 border-t border-green-100 dark:border-green-800/50">
                                <button
                                  onClick={() => onTvSyncNow({ full: false })}
                                  disabled={tvBusy}
                                  className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl shadow-lg transition active:scale-95 disabled:opacity-50 flex items-center gap-2"
                                >
                                  {tvBusy ? "Working..." : "Sync Now"}
                                </button>
                                
                                <button
                                  onClick={() => onTvSyncNow({ full: true })}
                                  disabled={tvBusy}
                                  className="px-4 py-2.5 bg-indigo-100 hover:bg-indigo-200 dark:bg-indigo-900/30 dark:hover:bg-indigo-900/50 text-indigo-700 dark:text-indigo-300 font-bold rounded-xl transition active:scale-95 disabled:opacity-50"
                                >
                                  Full Resync
                                </button>
      
                                <button
                                  onClick={handleDisconnect}
                                  disabled={tvBusy}
                                  className="px-4 py-2.5 bg-red-100 hover:bg-red-200 dark:bg-red-900/30 dark:hover:bg-red-900/50 text-red-700 dark:text-red-300 font-bold rounded-xl transition active:scale-95 disabled:opacity-50"
                                >
                                  Disconnect
                                </button>
                              </div>
                              
                              {!!tvMsg && (
                                <div className="mt-4 text-center text-sm font-medium text-gray-600 dark:text-gray-300 animate-fadeIn">
                                    {tvMsg}
                                </div>
                              )}
                            </div>
      
                          ) : (
                            
                            // VIEW 2: NOT CONNECTED
                                                      <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-xl border border-blue-100 dark:border-blue-800 animate-fadeIn">
                                                        <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
                                                          Select your environment and log in to sync trades.
                                                        </p>

                                                        {/* ONLY SHOW THIS IF NINJATRADER WAS CLICKED */}
                                                            {selectedSubPlatform === "ninjatrader" && !settings?.tradovateConnected && (
                                                              <div className="mb-4 p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg text-left animate-fadeIn">
                                                                <p className="text-xs text-amber-800 dark:text-amber-300 flex items-start gap-2">
                                                                  <FaInfoCircle className="mt-0.5 flex-shrink-0" />
                                                                  <span>
                                                                    <strong>NinjaTrader Setup:</strong> Please use your Tradovate-integrated credentials below. This connection is specifically for NinjaTrader accounts that route through Tradovate.
                                                                  </span>
                                                                </p>
                                                              </div>
                                                            )}

                                                        {/* ENVIRONMENT TOGGLE */}
                                                        <div className="mb-4 text-left">
                                                          <label className="block text-xs font-bold text-gray-500 uppercase tracking-wide mb-1.5 ml-1">Environment</label>
                                                          <div className="flex bg-white dark:bg-gray-800 p-1 rounded-lg border border-gray-200 dark:border-gray-700">
                                                            <button
                                                              onClick={() => setTvEnv("live")}
                                                              className={`flex-1 py-1.5 text-sm font-semibold rounded-md transition ${tvEnv === "live" ? "bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300" : "text-gray-500 hover:text-gray-700 dark:text-gray-400"}`}
                                                            >
                                                              Live
                                                            </button>
                                                            <button
                                                              onClick={() => setTvEnv("demo")}
                                                              className={`flex-1 py-1.5 text-sm font-semibold rounded-md transition ${tvEnv === "demo" ? "bg-yellow-100 text-yellow-700 dark:bg-yellow-900 dark:text-yellow-300" : "text-gray-500 hover:text-gray-700 dark:text-gray-400"}`}
                                                            >
                                                              Simulation / Demo
                                                            </button>
                                                          </div>
                                                        </div>
                                
                            <button
                                onClick={() => {
                                  try {
                                    const cid = "9686"; // YOUR CLIENT ID
                                    const redirectUri = "https://us-central1-trapound-app.cloudfunctions.net/tradovateCallback";
                                    
                                    if (!userId || !accountId) {
                                      console.error("Missing User ID or Account ID");
                                      return;
                                    }

                                    // PASS ENV IN STATE: userId|accountId|env
                                    const safeEnv = tvEnv || "live";
                                    const state = `${userId}|${accountId}|${safeEnv}`;
                                    
                                    // ALWAYS use the main Live URL for the login page
                                    const authBaseUrl = "https://trader.tradovate.com"; 
                                    const authUrl = `${authBaseUrl}/oauth?response_type=code&client_id=${cid}&redirect_uri=${encodeURIComponent(redirectUri)}&state=${encodeURIComponent(state)}`;
                                    
                                    // Redirect
                                    window.location.href = authUrl;

                                  } catch (e) {
                                    console.error("Login Button Error:", e);
                                  }
                                }}
                                className={`w-full py-3 px-4 text-white font-bold rounded-xl shadow-lg transition transform active:scale-95 flex items-center justify-center gap-3 ${tvEnv === "live" ? "bg-[#00b8e6] hover:bg-[#00a3cc] shadow-blue-500/30" : "bg-yellow-500 hover:bg-yellow-600 shadow-yellow-500/30"}`}
                              >


                                <img src={tradovateLogo} alt="" className="h-6 w-6" />
                                Log in to {tvEnv === "live" ? "Tradovate" : "Simulation"}
                              </button>
                                                                               
                              <div className="text-xs text-gray-400 dark:text-gray-500 mt-4">
                                You will be redirected to Tradovate's secure login page. <br/>
                                We do not see or store your password.
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                </div>
              )}
            </div>
   )} 
           </div>
         </div>
       </div>
     );
   }


// ---- MAIN COMPONENT ----
export default function Journal({ userId, accountId, isAdmin }) {
    const location = useLocation();
    const inAdminView = location.pathname.startsWith("/__journal");
    const [rows, setRows] = useState([]);
    const [settings, setSettings] = useState({});
    const [userPrefs, setUserPrefs] = useState({});
    const [loading, setLoading] = useState(true);
    const isPrivacyMode = userPrefs?.["Privacy Mode"] === true;
    const [accountType, setAccountType] = useState(null);
    const [popupTradeId, setPopupTradeId] = useState(null);
    const [editTradeId, setEditTradeId] = useState(null);
    const [showResetConfirm, setShowResetConfirm] = useState(false);
    const [resetting, setResetting] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [tradeToDelete, setTradeToDelete] = useState(null);
    const [filters, setFilters] = useState({
      startDate: "",
      endDate: "",
      entryTimeFrom: "", // Added
      entryTimeTo: "",   // Added
      exitTimeFrom: "",  // Added
      exitTimeTo: "",    // Added
      session: "",       // Added
      pnlMin: "",        // Added
      pnlMax: "",        // Added
      product: "",
      result: "",
      rules: "",
      position: "",
      entryStrategy: "",
      exitStrategy: "",
      mood: "",
      grade: "",
      timeframe: "",
      needsReview: "",
      targetReached: "",
      dayOfWeek: ""
    });
    useEffect(() => {
        setCurrentPage(1);
    }, [filters]);
    const [showFilters, setShowFilters] = useState(false);
    const [showBulkUpdate, setShowBulkUpdate] = useState(false);
     const [bulkUpdateValues, setBulkUpdateValues] = useState({
       entryStrategy: "",
       exitStrategy: "",
       rules: "",
       mood: "",
       grade: "",
       session: "",
       timeframe: "",
       product: "",      
       position: "",     
       stopLoss: "",
       needsReview: ""
     });
    const [sortConfig, setSortConfig] = useState({ key: "Date", direction: "desc" });

    const handleSort = (header) => {
        // Prevent sorting on purely action/UI columns
        const nonSortable = ["Link", "Details", "Edit", "Delete", "Download", "Funding"];
        if (nonSortable.includes(header)) return;

        let direction = "desc";
        if (sortConfig.key === header && sortConfig.direction === "desc") {
            direction = "asc";
        }
        setSortConfig({ key: header, direction });
    }; 
    const [showBulkUpdateConfirm, setShowBulkUpdateConfirm] = useState(false);
    const [bulkUpdating, setBulkUpdating] = useState(false);
    const [showBulkUpdateSuccess, setShowBulkUpdateSuccess] = useState(false);
    const [bulkUpdateCount, setBulkUpdateCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 15;
    const [isPropAcct, setIsPropAcct] = useState(false);
    const [isBacktesting, setIsBacktesting] = useState(false);
    const [isPropEval, setIsPropEval] = useState(false);
    const [maxLossLimit, setMaxLossLimit] = useState(0);
    const [showPTC, setShowPTC] = useState(false);
    const [ptcData, setPTCData] = useState(null);
    const [ptcDateStr, setPTCDateStr] = useState("");
    const [ptcLoading, setPTCLoading] = useState(false);
    const [pretradeEnabled, setPretradeEnabled] = useState(false);
    const [ptcNotFound, setPTCNotFound] = useState(null); 
    const [importOpen, setImportOpen] = useState(false);
    // TradeLocker connect/sync state
    const [tlEnv, setTlEnv] = useState("demo");
    const [tlServer, setTlServer] = useState("");
    const [tlEmail, setTlEmail] = useState("");
    const [tlPass, setTlPass] = useState("");
    const [tlEnabled, setTlEnabled] = useState(true);
    const [tlBusy, setTlBusy] = useState(false);
    const [tlMsg, setTlMsg] = useState("");
    const [tvEnv, setTvEnv] = useState("demo");
    const [tvUsername, setTvUsername] = useState("");
    const [tvPassword, setTvPassword] = useState("");
    const [tvDeviceId, setTvDeviceId] = useState("");
    const [tvCid, setTvCid] = useState("");
    const [tvSecret, setTvSecret] = useState("");
    const [tvEnabled, setTvEnabled] = useState(true);
    const [tvBusy, setTvBusy] = useState(false);
    const [tvMsg, setTvMsg] = useState("");
    // Near the top of Journal.jsx
    const TRADOVATE_WEBHOOK_SECRET = "AutoTV_Nextlevel26$"; // Try this if the other one fails

    // START: Webhook Handler
    // START: Webhook Handler
    // START: Webhook Handler
const handleTradeWebhook = async (side, symbolOverride = null, qtyOverride = null) => {
      // 1. Determine Qty
      const qty = qtyOverride !== null ? qtyOverride : (Number(settings["Minimum Contracts"]) || 1);
      
      // 2. Determine Symbol
      let symbol = symbolOverride;
      if (!symbol) {
        symbol = getProductSymbol(settings["Product"]);
      }
      
      // BUG FIX: If "Close All" is clicked but no product is in settings,
      // the server likely still needs a symbol to target the right account positions.
      if (!symbol) {
        if (side === "Close All") {
          // Fallback to a default or tell the user they need a product selected to "Close All"
          alert("Please select a Product in Settings so the system knows which positions to close.");
          return;
        } else {
          alert("Product not found. Please configure a Product in Settings.");
          return;
        }
      }
  
      // NOTE: Ensure this secret matches your Cloud Function environment variables!
      const url = `${TRADOVATE_WEBHOOK_URL}?secret=${encodeURIComponent(TRADOVATE_WEBHOOK_SECRET)}`;

      const payload = {
        action: side, // Sending "Close All"
        symbol: symbol, 
        product: symbolOverride ? symbolOverride : (settings["Product"] || symbol),
        quantity: qty,
        stopLossTicks: Number(settings["Stop Loss"] || 0),
        takeProfitTicks: Number(settings["Take Profit"] || 0),
        accountId: accountId,
        timestamp: new Date().toISOString(),
        force: true
      };
      
      try {
        const btn = document.activeElement;
        const originalText = btn ? btn.innerText : side;
        if(btn) {
            btn.innerText = "Sending...";
            btn.disabled = true;
        }
  
        const res = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
  
        if (!res.ok) {
          const txt = await res.text();
          console.error("Webhook error:", txt);
          alert(`Failed: ${res.status} ${res.statusText}`);
        } else {
          // Success? Let's check if the server sent a text message back
          const txt = await res.text();
          console.log("Webhook Response:", txt);
          if (txt.includes("Missing") || txt.includes("Invalid")) {
             alert(`Server Rejected: ${txt}`);
          }
        }
        
        if(btn) {
            btn.innerText = originalText;
            btn.disabled = false;
        }
  
      } catch (e) {
        console.error("Webhook fetch failed:", e);
        alert("Error contacting webhook.");
        if(document.activeElement) {
            document.activeElement.innerText = side; 
            document.activeElement.disabled = false;
        }
      }
    };

    // Webull connect/sync state
    //const [wbAppKey, setWbAppKey] = useState("");
    //const [wbAppSecret, setWbAppSecret] = useState("");
    //const [wbBusy, setWbBusy] = useState(false);
    //const [wbMsg, setWbMsg] = useState("");



    // Robust truthiness check for your settings toggle
    function pretradeEnabledFrom(settingsObj) {
      if (!settingsObj || typeof settingsObj !== "object") return false;

      // Accept any key that *looks like* "pretrade checklist"
      for (const [rawKey, rawVal] of Object.entries(settingsObj)) {
        const key = String(rawKey).toLowerCase().replace(/[\s_-]+/g, "");
        const looksLikePretradeChecklist =
          key.includes("pretrade") && key.includes("checklist");

        if (!looksLikePretradeChecklist) continue;

        // Accept common truthy encodings
        if (rawVal === true || rawVal === 1) return true;
        if (typeof rawVal === "string") {
          const v = rawVal.trim().toLowerCase();
          if (["true", "yes", "on", "1", "y"].includes(v)) return true;
        }
      }
      return false;
    }

    // Add inside Journal.jsx component
    useEffect(() => {
      const params = new URLSearchParams(location.search);
      if (params.get("status") === "success") {
        // Clear the query param so it doesn't stay in the URL
        window.history.replaceState({}, document.title, location.pathname);
        
        // Optionally trigger a sync now
      }
    }, [location]);

  // Function to handle image download (uses hidden export templates)
  const handleDownloadImage = async (trade) => {
    if (!trade) return;

    const exportKey = trade.id || trade["Trade #"];
    const element = document.getElementById(`trade-export-${exportKey}`);
    if (!element) {
      console.warn("No export element for trade", exportKey);
      return;
    }

    // If the <img> in the template hasn't finished loading yet, wait for it
    const img = element.querySelector("img");
    if (img && !img.complete) {
      await new Promise((resolve) => {
        const done = () => {
          img.removeEventListener("load", done);
          img.removeEventListener("error", done);
          resolve();
        };
        img.addEventListener("load", done);
        img.addEventListener("error", done);
      });
    }

    const previousDisplay = element.style.display;
    element.style.display = "block";

    try {
      const canvas = await html2canvas(element, {
        useCORS: true,
        backgroundColor: "#ffffff",
        scale: 2,
      });

      const image = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      const productShort = (trade["Product"] || "")
        .toString()
        .split(" - ")[0]
        .trim();

        const tradeNum = trade["Trade #"];
        const tradeNumPart =
          tradeNum !== undefined && tradeNum !== null && tradeNum !== ""
            ? `${tradeNum}_`
            : "";

        link.href = image;
        link.download = `Trade_${tradeNumPart}${trade["Date"] || ""}_${productShort || "trade"}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Failed to generate image", err);
      alert("Could not generate image. Check console for details.");
    } finally {
      element.style.display = previousDisplay || "none";
    }
  };





    // Extract YYYY-MM-DD from a date field
    function toISODateKey(v) {
      if (!v) return "";
      if (typeof v === "string" && v.includes("-")) return v.slice(0, 10);
      const d = new Date(v);
      return isNaN(d) ? "" : d.toISOString().slice(0, 10);
    }

    function prettyDate(iso) {
      if (!iso) return "";
      const d = new Date(iso + "T00:00:00");
      return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
    }

// Recompute Running Balance (and Prop Running Balance) after a delete
    async function recomputeBalancesAfterDelete(nextRows) {
      try {
        const settings = await getSettings(userId, accountId);
        const initial = Number(settings?.["Initial Balance"] ?? 0);
        // New fallback logic
        const beginning = Number(settings?.["Beginning Balance"] ?? 0);
        const fallbackBalance = beginning > 0 ? beginning : initial;

        const maxLoss = Number(settings?.["Maximum Loss Limit"] ?? 0);
        
        // Treat as “prop-like” if explicit flags are set OR if prop fields already exist.
        const hasPropRBKey  = Object.prototype.hasOwnProperty.call(settings || {}, "Prop Running Balance");
        const hasPropInit   = Object.prototype.hasOwnProperty.call(settings || {}, "Prop Initial Balance");
        const isPropLike    = Boolean(settings?.isProp || settings?.isPropFirm || hasPropRBKey || hasPropInit);

        // pick the newest trade by Date, then Trade #
        const latest = (nextRows || [])
          .slice()
          .sort((a, b) => {
            const tA = new Date(a["Date"]).getTime() || 0;
            const tB = new Date(b["Date"]).getTime() || 0;
            if (tB !== tA) return tB - tA;
            const nA = parseInt(a["Trade #"], 10) || 0;
            const nB = parseInt(b["Trade #"], 10) || 0;
            return nB - nA;
          })[0];

        const num = (v) => {
          const n = Number(String(v ?? "").replace(/[^\d.-]/g, ""));
          return Number.isFinite(n) ? n : NaN;
        };

        // Initialize variables
        let nextRunning = fallbackBalance;
        let nextTotalEquity = fallbackBalance;
        let nextUnsettled = 0; 

        if (latest) {
          // 1. Restore Total Equity (Saved historically under 'Running Balance' or new 'Total Equity')
          // 👇 FIX: Added latest["Actual Balance"] as the ultimate fallback
          const te = num(latest["Total Equity"] ?? latest["Running Balance"] ?? latest["Actual Balance"]);
          if (Number.isFinite(te)) {
              nextTotalEquity = te;
          }

          // 2. Restore Unsettled Funds
          const ub = num(latest["Unsettled Balance"]);
          if (Number.isFinite(ub)) {
              nextUnsettled = ub;
          } else {
              nextUnsettled = 0; // Fallback for old trades that didn't save this
          }

          // 3. Restore Buying Power
          // 👇 FIX: Added latest["Actual Balance"] as the ultimate fallback
          const bp = num(latest["Buying Power"] ?? latest["Running Balance"] ?? latest["Actual Balance"]);
          if (Number.isFinite(bp)) {
              nextRunning = bp;
          } else {
              // Fallback for old trades: Total Equity minus Unsettled
              nextRunning = nextTotalEquity - nextUnsettled; 
          }
        } else {
           // If no trades left, ensure Unsettled resets to the settings value (or 0)
           const startUnsettled = Number(settings?.["Beginning Unsettled"] ?? 0);
           nextUnsettled = startUnsettled;
           // Reset both balances to Initial
           nextRunning = initial;
           nextTotalEquity = initial;
        }

        const nextSettings = { 
            ...settings, 
            "Beginning Balance": nextTotalEquity, // <-- Added Total Equity Update
            "Running Balance": nextRunning,
            "Unsettled Balance": nextUnsettled 
        };

        if (isPropLike) {
          nextSettings["Prop Running Balance"] = Math.max(
            0,
            nextRunning - (Number.isFinite(maxLoss) ? maxLoss : 0)
          );
        }

        await updateSettings(userId, accountId, nextSettings);
      } catch (e) {
         console.error("Failed to recompute balances:", e);
      }
    }



useEffect(() => {
        // 1. Safety Check
        if (!userId || !accountId) {
            setRows([]);
            setAccountType(null);
            setLoading(false);
            return;
        }
        setLoading(true);

        // ---------------------------------------------------------
        // LISTENER 1: SETTINGS (Account Balance, Config, etc.)
        // ---------------------------------------------------------
        const settingsRef = doc(db, "users", userId, "accounts", accountId);
        const unsubSettings = onSnapshot(settingsRef, (docSnap) => {
            if (docSnap.exists()) {
                const data = docSnap.data();
                setSettings(data);

                // Derived State Updates
                const inferred = resolveAccountType(data, rows);
                setAccountType(inferred);

                const propFunded = Boolean(data?.isPropFunded);
                const propFirm = Boolean(data?.isProp || data?.isPropFirm);
                const isAnyPropAccount = propFirm || propFunded; 
                const propEval = (propFirm && !propFunded) || Boolean(data?.isPropEval);

                const backtesting =
                    data?.isBacktest === true ||
                    String(data?.tag || "").toLowerCase().includes("backtest") ||
                    String(data?.fundingType || "").toLowerCase().includes("backtest");

                setIsPropAcct(isAnyPropAccount);
                setIsPropEval(propEval);
                setIsBacktesting(backtesting);
                setMaxLossLimit(Number(data?.["Maximum Loss Limit"] ?? 0));
                setPretradeEnabled(pretradeEnabledFrom(data));
            }
        });

        // --- ADD THIS NEW LISTENER BLOCK HERE ---
        const prefsRef = doc(db, "users", userId, "settings", "prefs");
        const unsubPrefs = onSnapshot(prefsRef, (docSnap) => {
            if (docSnap.exists()) {
                setUserPrefs(docSnap.data());
            }
        });

        // ---------------------------------------------------------
        // LISTENER 2: JOURNAL ROWS (REAL-TIME UPDATES)
        // ---------------------------------------------------------
        // This listens to the ENTIRE journal. 
        // It will catch Tradovate trades, Oanda trades, and CSV imports instantly.
        const journalRef = collection(db, "users", userId, "accounts", accountId, "journal");
        
        const unsubJournal = onSnapshot(journalRef, (snapshot) => {
            const journalData = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
            
    
            
            // This 'setRows' puts ALL trades (Oanda included) into your table
            setRows(journalData);
            setLoading(false);
        }, (error) => {
            console.error("❌ Journal Listener Error:", error);
            setLoading(false);
        });

        // Cleanup
        return () => {
            unsubSettings();
            unsubJournal();
        };
    }, [userId, accountId]);


     const filterOptions = useMemo(() => {
         const products = new Set();
         const entryStrategies = new Set();
         const exitStrategies = new Set();
         const moods = new Set();
         const grades = new Set();
         const timeframes = new Set();

          rows.forEach(row => {
            if (row.Product) products.add(getProductShort(row.Product));
            if (row["Entry Strategy"]) entryStrategies.add(row["Entry Strategy"]);
            if (row["Exit Strategy"]) exitStrategies.add(row["Exit Strategy"]);
           const moodVal = (row["Mood_Mindset"] ?? row["Mood/Mindset"] ?? "").toString().trim();
           if (moodVal) moods.add(moodVal);
           const gradeVal = (row["Grade"] ?? "").toString().trim().toUpperCase();
           if (gradeVal) grades.add(gradeVal);
           const tfVal = (row["Timeframe"] ?? "").toString().trim();
           if (tfVal) timeframes.add(tfVal);
          });

          return {
            products: [...products].sort(),
            entryStrategies: [...entryStrategies].sort(),
           exitStrategies: [...exitStrategies].sort(),
           moods: [...moods].sort(),
           grades: [...grades].sort(),
           timeframes: [...timeframes].sort()
          };
       }, [rows]);
// ✅ Helper to safely get milliseconds from Strings OR Timestamps
         // ✅ ROBUST SORTING HELPER
         const getMs = (val) => {
             if (!val) return 0;
             // Handle Firestore Timestamp (seconds)
             if (typeof val === 'object' && val.seconds) {
                 return val.seconds * 1000;
             }
             // Handle String or Date Object
             const d = new Date(val);
             return isNaN(d.getTime()) ? 0 : d.getTime();
         };

         const sortedRows = useMemo(() => {
             return [...rows].sort((a, b) => {
                 let valA, valB;
                 const key = sortConfig.key;

                 switch (key) {
                     case "Trade #":
                         valA = parseInt(a["Trade #"], 10) || 0;
                         valB = parseInt(b["Trade #"], 10) || 0;
                         break;
                     case "Reward":
                     case "Balance":
                         valA = parseSignedNumber(a[key === "Reward" ? "Actual Reward" : "Actual Balance"]) || 0;
                         valB = parseSignedNumber(b[key === "Reward" ? "Actual Reward" : "Actual Balance"]) || 0;
                         break;
                     case "% Growth":
                         valA = parseFloat(String(a["Actual Percent Growth"] || "0").replace(/[^\d.-]/g, "")) || 0;
                         valB = parseFloat(String(b["Actual Percent Growth"] || "0").replace(/[^\d.-]/g, "")) || 0;
                         break;
                     case "Size":
                         valA = parseFloat(a["Size"]) || 0;
                         valB = parseFloat(b["Size"]) || 0;
                         break;
                     case "Product":
                         valA = getProductShort(a["Product"]).toLowerCase();
                         valB = getProductShort(b["Product"]).toLowerCase();
                         break;
                     case "Result":
                         valA = (a.Win === "TRUE" || a.Win === true) ? 1 : (a.Loss === "TRUE" || a.Loss === true || String(a.Loss).toLowerCase() === "lost") ? -1 : 0;
                         valB = (b.Win === "TRUE" || b.Win === true) ? 1 : (b.Loss === "TRUE" || b.Loss === true || String(b.Loss).toLowerCase() === "lost") ? -1 : 0;
                         break;
                     case "Date":
                     default: {
                         // Combine Date and Entry Time for a true chronological sort
                         const timeA = a["Entry Time"] ? ` ${a["Entry Time"]}` : "";
                         const timeB = b["Entry Time"] ? ` ${b["Entry Time"]}` : "";
                         
                         valA = new Date(`${a["Date"]}${timeA}`).getTime() || getMs(a["Date"]);
                         valB = new Date(`${b["Date"]}${timeB}`).getTime() || getMs(b["Date"]);
                         break;
                     }
                 }

                 if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
                 if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;

                 // Secondary Sort by Trade # (Desc)
                 const tradeNumA = parseInt(a["Trade #"], 10) || 0;
                 const tradeNumB = parseInt(b["Trade #"], 10) || 0;
                 return tradeNumB - tradeNumA;
             });
         }, [rows, sortConfig]);


    const handleViewChecklistFor = async (detailsRow) => {
      try {
        setPTCLoading(true);
        const dateKey = toISODateKey(detailsRow?.["Date"]);
        setPTCDateStr(dateKey);

        const data = await getTodayPreTradeChecklist(userId, accountId, dateKey);
        if (!data) {
          setPTCData(null);
          setShowPTC(false);
          setPTCNotFound({ dateKey, pretty: prettyDate(dateKey) });  // <-- show styled notice
          return;
        }
        setPTCNotFound(null);
        setPTCData(data);
        setShowPTC(true);
      } finally {
        setPTCLoading(false);
      }
    };



const filteredRows = sortedRows.filter(row => {
         // Convert Date safely using your existing helper
         const tradeDate = toYYYYMMDD(row["Date"]); 
         
         // Debug if we are missing dates
         // if (!tradeDate) console.warn("Row missing valid date:", row);

         const product = getProductShort(row["Product"]).toLowerCase();
          
          // --- DATE RANGE LOGIC ---
          let dateMatch = true;
          if (filters.startDate && filters.endDate) {
              dateMatch = tradeDate >= filters.startDate && tradeDate <= filters.endDate;
          } else if (filters.startDate) {
              dateMatch = tradeDate >= filters.startDate;
          } else if (filters.endDate) {
              dateMatch = tradeDate <= filters.endDate;
          }        const result = row.Win === "TRUE" || row.Win === true ? "Won" : row.Loss === "TRUE" || row.Loss === true ? "Loss" : "";
        const rules = row["Did I follow my Rules?"];
        const position = row["Position"];
        const entryStrategy = row["Entry Strategy"]?.toLowerCase() || "";
        const exitStrategy = row["Exit Strategy"]?.toLowerCase() || "";
        const moodVal = (row["Mood_Mindset"] ?? row["Mood/Mindset"] ?? "").toString().trim();
        const gradeVal = (row["Grade"] ?? "").toString().trim().toUpperCase();
        const timeframeVal = (row["Timeframe"] ?? "").toString().trim();
        const sessionVal = (row["Session"] || "").toString().trim();

          // Parse times into comparable 24-hour HH:mm formats
          const rowEntryTime24 = row["Entry Time"] ? toHHMM(to24HourTime(row["Entry Time"])) : "";
          const rowExitTime24 = row["Exit Time"] ? toHHMM(to24HourTime(row["Exit Time"])) : "";
          const pnlVal = parseSignedNumber(row["Actual Reward"]);
        let weekdayMatch = true;
        if (filters.dayOfWeek && tradeDate) {
           // Split the safe YYYY-MM-DD string
           const [y, m, d] = tradeDate.split('-');
           
           // Creating the date this way forces it to local time, preventing any timezone shift
           const localDate = new Date(y, m - 1, d);
           const dayName = localDate.toLocaleDateString('en-US', { weekday: 'long' });
           
           weekdayMatch = dayName === filters.dayOfWeek;
        }

        //const dateMatch = filters.date ? tradeDate === filters.date : true;
        const productMatch = filters.product ? product === filters.product.toLowerCase() : true;
        const resultMatch = filters.result ? result === filters.result : true;
        const rulesMatch = filters.rules ? (filters.rules === BLANK ? !rules || String(rules).trim() === "" : rules === filters.rules) : true;
        const positionMatch = filters.position ? position === filters.position : true;
        const entryStrategyMatch = filters.entryStrategy ? (filters.entryStrategy === BLANK ? entryStrategy === "" : entryStrategy === filters.entryStrategy.toLowerCase()) : true;
        const exitStrategyMatch = filters.exitStrategy ? (filters.exitStrategy === BLANK ? exitStrategy === "" : exitStrategy === filters.exitStrategy.toLowerCase()) : true;
        const moodMatch = filters.mood ? (filters.mood === BLANK ? moodVal === "" : moodVal.toLowerCase() === filters.mood.toLowerCase()) : true;
        const gradeMatch = filters.grade ? (filters.grade === BLANK ? gradeVal === "" : gradeVal === filters.grade.toUpperCase()) : true;
        const timeframeMatch = filters.timeframe
           ? (filters.timeframe === BLANK ? timeframeVal === "" : timeframeVal.toLowerCase() === filters.timeframe.toLowerCase())
           : true;
        const sessionMatch = filters.session 
          ? (filters.session === BLANK ? sessionVal === "" : sessionVal.toLowerCase() === filters.session.toLowerCase()) 
          : true;
        const pnlMin = parseSignedNumber(filters.pnlMin);
        const pnlMax = parseSignedNumber(filters.pnlMax);

        const pnlMinMatch =
          filters.pnlMin !== ""
            ? Number.isFinite(pnlVal) &&
              Number.isFinite(pnlMin) &&
              pnlVal >= pnlMin
            : true;

        const pnlMaxMatch =
          filters.pnlMax !== ""
            ? Number.isFinite(pnlVal) &&
              Number.isFinite(pnlMax) &&
              pnlVal <= pnlMax
            : true;
        const isFlagged = row["Needs Review"] === "TRUE" || row["Needs Review"] === true;
        const reviewMatch = filters.needsReview ? (filters.needsReview === "TRUE" ? isFlagged : !isFlagged) : true;
        const isTargetReached = row["Target Reached"] === "TRUE" || row["Target Reached"] === true;
        const targetReachedMatch = filters.targetReached ? (filters.targetReached === "TRUE" ? isTargetReached : !isTargetReached) : true;

        const entryTimeMatch = checkTimeRange(rowEntryTime24, filters.entryTimeFrom, filters.entryTimeTo);
        const exitTimeMatch = checkTimeRange(rowExitTime24, filters.exitTimeFrom, filters.exitTimeTo);

        return dateMatch && productMatch && resultMatch && rulesMatch && positionMatch && 
               entryStrategyMatch && exitStrategyMatch && moodMatch && gradeMatch && 
               timeframeMatch && sessionMatch && pnlMinMatch && pnlMaxMatch && 
               entryTimeMatch && exitTimeMatch && reviewMatch && weekdayMatch && targetReachedMatch;
        });




    const hideFunding = isPropAcct || isPropEval || isBacktesting;
    // after hideFunding is computed
    const perfHeader =
          (accountType === "stock" || accountType === "options") ? "Points" :
          (accountType === "futures") ? "Ticks" :
          (accountType === "mixed") ? "Units" :
          "Pips";

        const headers = [
          "Trade #", "Product", "Position", "Size", "% Growth", "Result",
          ...(!hideFunding ? ["Funding"] : []),
          "Reward", "Balance",
          perfHeader, // This will now show "Units" for mixed accounts
          "Date", "Entry", "Exit", "Duration",
          "Link", "Details", "Edit", "Delete", "Review","Download"
        ];


    // --- Prev/Next helpers that skip Funding rows ---
    function prevIndexFrom(i) {
      let j = (i ?? 0) - 1;
      while (j >= 0 && isFundingRow(filteredRows[j])) j--;
      return j;
    }
    function nextIndexFrom(i) {
      let j = (i ?? -1) + 1;
      while (j < filteredRows.length && isFundingRow(filteredRows[j])) j++;
      return j;
    }

    // Dynamically find the current index based on the ID
    const popupIdx = popupTradeId ? filteredRows.findIndex(r => r.id === popupTradeId) : null;
    const editIdx = editTradeId ? filteredRows.findIndex(r => r.id === editTradeId) : null;

    const canPrevDetails = popupIdx !== null && popupIdx >= 0 && prevIndexFrom(popupIdx) >= 0;
    const canNextDetails = popupIdx !== null && popupIdx >= 0 && nextIndexFrom(popupIdx) < filteredRows.length;
    const goPrevDetails  = () => {
        if (popupIdx !== null && popupIdx >= 0) {
            const j = prevIndexFrom(popupIdx);
            if (j >= 0) setPopupTradeId(filteredRows[j].id);
        }
    };
    const goNextDetails  = () => {
        if (popupIdx !== null && popupIdx >= 0) {
            const j = nextIndexFrom(popupIdx);
            if (j < filteredRows.length) setPopupTradeId(filteredRows[j].id);
        }
    };

    const canPrevEdit = editIdx !== null && editIdx >= 0 && prevIndexFrom(editIdx) >= 0;
    const canNextEdit = editIdx !== null && editIdx >= 0 && nextIndexFrom(editIdx) < filteredRows.length;
    const goPrevEdit  = () => {
        if (editIdx !== null && editIdx >= 0) {
            const j = prevIndexFrom(editIdx);
            if (j >= 0) setEditTradeId(filteredRows[j].id);
        }
    };
    const goNextEdit  = () => {
        if (editIdx !== null && editIdx >= 0) {
            const j = nextIndexFrom(editIdx);
            if (j < filteredRows.length) setEditTradeId(filteredRows[j].id);
        }
    };
    // Note: We removed the old useEffect that tried to force array indices!

    const pageCount = Math.max(1, Math.ceil(filteredRows.length / rowsPerPage));
    const pagedRows = filteredRows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

    const getResultCell = (row) => {
        const isWon = row["Win"] === "TRUE" || row["Win"] === true || String(row["Result"]).toLowerCase() === "won";
        const isLoss = row["Loss"] === "TRUE" || row["Loss"] === true || String(row["Loss"]).toLowerCase() === "lost" || String(row["Result"]).toLowerCase() === "loss" || String(row["Result"]).toLowerCase() === "lost";

        if (isWon) {
            return <span className="inline-block bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300 font-bold px-2 py-0.5 rounded-md text-xs">Won</span>;
        }
        if (isLoss) {
            return <span className="inline-block bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300 font-bold px-2 py-0.5 rounded-md text-xs">Loss</span>;
        }
        return <span className="text-gray-400 dark:text-gray-500">–</span>;
    };

    function getNegativeClass(val) {
        if (!val) return "";
        let n = Number(String(val).replace(/[^\d.-]/g, ""));
        return n < 0 ? "text-red-600 dark:text-red-300 font-bold" : "";
    }

    async function handleUpdateJournalRow(rowIndex, updatedRow) {
      try {
        // 1) Find the row being edited (global index over filteredRows)
        const targetRow = filteredRows[rowIndex];
        if (!targetRow || !targetRow.id) {
          console.warn("[Journal] Skipped update: missing row or ID");
          return;
        }

        const rowId = targetRow.id;

        // 2) Persist the leader’s edit
        await updateJournalRow(userId, accountId, rowId, updatedRow);

        const oldBalance = Number(targetRow["Actual Balance"]);
                const newBalance = Number(updatedRow["Actual Balance"]);
                const balanceWasChanged = (updatedRow["Actual Balance"] !== undefined && oldBalance !== newBalance && Number.isFinite(newBalance));

                if (balanceWasChanged) {
          // ✅ Helper to safely get milliseconds (defined locally or assume it's in scope)
          const getMs = (val) => {
              if (!val) return 0;
              if (typeof val === 'object' && val.seconds) {
                  return val.seconds * 1000;
              }
              return new Date(val).getTime(); 
          };

          // Find the latest trade in the *full* journal using the SAFE sort
          const latestTrade = [...rows].sort((a, b) => {
              const timeA = getMs(a["Date"]);
              const timeB = getMs(b["Date"]);
              
              // 1. Sort by Date (Newest First)
              if (timeB !== timeA) return timeB - timeA;

              // 2. Secondary Sort by Trade # (Desc)
              const tradeNumA = parseInt(a["Trade #"], 10) || 0;
              const tradeNumB = parseInt(b["Trade #"], 10) || 0;
              return tradeNumB - tradeNumA;
          })[0];
          
          const isLatestTrade = (latestTrade && latestTrade.id === rowId);

          if (isLatestTrade) {
            // This IS the latest trade, so update the main account balance
            const settings = await getSettings(userId, accountId);
            const maxLoss = Number(settings?.["Maximum Loss Limit"] ?? 0);
            const hasPropRBKey = Object.prototype.hasOwnProperty.call(settings || {}, "Prop Running Balance");
            const hasPropInit = Object.prototype.hasOwnProperty.call(settings || {}, "Prop Initial Balance");
            const isPropLike = Boolean(settings?.isProp || settings?.isPropFirm || hasPropRBKey || hasPropInit);
            
            const delta = newBalance - oldBalance;
            const currentRunning = Number(settings["Running Balance"] || 0);

            const nextSettings = { 
                ...settings, 
                "Beginning Balance": newBalance,
                "Running Balance": currentRunning + delta 
            };
            
            if (isPropLike) {
              nextSettings["Prop Running Balance"] = Math.max(0, nextSettings["Running Balance"] - maxLoss);
            }
            await updateSettings(userId, accountId, nextSettings);
          }
        }

        // 3) Optimistically update local UI
        setRows(prev => prev.map(r => (r.id === rowId ? { ...r, ...updatedRow } : r)));
        

        // 4) If this account is a leader, propagate to followers
        try {
          const me = await getSettings(userId, accountId);
          const isLeader =
            me?.CopyTrade?.role === "leader" ||
            me?.settings?.CopyTrade?.role === "leader";
          if (!isLeader) return;

          // P&L for this trade (fallback if Actual Reward not in the edit payload)
           // P&L for this trade; force 0 if Did Not Take
           const didNotTake = String((updatedRow["Position"] ?? targetRow["Position"] ?? "")).trim().toLowerCase() === "did not take";
           const delta = didNotTake
             ? 0
             : (Number(updatedRow["Actual Reward"] ?? 0) ||
                (Number(updatedRow["Actual Balance"] || 0) -
                 Number(updatedRow["Balance Before Trade"] || 0)));

          await copyTradeToFollowers({
            userId,
            leaderAccountId: accountId,
            // Merge to make sure the leader Trade # and other keys are present
            leaderTrade: { ...targetRow, ...updatedRow },
            delta,
            accountType: (accountType || "futures"),
            mode: "update",              // <-- update existing follower rows
          });

          console.log("[CopyTrade] Update propagated to followers");
        } catch (e) {
          console.error("[CopyTrade] Update propagation failed:", e);
        }
      } catch (err) {
        console.error("Failed to update row:", err);
        alert("Failed to update row");
      }
    }




    async function handleBulkUpdate() {
        if (!filteredRows.length) return;
        setBulkUpdating(true);
        const updates = filteredRows.map(row => {
            const updatedFields = {};
            if (bulkUpdateValues.entryStrategy) updatedFields["Entry Strategy"] = bulkUpdateValues.entryStrategy;
            if (bulkUpdateValues.exitStrategy) updatedFields["Exit Strategy"] = bulkUpdateValues.exitStrategy;
            if (bulkUpdateValues.rules) updatedFields["Did I follow my Rules?"] = bulkUpdateValues.rules;
            if (bulkUpdateValues.mood) updatedFields["Mood_Mindset"] = bulkUpdateValues.mood;
            if (bulkUpdateValues.grade) updatedFields["Grade"] = bulkUpdateValues.grade;
            if (bulkUpdateValues.session) updatedFields["Session"] = bulkUpdateValues.session;
            if (bulkUpdateValues.timeframe) updatedFields["Timeframe"] = bulkUpdateValues.timeframe;
            if (bulkUpdateValues.product) updatedFields["Product"] = bulkUpdateValues.product;
            if (bulkUpdateValues.position) updatedFields["Position"] = bulkUpdateValues.position;
            if (bulkUpdateValues.stopLoss) updatedFields["Stop Loss_Take Profit"] = bulkUpdateValues.stopLoss;
            if (bulkUpdateValues.needsReview) updatedFields["Needs Review"] = bulkUpdateValues.needsReview;
            
            return updateJournalRow(userId, accountId, row.id, updatedFields);
        });
        try {
            await Promise.all(updates);
            const updatedRows = await fetchJournalRows(userId, accountId);
            setRows(updatedRows || []);
            setBulkUpdateValues({ 
                entryStrategy: "", exitStrategy: "", rules: "", mood: "", 
                grade: "", session: "", timeframe: "", product: "", 
                position: "", stopLoss: "" 
            });
            setShowBulkUpdateConfirm(false);
            setShowBulkUpdate(false);
            setBulkUpdateCount(updates.length);
            setShowBulkUpdateSuccess(true);
        } catch (err) {
            alert("Failed to perform bulk update.");
            console.error(err);
        } finally {
            setBulkUpdating(false);
        }
    }

    async function handleResetJournal() {
        if (!showResetConfirm) return;
        
        // 1. ADD THIS: Start the loading state
        setResetting(true);
        
        try {
            await clearJournalRows(userId, accountId);
            setRows([]);
            const current = await getSettings(userId, accountId);
            const initial = Number(current["Initial Balance"] || 0);
            const goal = Number(current["Account Goal"] || 0);
            const maxLoss = Number(current["Maximum Loss Limit"] || 0);
            const propInitial = Math.max(0, initial - maxLoss);
            const propGoal = Math.max(0, goal - maxLoss);
            const next = {
                ...current,
                "Running Balance": initial,
                "Beginning Balance": initial, // Resets Total Account Equity
                "Unsettled Balance": 0,       // Clears any lingering unsettled funds
                "Remaining Profit Amount": Math.max(0, goal - initial),
                "Prop Initial Balance": propInitial,
                "Prop Account Goal": propGoal,
                "Prop Running Balance": propInitial,
                "Number of Trades to Goal": 0,
                "AccountGoalReachedShownDate": "",
            };
            await updateSettings(userId, accountId, next);
            setShowResetConfirm(false);
        } catch (err) {
            alert("Failed to reset journal or update balance.");
            console.error(err);
        } finally {
            // 2. ADD THIS: Stop the loading state whether it succeeds or fails
            setResetting(false);
        }
    }



    function ResetJournalModal({ open, onCancel, onConfirm, loading }) {
        if (!open) return null;
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur">
                <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl p-8 border border-gray-200 dark:border-gray-700 min-w-[340px] max-w-[90vw] text-center">
                    <h2 className="text-2xl font-extrabold text-red-700 dark:text-red-400 mb-3"> Reset Journal? </h2>
                    <div className="text-gray-700 dark:text-gray-200 mb-6"> Are you sure you want to <b>delete all trades</b>?<br /> This action <span className="font-bold text-red-700 dark:text-red-400">cannot be undone</span>! </div>
                    <div className="flex justify-center gap-6">
                        <button className="px-6 py-2 rounded bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 dark:text-white font-semibold" onClick={onCancel} disabled={loading} > Cancel </button>
                        <button className="px-6 py-2 rounded bg-red-600 hover:bg-red-700 text-white font-bold" onClick={onConfirm} disabled={loading} > {loading ? "Resetting..." : "Yes, Reset"} </button>
                    </div>
                </div>
            </div>
        );
    }

    function BulkUpdateConfirmModal({ open, onCancel, onConfirm, count, loading }) {
        if (!open) return null;
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl px-8 py-8 min-w-[340px] max-w-[95vw] border-2 border-blue-400 text-center">
                    <div className="mb-4">
                        <FaSyncAlt className="text-3xl text-blue-500 mx-auto mb-2" />
                        <h2 className="text-xl font-bold text-blue-700 dark:text-blue-400 mb-2"> Bulk Update {count} Trades? </h2>
                        <div className="text-gray-700 dark:text-gray-300"> Are you sure you want to apply this update to <br />all {count} filtered trades? <br /> This action can be undone manually. </div>
                    </div>
                    <div className="flex justify-center gap-4 mt-6">
                        <button onClick={onCancel} disabled={loading} className="px-6 py-2 rounded-lg bg-gray-200 dark:bg-gray-800 text-gray-700 dark:text-gray-200 font-bold hover:bg-gray-300 transition" > Cancel </button>
                        <button onClick={onConfirm} disabled={loading} className="px-6 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-bold transition" > {loading ? "Updating..." : "Yes, Update"} </button>
                    </div>
                </div>
            </div>
        );
    }

    function BulkUpdateSuccessModal({ open, onDismiss, count }) {
        if (!open) return null;
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl px-8 py-8 min-w-[340px] max-w-[95vw] border-2 border-green-400 text-center">
                    <div className="mb-4">
                        <FaCheckCircle className="text-3xl text-green-500 mx-auto mb-2" />
                        <h2 className="text-xl font-bold text-green-700 dark:text-green-400 mb-2"> Update Successful! </h2>
                        <div className="text-gray-700 dark:text-gray-300"> Successfully updated {count} trades. </div>
                    </div>
                    <div className="flex justify-center gap-4 mt-6">
                        <button onClick={onDismiss} className="px-6 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-bold transition" > Close </button>
                    </div>
                </div>
            </div>
        );
    }




    function csvEscape(val) {
      if (val === null || val === undefined) return "";
      const str = String(val);
      const needsWrap = /[",\n]/.test(str);
      const out = str.replace(/"/g, '""');
      return needsWrap ? `"${out}"` : out;
    }

    // Keep CSV schema stable and independent from the UI table headers
function rowsToCsv(rows, accountType) {
  const isFuturesAccount = String(accountType || "").toLowerCase() === "futures";
  const isForexAccount   = String(accountType || "").toLowerCase() === "forex";
  const isMixedAccount   = String(accountType || "").toLowerCase() === "mixed";
  // [!code --] Removed the block causing errors (isOptionsAccount)

  const csvHeaders = [
    "Trade #",
    "Account Type",
    "Product",
    "Position",
    "Size",
    "Actual Percent Growth",
    "Result",
    "Actual Reward",
    "Actual Balance",
    "Balance Before Trade",
    "Date",
    "Entry Time",
    "Exit Time",
    "Entry Price",   
    "Exit Price",
    // [!code ++] ADDED OPTIONS FIELDS
    "Option Type",
    "Strike",
    "Expiration",
    "Underlying Entry Price",
    "Delta",
    // -----------------------
    "Duration",
    "Potential",        
    "Ideal Stop Loss",  
    "Links_Screenshots",
    "Session",
    "Entry Strategy",
    "Exit Strategy",
    "Ticks",            
    "Pips",             
    "Timeframe",
    "Did I follow my Rules?",
    "Grade",
    "Mood_Mindset",
    "Actual Risk to Reward",
    "Stop Loss_Take Profit",
    "Total Risk",
    "Percent of Balance",
    "Notes",
    "Emotional Notes",
    "Lesson"
  ];

  const formatResult = (row) =>
    (row["Win"] === "TRUE" || row["Win"] === true)
      ? "Won"
      : (row["Loss"] === "TRUE" || row["Loss"] === true)
        ? "Loss"
        : "";

  const lines = [];
  lines.push(csvHeaders.map(csvEscape).join(","));

  rows.forEach(r => {
    const prodNorm = normalizeProductValue(r["Product"]);
    
    // Determine row-level account type
    const rowType = (r["Account Type"] || "").toLowerCase();
    const isRowStock = rowType.includes("stock") || (isMixedAccount && rowType.includes("stock"));
    const isRowForex = FOREX_VALUES.has(prodNorm) || rowType.includes("forex");
    const isRowFutures = FUTURES_VALUES.has(prodNorm) || rowType.includes("future");

    // Logic for Ticks/Pips population
    const ticksOut = (isRowFutures || isRowStock) ? (r["Ticks"] ?? r["Pips"] ?? "") : "";
    const pipsOut  = isRowForex ? (r["Pips"] ?? r["Ticks"] ?? "") : "";

    const beforeTrade = r["Balance Before Trade"] ??
                        (Number(r["Actual Balance"]) - Number(r["Actual Reward"]));

    const line = [
      r["Trade #"] ?? "",
      r["Account Type"] ?? accountType ?? "",
      getProductShort(r["Product"]),
      r["Position"] ?? "",
      r["Size"] ?? "",
      formatGrowthCell(r["Actual Percent Growth"]) ?? "",
      formatResult(r),
      formatCurrency(r["Actual Reward"]),
      formatCurrency(r["Actual Balance"]),
      formatCurrency(beforeTrade),
      formatMMDDYYYY2(r["Date"]),
      toAmPm(r["Entry Time"]),
      toAmPm(r["Exit Time"]),
      r["Entry Price"] ?? "",       
      r["Exit Price"] ?? "",
      // [!code ++] MAP NEW OPTIONS VALUES
      r["Option Type"] ?? "",
      r["Strike"] ?? "",
      r["Expiration"] ?? "",
      r["Underlying Entry Price"] ?? "",
      r["Delta"] ?? "",
      // -----------------------
      formatDuration(r["Duration"] ?? r["Duration (h:mm)"]),
      r["Potential"] ?? r["Potential Pips"] ?? "", 
      r["IdealSL"] ?? "",                          
      r["Links_Screenshots"] ?? "",
      r["Session"] ?? "",
      r["Entry Strategy"] ?? "",
      r["Exit Strategy"] ?? "",
      ticksOut,
      pipsOut,
      r["Timeframe"] ?? "",
      r["Did I follow my Rules?"] ?? "",
      r["Grade"] ?? "",
      r["Mood_Mindset"] ?? "",
      r["Actual Risk to Reward"] ?? "",
      r["Stop Loss_Take Profit"] ?? "",
      formatCurrency(r["Total Risk"] ?? r["Risk Amount"]),
      formatCurrency(r["Percent of Balance"]),
      (r["Target Reached"] === "TRUE" || r["Target Reached"] === true) ? "TRUE" : "FALSE",
      r["Notes"] ?? "",
      r["Emotional Notes"] ?? "",
      r["Lesson"] ?? ""
    ];

    lines.push(line.map(csvEscape).join(","));
  });

  return lines.join("\n");
}


    function formatGrowthCell(val) {
      if (val === null || val === undefined || String(val).trim() === "") return "–";
      // Delegate to the unified percent formatter
      return formatPercent(val);
    }


    // --- in Journal.jsx (near other helpers) ---
    // Replace the existing formatPercent(...)
    function formatPercent(val) {
      if (val === "" || val === null || typeof val === "undefined") return "–";

      // Strip any symbols (handles "102.00%")
      const n = Number(String(val).toString().replace(/[^\d.-]/g, ""));
      if (!Number.isFinite(n)) return "–";

      // Keep two decimals for non-integers; no decimals for whole numbers
      const n2 = Math.round(n * 100) / 100;
      return Number.isInteger(n2) ? `${n2}%` : `${n2.toFixed(2)}%`;
    }

    
function getRiskBudgetParts(details) {
  if (!details) return { totalRisk: null, actualRiskValue: null };

  // Use the exact keys from your console log
  const rawTotalRisk = details["Total Risk"]; 
  const rawPercentField = details["Percent of Balance"]; 
  
  const cleanNum = (val) => {
    if (val === undefined || val === null || val === "") return null;
    // Remove anything that isn't a digit, decimal, or minus sign
    const n = Number(String(val).replace(/[^\d.-]/g, ""));
    return Number.isFinite(n) ? n : null;
  };

  return { 
    totalRisk: cleanNum(rawTotalRisk), 
    actualRiskValue: cleanNum(rawPercentField) 
  };
}


function handleDownloadCSV() { 
  // Change sortedRows to filteredRows here:
  const csv = rowsToCsv(filteredRows); 
  
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" }); 
  const url = URL.createObjectURL(blob); 
  const a = document.createElement("a"); 
  a.href = url; 
  a.download = `trade_journal_${new Date().toISOString().slice(0, 10)}.csv`; 
  document.body.appendChild(a); 
  a.click(); 
  document.body.removeChild(a); 
  URL.revokeObjectURL(url); 
}
    function DeleteTradeModal({ open, onCancel, onConfirm, tradeNum, loading }) {
        if (!open) return null;
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl px-8 py-8 min-w-[340px] max-w-[95vw] border-2 border-red-400 text-center">
                    <div className="mb-4">
                        <FaTrash className="text-3xl text-red-500 mx-auto mb-2" />
                        <h2 className="text-xl font-bold text-red-700 dark:text-red-400 mb-2"> Delete Trade {tradeNum ? `#${tradeNum}` : ""} </h2>
                        <div className="text-gray-700 dark:text-gray-300"> Are you sure you want to delete this trade? <br /> This action <span className="font-bold text-red-700 dark:text-red-400">cannot be undone</span>. </div>
                    </div>
                    <div className="flex justify-center gap-4 mt-6">
                        <button onClick={onCancel} disabled={loading} className="px-6 py-2 rounded-lg bg-gray-200 dark:bg-gray-800 text-gray-700 dark:text-gray-200 font-bold hover:bg-gray-300 transition" > Cancel </button>
                        <button onClick={onConfirm} disabled={loading} className="px-6 py-2 rounded-lg bg-red-600 hover:bg-red-700 text-white font-bold transition" > {loading ? "Deleting..." : "Delete"} </button>
                    </div>
                </div>
            </div>
        );
    }
  const tradeCount = filteredRows.filter(r => !r.isFunding).length;
    return (
         <div className="flex flex-col px-2 pb-8 pt-3 min-h-screen overflow-y-auto ml-20
                         bg-gradient-to-b from-white to-blue-50 dark:from-gray-900 dark:to-gray-950 transition-colors">
            <div className="w-full max-w-[1700px] mx-auto">
              <div className="flex items-center mb-1 ml-1">
                <h1 className="text-3xl font-bold mb-1 ml-1 tracking-tight text-blue-900 dark:text-blue-200 drop-shadow-sm"> Trade Journal </h1>
              </div>
                <p className="text-gray-600 dark:text-gray-300 mt-1">
                  You can review and manage all your recorded trades here. To log a new trade, click <strong>Entry</strong> in the sidebar.
                </p>

                <div className="text-gray-600 dark:text-gray-300 mb-5 ml-1 text-sm font-semibold">
                  Total Trades: {tradeCount}
                </div>

                <div className="flex justify-between mb-4 gap-2">
                    <div className="flex gap-2">
                        <button className="flex items-center gap-2 px-4 py-2 text-sm font-semibold text-blue-800 dark:text-gray-200 bg-gray-100 dark:bg-gray-700 rounded-xl hover:bg-blue-200 dark:hover:bg-gray-600 transition" onClick={() => { setShowFilters(!showFilters); setShowBulkUpdate(false); }} >
                            <FaFilter />
                            <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        </button>
                        <button className={`flex items-center gap-2 px-4 py-2 text-sm font-semibold text-blue-800 dark:text-gray-200 bg-gray-100 dark:bg-gray-700 rounded-xl hover:bg-blue-200 dark:hover:bg-gray-600 transition ${rows.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`} onClick={() => { setShowBulkUpdate(!showBulkUpdate); setShowFilters(false); }} disabled={rows.length === 0} >
                            <FaSyncAlt />
                            <span>{showBulkUpdate ? "Hide Bulk Update" : "Bulk Update"}</span>
                        </button>
                    </div>
                    <div className="flex gap-2">

                      {/* [!code ++] START: Admin Webhook Buttons */}
                        {isAdmin && (
                          <>
                            <button
                              onClick={() => handleTradeWebhook("Buy", "MNQ", 1)}
                              className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-5 rounded-xl shadow transition active:scale-95 hidden"
                              title="Buy 1 MNQ Contract"
                            >
                              BUY
                            </button>
                            <button
                              onClick={() => handleTradeWebhook("Sell", "MNQ", 1)}
                              className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-5 rounded-xl shadow transition active:scale-95 hidden"
                              title="Sell 1 MNQ Contract"
                            >
                              SELL
                            </button>
                            <button
                              onClick={() => handleTradeWebhook("Close All", "MNQ")}
                              className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-5 rounded-xl shadow transition active:scale-95 hidden"
                              title="Close All Open Positions"
                            >
                              CLOSE ALL
                            </button>
                          </>
                        )}
                        {/* [!code ++] END */}
  
                        <button
                          className="bg-violet-600 hover:bg-violet-700 text-white font-bold py-2 px-5 rounded-xl shadow"
                          onClick={() => setImportOpen(true)}
                          type="button"
                        >
                          <span className="inline-flex items-center gap-2">
                            <FaUpload/> Import / Connect
                          </span>
                        </button>



                        <button className={`bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-5 rounded-xl shadow ${rows.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`} onClick={handleDownloadCSV} disabled={rows.length === 0} >
                            <span className="inline-flex items-center gap-2"> <FaDownload /> Download CSV </span>
                        </button>
                        <button className={`bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-5 rounded-xl shadow ${rows.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`} onClick={() => setShowResetConfirm(true)} disabled={rows.length === 0} > Reset Journal </button>
                    </div>
                </div>
                {showFilters && (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6 p-4 rounded-xl shadow-inner bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 transition-all duration-300 ease-in-out">
                          <div>
                              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">From</label>
                              <input
                                type="date"
                                value={filters.startDate}
                                onChange={(e) => setFilters(f => ({ ...f, startDate: e.target.value }))}
                                className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">To</label>
                              <input
                                type="date"
                                value={filters.endDate}
                                onChange={(e) => setFilters(f => ({ ...f, endDate: e.target.value }))}
                                className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                              />
                            </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Product</label>
                            <select
                              value={filters.product}
                              onChange={(e) => setFilters(f => ({ ...f, product: e.target.value }))}
                              className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            >
                              <option value="">All</option>
                              {filterOptions.products.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                              ))}
                            </select>
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Result</label>
                            <select
                              value={filters.result}
                              onChange={(e) => setFilters(f => ({ ...f, result: e.target.value }))}
                              className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            >
                              <option value="">All</option>
                              {RESULT_OPTIONS.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                              ))}
                            </select>
                          </div>
                          {/* Session Filter */}
                              <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Session</label>
                                <select
                                  value={filters.session}
                                  onChange={(e) => setFilters(f => ({ ...f, session: e.target.value }))}
                                  className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                >
                                  <option value="">All</option>
                                  <option value={BLANK}>(Blank/None)</option>
                                  {SESSION_OPTIONS.map(opt => (
                                    <option key={opt} value={opt}>{opt}</option>
                                  ))}
                                </select>
                              </div>

                              {/* PnL Range Filters */}
                              <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Min PnL ($)</label>
                                <input
                                  type="number"
                                  step="any"
                                  placeholder="e.g., -500"
                                  value={filters.pnlMin}
                                  onChange={(e) =>
                                    setFilters((f) => ({
                                      ...f,
                                      pnlMin: e.target.value
                                    }))
                                  }
                                  className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                />
                              </div>
                              <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Max PnL ($)</label>
                                <input
                                  type="number"
                                  step="any"
                                  placeholder="e.g., -100"
                                  value={filters.pnlMax}
                                  onChange={(e) =>
                                    setFilters((f) => ({
                                      ...f,
                                      pnlMax: e.target.value
                                    }))
                                  }
                                  className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                />
                              </div>

                              {/* Timeframe */}
                             <div>
                               <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Timeframe</label>
                               <select
                                 value={filters.timeframe}
                                 onChange={(e) => setFilters(f => ({ ...f, timeframe: e.target.value }))}
                                 className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline:none focus:ring-blue-500 focus:border-blue-500"
                               >
                                 <option value="">All</option>
                                 <option value={BLANK}>(Blank/None)</option>
                                 {(filterOptions.timeframes.length ? filterOptions.timeframes : TIMEFRAME_OPTIONS).map(tf => (
                                   <option key={tf} value={tf}>{tf}</option>
                                 ))}
                               </select>
                             </div>

                              {/* Entry Time Range Filters */}
                              <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Entry Time (From)</label>
                                <input
                                  type="time"
                                  value={filters.entryTimeFrom}
                                  onChange={(e) => setFilters(f => ({ ...f, entryTimeFrom: e.target.value }))}
                                  className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                />
                              </div>
                              <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Entry Time (To)</label>
                                <input
                                  type="time"
                                  value={filters.entryTimeTo}
                                  onChange={(e) => setFilters(f => ({ ...f, entryTimeTo: e.target.value }))}
                                  className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                />
                              </div>

                              {/* Exit Time Range Filters */}
                              <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Exit Time (From)</label>
                                <input
                                  type="time"
                                  value={filters.exitTimeFrom}
                                  onChange={(e) => setFilters(f => ({ ...f, exitTimeFrom: e.target.value }))}
                                  className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                />
                              </div>
                              <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Exit Time (To)</label>
                                <input
                                  type="time"
                                  value={filters.exitTimeTo}
                                  onChange={(e) => setFilters(f => ({ ...f, exitTimeTo: e.target.value }))}
                                  className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                />
                              </div>

                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Rules</label>
                            <select
                              value={filters.rules}
                              onChange={(e) => setFilters(f => ({ ...f, rules: e.target.value }))}
                              className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            >
                              <option value="">All</option>
                              <option value={BLANK}>(Blank/None)</option>
                              {RULES_OPTIONS.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                              ))}
                            </select>

                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Position</label>
                            <select
                              value={filters.position}
                              onChange={(e) => setFilters(f => ({ ...f, position: e.target.value }))}
                              className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            >
                              <option value="">All</option>
                              {POSITION_OPTIONS.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                              ))}
                            </select>
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Entry Strategy</label>
                            <select
                              value={filters.entryStrategy}
                              onChange={(e) => setFilters(f => ({ ...f, entryStrategy: e.target.value }))}
                              className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            >
                              <option value="">All</option>
                              <option value={BLANK}>(Blank/None)</option>
                              {filterOptions.entryStrategies.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                              ))}
                            </select>

                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Exit Strategy</label>
                            <select
                              value={filters.exitStrategy}
                              onChange={(e) => setFilters(f => ({ ...f, exitStrategy: e.target.value }))}
                              className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            >
                              <option value="">All</option>
                              <option value={BLANK}>(Blank/None)</option>
                              {filterOptions.exitStrategies.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                              ))}
                            </select>
                          </div>

                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Day of the Week</label>
                            <select
                              value={filters.dayOfWeek}
                              onChange={(e) => setFilters(f => ({ ...f, dayOfWeek: e.target.value }))}
                              className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            >
                              <option value="">All</option>
                              <option value="Monday">Monday</option>
                              <option value="Tuesday">Tuesday</option>
                              <option value="Wednesday">Wednesday</option>
                              <option value="Thursday">Thursday</option>
                              <option value="Friday">Friday</option>
                              <option value="Saturday">Saturday</option>
                              <option value="Sunday">Sunday</option>
                            </select>
                          </div>

                            {/* Mood */}
                            <div>
                              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Mood</label>
                              <select
                                value={filters.mood}
                                onChange={(e) => setFilters(f => ({ ...f, mood: e.target.value }))}
                                className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                              >
                                <option value="">All</option>
                                <option value={BLANK}>(Blank/None)</option>
                                {(filterOptions.moods.length ? filterOptions.moods : MOOD_OPTIONS).map(opt => (
                                  <option key={opt} value={opt}>{opt}</option>
                                ))}
                              </select>
                            </div>
                          
                            {/* Grade */}
                            <div>
                              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Grade</label>
                              <select
                                value={filters.grade}
                                onChange={(e) => setFilters(f => ({ ...f, grade: e.target.value }))}
                                className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                              >
                                <option value="">All</option>
                                <option value={BLANK}>(Blank/None)</option>
                                {(filterOptions.grades.length ? filterOptions.grades : GRADE_OPTIONS).map(opt => (
                                  <option key={opt} value={opt}>{opt}</option>
                                ))}
                              </select>
                            </div>

                            <div>
                              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Needs Review</label>
                              <select
                                value={filters.needsReview}
                                onChange={(e) => setFilters(f => ({ ...f, needsReview: e.target.value }))}
                                className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                              >
                                <option value="">All</option>
                                <option value="TRUE">Flagged (Red)</option>
                                <option value="FALSE">Unflagged (Gray)</option>
                              </select>
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Target Reached</label>
                              <select
                                value={filters.targetReached}
                                onChange={(e) => setFilters(f => ({ ...f, targetReached: e.target.value }))}
                                className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                              >
                                <option value="">All</option>
                                <option value="TRUE">Yes</option>
                                <option value="FALSE">No</option>
                              </select>
                            </div>
                             

                          <div className="flex items-end lg:col-span-4">
                                <button
                                   onClick={() => setFilters({
                                     startDate: "",
                                     endDate: "",
                                     entryTimeFrom: "",
                                     entryTimeTo: "",
                                     exitTimeFrom: "",
                                     exitTimeTo: "",
                                     session: "",
                                     pnlMin: "",
                                     pnlMax: "",
                                     product: "",
                                     result: "",
                                     rules: "",
                                     position: "",
                                     entryStrategy: "",
                                     exitStrategy: "",
                                     mood: "",
                                     grade: "",
                                     timeframe: ""
                                   })}
                                  className="w-full px-4 py-2 text-sm font-medium text-blue-700 bg-blue-100 rounded-md hover:bg-blue-200 dark:text-blue-100 dark:bg-gray-700 dark:hover:bg-gray-600"
                                >
                                  Clear Filters
                                </button>
                              </div>
                        </div>
                      )}
                      {showBulkUpdate && (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6 p-4 rounded-xl shadow-inner bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 transition-all duration-300 ease-in-out">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Entry Strategy</label>
                            <input
                              type="text"
                              value={bulkUpdateValues.entryStrategy}
                              onChange={(e) => setBulkUpdateValues(v => ({ ...v, entryStrategy: e.target.value }))}
                              className="
                                w-full px-3 py-2 text-sm
                                bg-white text-gray-900
                                dark:bg-gray-900 dark:text-gray-100
                                placeholder:text-gray-400 dark:placeholder:text-gray-500
                                border border-gray-300 dark:border-gray-600
                                rounded-md shadow-sm
                                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
                              "
                              placeholder="e.g., EMA Cross"
                            />
                          </div>
                          <div>
                            <label className="block text sm font-medium text-gray-700 dark:text-gray-300 mb-1">Exit Strategy</label>
                            <input
                              type="text"
                              value={bulkUpdateValues.exitStrategy}
                              onChange={(e) => setBulkUpdateValues(v => ({ ...v, exitStrategy: e.target.value }))}
                              className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline:none focus:ring-blue-500 focus:border-blue-500"
                              placeholder="e.g., Take Profit"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Rules</label>
                            <select
                              value={bulkUpdateValues.rules}
                              onChange={(e) => setBulkUpdateValues(v => ({ ...v, rules: e.target.value }))}
                              className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            >
                              <option value="">(No Change)</option>
                              {RULES_OPTIONS.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                              ))}
                            </select>
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Mood</label>
                            <select
                              value={bulkUpdateValues.mood}
                              onChange={(e) => setBulkUpdateValues(v => ({ ...v, mood: e.target.value }))}
                              className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline:none focus:ring-blue-500 focus:border-blue-500"
                            >
                              <option value="">(No Change)</option>
                              {MOOD_OPTIONS.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                              ))}
                            </select>
                          </div>
                                {/* Grade */}
                                <div>
                                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Grade</label>
                                  <select
                                    value={bulkUpdateValues.grade}
                                    onChange={(e) => setBulkUpdateValues(v => ({ ...v, grade: e.target.value }))}
                                    className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline none focus:ring-blue-500 focus:border-blue-500"
                                  >
                                    <option value="">(No Change)</option>
                                    {GRADE_OPTIONS.map(opt => (<option key={opt} value={opt}>{opt}</option>))}
                                  </select>
                                </div>
                          
                                {/* Session */}
                                <div>
                                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Session</label>
                                  <select
                                    value={bulkUpdateValues.session}
                                    onChange={(e) => setBulkUpdateValues(v => ({ ...v, session: e.target.value }))}
                                    className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline none focus:ring-blue-500 focus:border-blue-500"
                                  >
                                    <option value="">(No Change)</option>
                                    {SESSION_OPTIONS.map(opt => (<option key={opt} value={opt}>{opt}</option>))}
                                  </select>
                                </div>
                                 {/* Timeframe */}
                                 <div>
                                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Timeframe</label>
                                   <input
                                     type="text"
                                     list="journal-timeframe-options-bulk"
                                     value={bulkUpdateValues.timeframe}
                                     onChange={(e) => setBulkUpdateValues(v => ({ ...v, timeframe: e.target.value }))}
                                     className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline none focus:ring-blue-500 focus:border-blue-500"
                                     placeholder="e.g., 5m"
                                   />
                                   <datalist id="journal-timeframe-options-bulk">
                                     {TIMEFRAME_OPTIONS.map(tf => <option key={tf} value={tf} />)}
                                   </datalist>
                                 </div>
                                 {/* Product */}
                                 <div>
                                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Product</label>
                                   <input
                                     type="text"
                                     list="journal-bulk-product-options"
                                     value={bulkUpdateValues.product}
                                     onChange={(e) => setBulkUpdateValues(v => ({ ...v, product: e.target.value }))}
                                     className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                     placeholder="e.g., NQ, AAPL"
                                   />
                                   <datalist id="journal-bulk-product-options">
                                     {filterOptions.products.map(opt => <option key={opt} value={opt} />)}
                                   </datalist>
                                 </div>

                                 {/* Position */}
                                 <div>
                                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Position</label>
                                   <select
                                     value={bulkUpdateValues.position}
                                     onChange={(e) => setBulkUpdateValues(v => ({ ...v, position: e.target.value }))}
                                     className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                   >
                                     <option value="">(No Change)</option>
                                     {POSITION_OPTIONS.map(opt => (<option key={opt} value={opt}>{opt}</option>))}
                                   </select>
                                 </div>

                                 {/* Stop Loss / TP */}
                                 <div>
                                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Stop Loss / TP</label>
                                   <input
                                     type="text"
                                     value={bulkUpdateValues.stopLoss}
                                     onChange={(e) => setBulkUpdateValues(v => ({ ...v, stopLoss: e.target.value }))}
                                     className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                     placeholder="e.g., 10 / 20"
                                   />
                                 </div>

                                 <div>
                                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Needs Review</label>
                                   <select
                                     value={bulkUpdateValues.needsReview}
                                     onChange={(e) => setBulkUpdateValues(v => ({ ...v, needsReview: e.target.value }))}
                                     className="w-full px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                   >
                                     <option value="">(No Change)</option>
                                     <option value="TRUE">Flag for Review</option>
                                     <option value="FALSE">Remove Flag</option>
                                   </select>
                                 </div>

                                <div className="col-span-1 md:col-span-2 lg:col-span-4 flex items-end justify-end gap-3">
                                  <button
                                    type="button"
                                      onClick={() => {
                                        setBulkUpdateValues({
                                          entryStrategy: "",
                                          exitStrategy: "",
                                          rules: "",
                                          mood: "",
                                          grade: "",
                                          session: "",
                                          timeframe: "",
                                          product: "",      
                                          position: "",     
                                          stopLoss: ""      
                                        });
                                         setShowBulkUpdate(false);
                                    }}
                                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 dark:text-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 md:w-auto w-full"
                                  >
                                    Cancel
                                  </button>

                                  <button
                                    type="button"
                                    onClick={() => setShowBulkUpdateConfirm(true)}
                                    className={`px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 md:w-auto w-full ${filteredRows.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
                                    disabled={!Object.values(bulkUpdateValues).some(v => v) || filteredRows.length === 0}
                                  >
                                    Update {filteredRows.length} Trades
                                  </button>
                                </div>
                        </div>
                      )}
                <ResetJournalModal open={showResetConfirm} onCancel={() => setShowResetConfirm(false)} onConfirm={handleResetJournal} loading={resetting} />
                <BulkUpdateConfirmModal open={showBulkUpdateConfirm} onCancel={() => setShowBulkUpdateConfirm(false)} onConfirm={handleBulkUpdate} count={filteredRows.length} loading={bulkUpdating} />
                <BulkUpdateSuccessModal open={showBulkUpdateSuccess} onDismiss={() => setShowBulkUpdateSuccess(false)} count={bulkUpdateCount} />
                <div className="overflow-x-auto rounded-2xl shadow-2xl bg-white/90 dark:bg-gray-800 p-3 border border-blue-100 dark:border-gray-700">
                    {loading ? (
                        <div className="flex flex-col items-center justify-center min-h-[240px]">
                            <svg className="animate-spin h-8 w-8 text-blue-400 mb-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-80" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" /></svg>
                            <div className="text-blue-500 font-semibold text-lg">Loading...</div>
                        </div>
                    ) : (
                        <>
                            <table className="w-full text-[13px] text-left border-separate border-spacing-y-1">
                                <thead>
                                    <tr>
                                        {headers.map((header) => {
                                            const isSortable = !["Link", "Details", "Edit", "Delete", "Download", "Funding"].includes(header);
                                            return (
                                                <th
                                                    key={header}
                                                    className={`px-1 py-3 bg-blue-50 dark:bg-gray-700 font-bold text-blue-800 dark:text-blue-100 text-xs uppercase tracking-wide first:rounded-tl-xl last:rounded-tr-xl shadow select-none ${
                                                        isSortable ? "cursor-pointer hover:bg-blue-100 dark:hover:bg-gray-600" : ""
                                                    }`}
                                                    onClick={() => isSortable && handleSort(header)}
                                                >
                                                    <div className="flex items-center gap-1">
                                                        {header}
                                                        {isSortable && sortConfig.key === header && (
                                                            <span className="text-[10px] text-blue-500 dark:text-blue-300">
                                                                {sortConfig.direction === "asc" ? "▲" : "▼"}
                                                            </span>
                                                        )}
                                                    </div>
                                                </th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {pagedRows.length === 0 && (<tr><td colSpan={headers.length} className="text-center py-8 text-gray-400 dark:text-gray-500"> No trades found. </td></tr>)}
                                    {pagedRows.map((row, idx) => (
                                        <tr key={row.id || idx} className="transition hover:scale-[1.01] hover:bg-blue-100/30 dark:hover:bg-gray-900/30 duration-200 shadow-sm rounded-2xl" style={{ borderBottom: "2px solid #f2f6fa" }}>
                                            <td className="px-1 py-1 font-bold text-blue-700 dark:text-blue-200">{row["Trade #"]}</td>
                                            <td className="px-1 py-1 text-gray-900 dark:text-gray-100">{getProductShort(row["Product"])}</td>
                                            <td className="px-1 py-1 text-gray-900 dark:text-gray-100">{row["Position"]}</td>
                                            <td className="px-1 py-1 text-center text-gray-900 dark:text-gray-100">
                                               {isFundingRow(row) ? "" : row["Size"]}
                                             </td>
                                            <td className={`px-1 py-1 text-center ${isPrivacyMode ? "text-gray-400" : getNegativeClass(row["Actual Percent Growth"])} text-gray-900 dark:text-gray-100`}>
                                              {isPrivacyMode ? "******" : formatGrowthCell(row["Actual Percent Growth"])}
                                            </td>
                                            <td className="px-1 py-1">{getResultCell(row)}</td>
                                            {!hideFunding && (
                                              <td className="px-1 py-1 text-gray-900 dark:text-gray-100">
                                                {isFundingRow(row) ? (
                                                  <span
                                                    className={`inline-block px-2 py-0.5 rounded-md text-xs font-bold ${
                                                      String(row["Funding Type"] || "").toLowerCase() === "deposit"
                                                        ? "bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300"
                                                        : "bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300"
                                                    }`}
                                                    title={`${row["Funding Type"]} ${formatCurrency(row["Funding Amount"])}`}
                                                  >
                                                    {row["Funding Type"]} {formatCurrency(row["Funding Amount"])}
                                                  </span>
                                                ) : (
                                                  <span className="text-gray-400 dark:text-gray-500">–</span>
                                                )}
                                              </td>
                                            )}
                                            <td className={`px-1 py-1 ${getNegativeClass(row["Actual Reward"])} text-gray-900 dark:text-gray-100`}>{isPrivacyMode ? "******" :formatCurrency(row["Actual Reward"])}</td>
                                            <td className="px-1 py-1 text-gray-900 dark:text-gray-100">
                                              {isPrivacyMode ? "******" : formatCurrency(row["Actual Balance"])}
                                            </td>

                                           {/* Pips/Ticks/Points Cell */}
                                           <td className="px-1 py-1 text-gray-900 dark:text-gray-100">
                                             {isFundingRow(row)
                                               ? "—"
                                               : (() => {
                                                   // 1. Smart Symbol Extraction: "ES DEC25" -> "ES"
                                                   const rawProd = String(row["Product"] || "").toUpperCase();
                                                   let rootSym = rawProd.split(/[\s-]/)[0].replace(/[^\w]/g, ""); 
                                                   rootSym = rootSym.replace(/[FGHJKMNQUVXZ][0-9]{1,2}$/, ""); 
                                                   
                                                   const rowAcct = String(row["Account Type"] || "").toLowerCase();
                                                   
                                                   // ADD THIS NEW INDEX CHECK
                                                   const isIndex = ["US30", "NAS100", "SPX500", "GER30", "UK100"].includes(rootSym);
                                                   
                                                   // ADD isIndex TO THE END OF THIS LINE
                                                   const isFx = FOREX_VALUES?.has(rootSym) || rowAcct.includes("forex") || /^[A-Z]{6}$/.test(rawProd) || isIndex;
                                                   const isFut = FUTURES_VALUES?.has(rootSym) || rowAcct.includes("future") || ["ES","NQ","YM","RTY","CL","GC","MES","MNQ","MYM","MGC","MCL","NG","MNG","SI","SIL"].includes(rootSym);

                                                   // 2. Safely grab the saved value, prioritizing non-zero numbers
                                                   const getValidVal = (...keys) => {
                                                       for (const k of keys) {
                                                           const v = row[k];
                                                           if (v != null && v !== "") {
                                                               const num = Number(String(v).replace(/[^\d.-]/g, ""));
                                                               if (!isNaN(num) && num !== 0) return num;
                                                           }
                                                       }
                                                       for (const k of keys) {
                                                           const v = row[k];
                                                           if (v != null && v !== "") {
                                                               const num = Number(String(v).replace(/[^\d.-]/g, ""));
                                                               if (!isNaN(num)) return num;
                                                           }
                                                       }
                                                       return null;
                                                   };
                                                   
                                                   let savedVal = getValidVal("Movement", "Ticks", "Pips", "Points");

                                                   const entry = Number(row["Entry Price"]);
                                                   const exit = Number(row["Exit Price"]);
                                                   const canCalc = entry > 0 && exit > 0;

                                                   let finalVal = null;

                                                   // 3. Always calculate if prices exist
                                                   if (canCalc) {
                                                       const diff = Math.abs(exit - entry);
                                                       const sign = (row["Loss"] === "TRUE" || row["Loss"] === true) ? -1 : 1;
                                                       
                                                       if (isFx) {
                                                           let pSize = 0.0001;
                                                           if (rootSym.includes("JPY") || rootSym.includes("XAU") || rootSym.includes("GOLD") || rootSym.includes("XAG") || rootSym.includes("SILVER")) pSize = 0.01;
                                                           const isIndex = ["US30", "NAS100", "SPX500", "GER30", "UK100"].includes(rootSym);
                                                           if (isIndex) pSize = 1;
                                                           
                                                           // Keeps the * 10 for Indices so it outputs Pips
                                                           finalVal = (diff / pSize) * (isIndex ? 10 : 1) * sign;
                                                       } else if (isFut) {
                                                           const TICK_SIZES = {
                                                               YM: 1, MYM: 1, ES: 0.25, MES: 0.25, NQ: 0.25, MNQ: 0.25,
                                                               RTY: 0.1, M2K: 0.1, GC: 0.1, MGC: 0.1, CL: 0.01, MCL: 0.01,
                                                               NG: 0.001, MNG: 0.001, SI: 0.005, SIL: 0.005, BTC: 5, MBT: 5,
                                                           };
                                                           const tSize = TICK_SIZES[rootSym] || Number(row["tickSize"]) || 0.25;
                                                           finalVal = (diff / tSize) * sign;
                                                       } else {
                                                           finalVal = diff * sign; // Points for Stocks/Options
                                                       }
                                                   } 
                                                   // 4. Fallback to saved value
                                                   else if (savedVal !== null) {
                                                       finalVal = savedVal;
                                                   }

                                                   // 5. Display Logic & Smart Zero-Filter
                                                   if (finalVal === null || isNaN(finalVal)) return "—";
                                                   if (finalVal === 0 && Number(row["Actual Reward"]) !== 0) return "—";

                                                   // Smart Decimal Rendering
                                                   if (isFx || isFut) {
                                                       return Math.round(finalVal).toString();
                                                   } else {
                                                       return finalVal.toFixed(2); // Keeps decimals for Stocks/Options
                                                   }
                                                 })()}
                                           </td>


                                            <td className="px-1 py-1 text-gray-900 dark:text-gray-100">{formatMMDDYYYY(row["Date"])}</td>
                                            <td className="px-1 py-1 text-gray-900 dark:text-gray-100">
                                              {formatTimeWithAmPm(row["Entry Time"])}
                                            </td>
                                            <td className="px-1 py-1 text-gray-900 dark:text-gray-100">
                                              {formatTimeWithAmPm(row["Exit Time"])}
                                            </td>

                                            <td className="px-1 py-1 text-gray-900 dark:text-gray-100">
                                              {formatDuration(row["Duration"] || row["Duration (h:mm)"])}
                                            </td>
                                            <td className="px-1 py-1 text-blue-600 dark:text-blue-300 hover:underline max-w-[60px] truncate">
                                                {isValidUrl(row["Links_Screenshots"]) && (
                                                    <a href={row["Links_Screenshots"].startsWith("http") ? row["Links_Screenshots"] : "https://" + row["Links_Screenshots"]} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-blue-50 dark:bg-gray-700 hover:bg-blue-100 dark:hover:bg-blue-900" title="View Link">
                                                        <FaRegStickyNote className="text-blue-700 dark:text-blue-300" />
                                                    </a>
                                                )}
                                            </td>
                                            <td className="px-2 py-1 text-center">
                                              {isFundingRow(row) ? (
                                                <span className="text-gray-400 dark:text-gray-600">—</span>
                                              ) : (
                                                <button
                                                  className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-blue-50 dark:bg-gray-700 hover:bg-blue-100 dark:hover:bg-blue-900 focus:outline-none transition"
                                                  onClick={() => setPopupTradeId(row.id)}
                                                  title="Show Details"
                                                  type="button"
                                                >
                                                  <FaRegStickyNote className="justify-left text-blue-700 dark:text-blue-300" />
                                                </button>
                                              )}
                                            </td>                                            
                                            <td className="px-2 py-1 text-left">
                                              {isFundingRow(row) ? (
                                                <span className="text-gray-400 dark:text-gray-600">—</span>
                                              ) : (
                                                <button
                                                  className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-green-50 dark:bg-green-900 hover:bg-green-100 dark:hover:bg-green-700 focus:outline-none transition"
                                                  onClick={() => setEditTradeId(row.id)}
                                                  title="Edit"
                                                  type="button"
                                                >
                                                  <FaEdit className="text-green-700 dark:text-green-300" />
                                                </button>
                                              )}
                                            </td>

                                            <td className="px-2 py-1 text-left">
                                              <button
                                                className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-red-50 dark:bg-red-900 hover:bg-red-100 dark:hover:bg-red-700"
                                                onClick={() => { setTradeToDelete(row); setShowDeleteModal(true); }}
                                                title="Delete"
                                                type="button"
                                              >
                                                <FaTrash className="text-red-700 dark:text-red-300" />
                                              </button>
                                            </td>

                                            <td className="px-2 py-1 text-center">
                                                  <button
                                                    className="p-1.5 transition focus:outline-none transform active:scale-90"
                                                    onClick={() => {
                                                      // Find the exact index in filteredRows so we update the correct trade
                                                      const globalIdx = filteredRows.findIndex(r => r.id === row.id);
                                                      const isCurrentlyFlagged = row["Needs Review"] === "TRUE" || row["Needs Review"] === true;
                                                      handleUpdateJournalRow(globalIdx, { ...row, "Needs Review": isCurrentlyFlagged ? "FALSE" : "TRUE" });
                                                    }}
                                                    title={row["Needs Review"] === "TRUE" || row["Needs Review"] === true ? "Unflag Trade" : "Flag for Review"}
                                                    type="button"
                                                  >
                                                    <FaFlag 
                                                      className={`h-4 w-4 ${
                                                        row["Needs Review"] === "TRUE" || row["Needs Review"] === true 
                                                          ? "text-red-600 drop-shadow-sm" 
                                                          : "text-gray-300 dark:text-gray-600 hover:text-gray-400"
                                                      }`} 
                                                    />
                                                  </button>
                                              </td>

                                             <td className="px-2 py-1 text-left">
                                              {/* --- ADD THIS BUTTON WHERE YOU WANT IT (e.g., near Edit/Delete) --- */}
                                              <button
                                                onClick={() => handleDownloadImage(row)}
                                                className="p-2 text-gray-500 hover:text-blue-600 transition"
                                                title="Download Image"
                                              >
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                                </svg>
                                              </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="flex justify-between items-center mt-6 mb-1">
                                <div className="text-gray-800 dark:text-gray-200"> Page {currentPage} of {pageCount} </div>
                                <div className="flex gap-2">
                                    <button className="px-3 py-1 rounded bg-blue-100 dark:bg-gray-700 text-blue-800 dark:text-blue-100 disabled:opacity-60" onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} > Prev </button>
                                    <button className="px-3 py-1 rounded bg-blue-100 dark:bg-gray-700 text-blue-800 dark:text-blue-100 disabled:opacity-60" onClick={() => setCurrentPage(p => Math.min(p + 1, pageCount))} disabled={currentPage === pageCount} > Next </button>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>


         {/* Hidden export templates for each trade (used by handleDownloadImage) */}
        {filteredRows
          .filter((row) => !isFundingRow(row)) // no export for funding rows
          .map((row) => {
            const exportKey = row.id || row["Trade #"];
            const screenshotUrl = resolveExportScreenshotUrl(row);

            const actualReward = Number(row["Actual Reward"] || 0);

            const rewardColor =
              actualReward > 0
                ? "text-green-600"
                : actualReward < 0
                ? "text-red-600"
                : "text-gray-900 dark:text-gray-100";


            return (
              <div
                key={`export-${exportKey}`}
                id={`trade-export-${exportKey}`}
                style={{
                  display: "none",
                  position: "absolute",
                  top: "-9999px",
                  width: "600px",
                  padding: "24px",
                  backgroundColor: "white",
                  fontFamily: "sans-serif",
                  border: "1px solid #eee",
                }}
              >
                {/* 1. Header Image */}
                {screenshotUrl && (
                  <div className="mb-4 overflow-hidden rounded-lg border border-gray-200">
                    <img
                      src={screenshotUrl}
                      alt="Chart"
                      className="w-full object-cover"
                      style={{ maxHeight: "300px" }}
                      crossOrigin="anonymous"
                      referrerPolicy="no-referrer"
                    />
                  </div>
                )}

                {/* 2. Header Info */}
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900">
                      {normalizeProductValue(row["Product"])}
                    </h2>
                    <p className="text-gray-500">{formatMMDDYYYY2(row["Date"])}</p>
                  </div>
                  <div
                    className={`text-xl font-bold ${
                      (row["Win"] || parseFloat(row["Actual Reward"]) > 0)
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    {(row["Win"] || parseFloat(row["Actual Reward"]) > 0)
                      ? "WIN"
                      : "LOSS"}
                  </div>
                </div>

                {/* 3. Grid Details */}
                <div className="grid grid-cols-2 gap-4 text-sm border-t border-gray-100 pt-4">
                  <div className="space-y-2">
                    <p>
                      <span className="font-semibold text-gray-600">
                        Position:
                      </span>{" "}
                      {row["Position"]}
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Timeframe:
                      </span>{" "}
                      {row["Timeframe"]}
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Size:
                      </span>{" "}
                      {row["Size"]}{" "}
                      {(() => {
                        if (accountType === "futures") return "contracts"; // futures
                        return "lots";                                     // forex / default
                      })()}
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        {accountType === "futures" ? "Ticks:" : "Pips:"}
                      </span>{" "}
                      {accountType === "futures"
                        ? (row["Ticks"] ?? row["Pips"] ?? row["Tcks"]) 
                        : (row["Pips"]  ?? row["Ticks"] ?? row["Tcks"])} 
                    </p>
                  </div>
                  <div className="space-y-2">
                    <p>
                      <span className="font-semibold text-gray-600">
                        Entry:
                      </span>{" "}
                      {formatTimeWithAmPm(row["Entry Time"])}{" "}
                      {row["Entry Price"] && `@ ${row["Entry Price"]}`}
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Exit:
                      </span>{" "}
                      {formatTimeWithAmPm(row["Exit Time"])}{" "}
                      {row["Exit Price"] && `@ ${row["Exit Price"]}`}
                    </p>
                    {/* NEW: Duration directly under Exit */}
                    {(row["Duration"] || row["Duration (h:mm)"]) && (
                      <p>
                        <span className="font-semibold text-gray-600">
                          Duration:
                        </span>{" "}
                        {formatDuration(row["Duration"] || row["Duration (h:mm)"])}
                      </p>
                    )}

                    <p>
                      <span className="font-semibold text-gray-600">
                        Reward:
                      </span>{" "}
                      <span className={`font-bold ${rewardColor}`}>
                        {formatCurrency(actualReward)}
                      </span>
                    </p>
                  </div>
                </div>

                {/* 4. Strategies & Notes */}
                <div className="mt-4 pt-4 border-t border-gray-100 space-y-3">
                  {(row["Entry Strategy"] || row["Exit Strategy"]) && (
                    <div>
                      <p className="font-semibold text-gray-700">Strategy</p>
                      <p className="text-gray-600 text-sm">
                        {row["Entry Strategy"]}{" "}
                        {row["Entry Strategy"] && row["Exit Strategy"] ? "/" : ""}{" "}
                        {row["Exit Strategy"]}
                      </p>
                    </div>
                  )}

                  {row["Notes"] && (
                    <div>
                      <p className="font-semibold text-gray-700">Notes</p>
                      <p className="text-gray-600 text-sm bg-gray-50 p-2 rounded mt-1">
                        {row["Notes"]}
                      </p>
                    </div>
                  )}
                </div>

                {/* Footer Branding */}
                <div className="mt-6 text-center text-xs text-gray-400">
                  
                </div>
              </div>
            );
          })}





            <DetailsPopup
              open={popupIdx !== null && popupIdx !== -1}
              onClose={() => setPopupTradeId(null)}
              details={popupIdx !== null && popupIdx !== -1 ? filteredRows[popupIdx] : null}
              onViewChecklist={handleViewChecklistFor}
              canViewChecklist={pretradeEnabled}
              loadingPTC={ptcLoading}
              onPrev={goPrevDetails}
              onNext={goNextDetails}
              isBacktesting={isBacktesting}
              hasPrev={canPrevDetails}
              hasNext={canNextDetails}
              accountType={accountType}
              isPrivacyMode={isPrivacyMode}
              settings={settings}
            />

            <EditJournalModal
              settings={settings}
              open={editIdx !== null && editIdx !== -1}
              onClose={() => setEditTradeId(null)}
              row={editIdx !== null && editIdx !== -1 ? filteredRows[editIdx] : null}
              rowIndex={editIdx}
              onSave={handleUpdateJournalRow}
              accountType={accountType}
              userId={userId}
              onPrev={goPrevEdit}
              onNext={goNextEdit}
              hasPrev={canPrevEdit}
              hasNext={canNextEdit}
              isPropAcct={isPropAcct} 
              maxLossLimit={maxLossLimit} 
              isPropEval={isPropEval}
              isBacktesting={isBacktesting}
              isPrivacyMode={isPrivacyMode}
            />
            
            <DeleteTradeModal
              open={showDeleteModal}
              onCancel={() => { setShowDeleteModal(false); setTradeToDelete(null); }}
              onConfirm={async () => {
                if (!tradeToDelete) return;
                try {
                  setDeleting(true);

                  // 1) If this account is a leader and this is the latest trade,
                  //    also delete copies from follower accounts.
                  try {
                    const me = await getSettings(userId, accountId);
                    const isLeader =
                      me?.CopyTrade?.role === "leader" ||
                      me?.settings?.CopyTrade?.role === "leader";

                    if (isLeader) {
                      // Find latest non-funding trade in this account
                      const latest = rows
                        .filter(r => !isFundingRow(r))
                        .slice()
                        .sort((a, b) => {
                          const tA = new Date(a["Date"]).getTime() || 0;
                          const tB = new Date(b["Date"]).getTime() || 0;
                          if (tB !== tA) return tB - tA;
                          const nA = parseInt(a["Trade #"], 10) || 0;
                          const nB = parseInt(b["Trade #"], 10) || 0;
                          return nB - nA;
                        })[0];

                      const isLatestTrade = latest && latest.id === tradeToDelete.id;

                      if (isLatestTrade) {
                        await deleteLeaderTradeFromFollowers({
                          userId,
                          leaderAccountId: accountId,
                          leaderTrade: tradeToDelete,
                          accountType: accountType || "futures",
                        });
                      }
                    }
                  } catch (err) {
                    console.error("[CopyTrade] follower delete propagation failed:", err);
                    // Don't block the leader delete if followers fail
                  }

                  // 2) Delete on the leader (current) account
                  await deleteJournalRow(userId, accountId, tradeToDelete.id);

                  // 3) Update local UI
                  const nextRows = rows.filter(r => r.id !== tradeToDelete.id);
                  setRows(nextRows);

                  // 4) Recompute this account's balances
                  await recomputeBalancesAfterDelete(nextRows.filter(r => !isFundingRow(r)), tradeToDelete);
                } catch (e) {
                  console.error(e);
                  alert("Failed to delete the trade. Please try again.");
                } finally {
                  setDeleting(false);
                  setShowDeleteModal(false);
                  setTradeToDelete(null);
                }
              }}
              tradeNum={tradeToDelete?.["Trade #"]}
              loading={deleting}
            />

        {showPTC && (
          <PreTradeChecklistModal
            readOnly
            initialSelections={ptcData || {}}
            dateLabel={prettyDate(ptcDateStr)}
            onClose={() => setShowPTC(false)}
            // onConfirm is ignored in readOnly mode
          />
        )}

        {ptcNotFound && (
          <div className="fixed top-4 right-4 z-[100] max-w-sm rounded-xl border border-blue-300 bg-blue-50 text-blue-900 dark:bg-blue-900/30 dark:text-blue-100 shadow-lg">
            <div className="px-4 py-3">
              <div className="font-semibold mb-1">No Pre-Trade Checklist</div>
              <div className="text-sm">
                We couldn’t find a checklist for <span className="font-medium">{ptcNotFound.pretty}</span>.
              </div>
              <div className="mt-3 flex justify-end gap-2">
                <button
                  type="button"
                  className="px-3 py-1 rounded-md bg-blue-600 text-white hover:bg-blue-700"
                  onClick={() => setPTCNotFound(null)}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        )}

  <ImportConnectModal
    open={importOpen}
    onClose={() => {
      setImportOpen(false);
      // Clear all modal state on close
      setTlMsg("");
      //setWbMsg("");
    }}
    userId={userId}
    accountId={accountId}
    type={accountType}
    settings={settings}
    setRows={setRows} // Pass the setRows function

    // Pass TradeLocker state
    tlEnv={tlEnv}
    setTlEnv={setTlEnv}
    tlServer={tlServer}
    setTlServer={setTlServer}
    tlEmail={tlEmail}
    setTlEmail={setTlEmail}
    tlPass={tlPass}
    setTlPass={setTlPass}
    tlEnabled={tlEnabled}
    setTlEnabled={setTlEnabled}
    tlBusy={tlBusy}
    setTlBusy={setTlBusy}
    tlMsg={tlMsg}
    setTlMsg={setTlMsg}
    tvEnv={tvEnv} setTvEnv={setTvEnv}
    tvUsername={tvUsername} setTvUsername={setTvUsername}
    tvPassword={tvPassword} setTvPassword={setTvPassword}
    tvDeviceId={tvDeviceId} setTvDeviceId={setTvDeviceId}
    tvCid={tvCid} setTvCid={setTvCid}
    tvSecret={tvSecret} setTvSecret={setTvSecret}
    tvEnabled={tvEnabled} setTvEnabled={setTvEnabled}
    tvBusy={tvBusy} setTvBusy={setTvBusy}
    tvMsg={tvMsg} setTvMsg={setTvMsg}

    // Pass Webull state
    //wbAppKey={wbAppKey}
    //setWbAppKey={setWbAppKey}
    //wbAppSecret={wbAppSecret}
    //setWbAppSecret={setWbAppSecret}
    //wbBusy={wbBusy}
    //setWbBusy={setWbBusy}
    //wbMsg={wbMsg}
    //setWbMsg={setWbMsg}
      isAdmin={isAdmin}
  />





        </div>


    );
}